// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[0].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[0].use[2]!../node_modules/@angular/material/prebuilt-themes/indigo-pink.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* COLOR VARIABLES */
/* PATH */
/* colors */
/* Variables */
/* Breakpoint Vars */
@font-face {
  font-family: "Tele-GroteskUlt";
  src: url("/assets/tfb-acctmgmt/fonts/TeleGroteskUltra.eot") format("eot"), url("/assets/tfb-acctmgmt/fonts/TeleGroteskUltra.woff") format("woff"), url("/assets/tfb-acctmgmt/fonts/TeleGroteskUltra.ttf") format("truetype");
}
@font-face {
  font-family: "Tele-Grotesk-Fett";
  src: url("/assets/tfb-acctmgmt/fonts/tele-groteskfet.eot") format("eot"), url("/assets/tfb-acctmgmt/fonts/tele-groteskfet.svg") format("svg"), url("/assets/tfb-acctmgmt/fonts/tele-groteskfet.ttf") format("truetype"), url("/assets/tfb-acctmgmt/fonts/tele-groteskfet.woff") format("woff"), url("/assets/tfb-acctmgmt/fonts/tele-groteskfet.woff2") format("woff");
}
@font-face {
  font-family: "ArialMT";
  src: url("/assets/tfb-acctmgmt/fonts/arialmt.eot") format("eot"), url("/assets/tfb-acctmgmt/fonts/ArialMT.ttf") format("truetype"), url("/assets/tfb-acctmgmt/fonts/ArialMT.woff") format("woff"), url("/assets/tfb-acctmgmt/fonts/arialmt.woff2") format("woff");
}
@font-face {
  font-family: "Tele-Grotesk-Ultr";
  src: url("/assets/tfb-acctmgmt/fonts/TeleGroteskUltra.eot") format("eot"), url("/assets/tfb-acctmgmt/fonts/TeleGroteskUltra.woff") format("woff"), url("/assets/tfb-acctmgmt/fonts/TeleGroteskUltra.ttf") format("truetype");
}
@font-face {
  font-family: "Tele-GroteskHal";
  src: url("/assets/tfb-acctmgmt/fonts/telegrotesk-halbfett.eot") format("eot"), url("/assets/tfb-acctmgmt/fonts//telegrotesk-halbfett.woff") format("woff"), url("/assets/tfb-acctmgmt/fonts/telegrotesk-halbfett.ttf") format("truetype");
}
@font-face {
  font-family: "Tele-Grotesk-Halb";
  src: url("/assets/tfb-acctmgmt/fonts/tele-groteskhal.eot") format("eot"), url("/assets/tfb-acctmgmt/fonts/tele-groteskhal.svg") format("svg"), url("/assets/tfb-acctmgmt/fonts/tele-groteskhal.ttf") format("truetype"), url("/assets/tfb-acctmgmt/fonts/tele-groteskhal.woff") format("woff"), url("/assets/tfb-acctmgmt/fonts/tele-groteskhal.woff2") format("woff");
}
@font-face {
  font-family: "TeleNeo";
  src: url("/assets/tfb-acctmgmt/fonts/TeleNeo-Thin.otf") format("opentype"), url("/assets/tfb-acctmgmt/fonts/TeleNeo-Thin.ttf") format("truetype");
  font-weight: 100;
  font-style: normal;
}
@font-face {
  font-family: "TeleNeo";
  src: url("/assets/tfb-acctmgmt/fonts/TeleNeo-ThinItalic.otf") format("opentype"), url("/assets/tfb-acctmgmt/fonts/TeleNeo-ThinItalic.ttf") format("truetype");
  font-weight: 100;
  font-style: italic;
}
@font-face {
  font-family: "TeleNeo";
  src: url("/assets/tfb-acctmgmt/fonts/TeleNeo-Regular.otf") format("opentype"), url("/assets/tfb-acctmgmt/fonts/TeleNeo-Regular.ttf") format("truetype");
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: "TeleNeo";
  src: url("/assets/tfb-acctmgmt/fonts/TeleNeo-RegularItalic.otf") format("opentype"), url("/assets/tfb-acctmgmt/fonts/TeleNeo-RegularItalic.ttf") format("truetype");
  font-weight: 400;
  font-style: italic;
}
@font-face {
  font-family: "TeleNeo";
  src: url("/assets/tfb-acctmgmt/fonts/TeleNeo-Medium.otf") format("opentype"), url("/assets/tfb-acctmgmt/fonts/TeleNeo-Medium.ttf") format("truetype");
  font-weight: 500;
  font-style: normal;
}
@font-face {
  font-family: "TeleNeo";
  src: url("/assets/tfb-acctmgmt/fonts/TeleNeo-MediumItalic.otf") format("opentype"), url("/assets/tfb-acctmgmt/fonts/TeleNeo-MediumItalic.ttf") format("truetype");
  font-weight: 500;
  font-style: italic;
}
@font-face {
  font-family: "TeleNeo";
  src: url("/assets/tfb-acctmgmt/fonts/TeleNeo-Bold.otf") format("opentype"), url("/assets/tfb-acctmgmt/fonts/TeleNeo-Bold.ttf") format("truetype");
  font-weight: 700;
  font-style: normal;
}
@font-face {
  font-family: "TeleNeo";
  src: url("/assets/tfb-acctmgmt/fonts/TeleNeo-BoldItalic.otf") format("opentype"), url("/assets/tfb-acctmgmt/fonts/TeleNeo-BoldItalic.ttf") format("truetype");
  font-weight: 700;
  font-style: italic;
}
@font-face {
  font-family: "TeleNeo";
  src: url("/assets/tfb-acctmgmt/fonts/TeleNeo-ExtraBold.otf") format("opentype"), url("/assets/tfb-acctmgmt/fonts/TeleNeo-ExtraBold.ttf") format("truetype");
  font-weight: 900;
  font-style: normal;
}
@font-face {
  font-family: "TeleNeo";
  src: url("/assets/tfb-acctmgmt/fonts/TeleNeo-ExtraBoldItalic.otf") format("opentype"), url("/assets/tfb-acctmgmt/fonts/TeleNeo-ExtraBoldItalic.ttf") format("truetype");
  font-weight: 900;
  font-style: italic;
}
.font-tele-hal {
  font-family: Tele-GroteskHal, sans-serif;
}

.mat-mdc-tab-group, .mat-mdc-tab-nav-bar {
  --mdc-tab-indicator-active-indicator-color: #e20074;
  --mat-tab-header-active-label-text-color:#000;
  --mat-tab-header-active-hover-label-text-color:#fff;
  --mat-tab-header-active-hover-indicator-color:var(--mdc-tab-indicator-active-indicator-color);
  --mat-tab-header-inactive-hover-label-text-color:var(--mat-tab-header-active-hover-label-text-color);
  --mat-tab-header-active-focus-label-text-color:var(--mdc-tab-indicator-active-indicator-color);
  --mat-tab-header-active-focus-indicator-color:var(--mat-tab-header-active-label-text-color)
  --mat-tab-header-active-ripple-color:var(--mdc-tab-indicator-active-indicator-color);
  --mat-select-focused-arrow-color:var(--mdc-tab-indicator-active-indicator-color);
}

.acctmgmt {
  /* IMPORTING COMMON SASS FILES */
  /* COLOR VARIABLES */
  /* PATH */
  /* colors */
  /* Variables */
  /* Breakpoint Vars */
  /*
  *
  * Skeleton Loading
  *
  */
  /* TODO(mdc-migration): The following rule targets internal classes of tabs that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of tabs that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of tabs that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of button that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of tabs that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of tabs that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of tabs that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of option that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of checkbox that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of checkbox that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of option that may no longer apply for the MDC version.*/
  @import "@angular/material/prebuilt-themes/indigo-pink.css";
  /* RESET */
  /* FOOTER */
  /*------------------- RESET CLASSES/Tags ----------------*/
  /* LAYOUT */
  /*----- INPUTS BUTTONS ------*/
  /*----- FLOATING LABEL ------*/
  /** z-index level**/
  /** Custom Drop Down start **/
  /** Custom Drop Down end **/
  /*TODO(mdc-migration): The following rule targets internal classes of card that may no longer apply for the MDC version.*/
  /*------------Manage Modal Pop Up-------------*/
  /* COLOR VARIABLES */
  /* PATH */
  /* colors */
  /* Variables */
  /* Breakpoint Vars */
  /* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version.*/
  /** modal start**/
  /** modal end**/
  /** modal show top start **/
  /** modal show top end **/
  /* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/
  /* COLOR VARIABLES */
  /* PATH */
  /* colors */
  /* Variables */
  /* Breakpoint Vars */
  /* no padding */
  /* Padding all */
  /* Padding left */
  /* Padding right */
  /* Padding top */
  /* padding bottom */
  /* Margin all */
  /* COLOR VARIABLES */
  /* PATH */
  /* colors */
  /* Variables */
  /* Breakpoint Vars */
  /* LOADER */
}
@font-face {
  font-family: "Tele-GroteskUlt";
  src: url("/assets/tfb-acctmgmt/fonts/TeleGroteskUltra.eot") format("eot"), url("/assets/tfb-acctmgmt/fonts/TeleGroteskUltra.woff") format("woff"), url("/assets/tfb-acctmgmt/fonts/TeleGroteskUltra.ttf") format("truetype");
}
@font-face {
  font-family: "Tele-Grotesk-Fett";
  src: url("/assets/tfb-acctmgmt/fonts/tele-groteskfet.eot") format("eot"), url("/assets/tfb-acctmgmt/fonts/tele-groteskfet.svg") format("svg"), url("/assets/tfb-acctmgmt/fonts/tele-groteskfet.ttf") format("truetype"), url("/assets/tfb-acctmgmt/fonts/tele-groteskfet.woff") format("woff"), url("/assets/tfb-acctmgmt/fonts/tele-groteskfet.woff2") format("woff");
}
@font-face {
  font-family: "ArialMT";
  src: url("/assets/tfb-acctmgmt/fonts/arialmt.eot") format("eot"), url("/assets/tfb-acctmgmt/fonts/ArialMT.ttf") format("truetype"), url("/assets/tfb-acctmgmt/fonts/ArialMT.woff") format("woff"), url("/assets/tfb-acctmgmt/fonts/arialmt.woff2") format("woff");
}
@font-face {
  font-family: "Tele-Grotesk-Ultr";
  src: url("/assets/tfb-acctmgmt/fonts/TeleGroteskUltra.eot") format("eot"), url("/assets/tfb-acctmgmt/fonts/TeleGroteskUltra.woff") format("woff"), url("/assets/tfb-acctmgmt/fonts/TeleGroteskUltra.ttf") format("truetype");
}
@font-face {
  font-family: "Tele-GroteskHal";
  src: url("/assets/tfb-acctmgmt/fonts/telegrotesk-halbfett.eot") format("eot"), url("/assets/tfb-acctmgmt/fonts//telegrotesk-halbfett.woff") format("woff"), url("/assets/tfb-acctmgmt/fonts/telegrotesk-halbfett.ttf") format("truetype");
}
@font-face {
  font-family: "Tele-Grotesk-Halb";
  src: url("/assets/tfb-acctmgmt/fonts/tele-groteskhal.eot") format("eot"), url("/assets/tfb-acctmgmt/fonts/tele-groteskhal.svg") format("svg"), url("/assets/tfb-acctmgmt/fonts/tele-groteskhal.ttf") format("truetype"), url("/assets/tfb-acctmgmt/fonts/tele-groteskhal.woff") format("woff"), url("/assets/tfb-acctmgmt/fonts/tele-groteskhal.woff2") format("woff");
}
@font-face {
  font-family: "TeleNeo";
  src: url("/assets/tfb-acctmgmt/fonts/TeleNeo-Thin.otf") format("opentype"), url("/assets/tfb-acctmgmt/fonts/TeleNeo-Thin.ttf") format("truetype");
  font-weight: 100;
  font-style: normal;
}
@font-face {
  font-family: "TeleNeo";
  src: url("/assets/tfb-acctmgmt/fonts/TeleNeo-ThinItalic.otf") format("opentype"), url("/assets/tfb-acctmgmt/fonts/TeleNeo-ThinItalic.ttf") format("truetype");
  font-weight: 100;
  font-style: italic;
}
@font-face {
  font-family: "TeleNeo";
  src: url("/assets/tfb-acctmgmt/fonts/TeleNeo-Regular.otf") format("opentype"), url("/assets/tfb-acctmgmt/fonts/TeleNeo-Regular.ttf") format("truetype");
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: "TeleNeo";
  src: url("/assets/tfb-acctmgmt/fonts/TeleNeo-RegularItalic.otf") format("opentype"), url("/assets/tfb-acctmgmt/fonts/TeleNeo-RegularItalic.ttf") format("truetype");
  font-weight: 400;
  font-style: italic;
}
@font-face {
  font-family: "TeleNeo";
  src: url("/assets/tfb-acctmgmt/fonts/TeleNeo-Medium.otf") format("opentype"), url("/assets/tfb-acctmgmt/fonts/TeleNeo-Medium.ttf") format("truetype");
  font-weight: 500;
  font-style: normal;
}
@font-face {
  font-family: "TeleNeo";
  src: url("/assets/tfb-acctmgmt/fonts/TeleNeo-MediumItalic.otf") format("opentype"), url("/assets/tfb-acctmgmt/fonts/TeleNeo-MediumItalic.ttf") format("truetype");
  font-weight: 500;
  font-style: italic;
}
@font-face {
  font-family: "TeleNeo";
  src: url("/assets/tfb-acctmgmt/fonts/TeleNeo-Bold.otf") format("opentype"), url("/assets/tfb-acctmgmt/fonts/TeleNeo-Bold.ttf") format("truetype");
  font-weight: 700;
  font-style: normal;
}
@font-face {
  font-family: "TeleNeo";
  src: url("/assets/tfb-acctmgmt/fonts/TeleNeo-BoldItalic.otf") format("opentype"), url("/assets/tfb-acctmgmt/fonts/TeleNeo-BoldItalic.ttf") format("truetype");
  font-weight: 700;
  font-style: italic;
}
@font-face {
  font-family: "TeleNeo";
  src: url("/assets/tfb-acctmgmt/fonts/TeleNeo-ExtraBold.otf") format("opentype"), url("/assets/tfb-acctmgmt/fonts/TeleNeo-ExtraBold.ttf") format("truetype");
  font-weight: 900;
  font-style: normal;
}
@font-face {
  font-family: "TeleNeo";
  src: url("/assets/tfb-acctmgmt/fonts/TeleNeo-ExtraBoldItalic.otf") format("opentype"), url("/assets/tfb-acctmgmt/fonts/TeleNeo-ExtraBoldItalic.ttf") format("truetype");
  font-weight: 900;
  font-style: italic;
}
.acctmgmt .font-tele-hal {
  font-family: Tele-GroteskHal, sans-serif;
}
@keyframes zoomIn {
  from {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  50% {
    opacity: 1;
  }
}
@keyframes zoomOut {
  from {
    opacity: 1;
  }
  50% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  to {
    opacity: 0;
  }
}
.acctmgmt .mat-mdc-fab.mat-primary,
.acctmgmt .mat-mdc-unelevated-button.mat-primary,
.acctmgmt .mat-mdc-mini-fab.mat-primary,
.acctmgmt .mat-mdc-raised-button.mat-primary {
  background-color: base-color;
}
.acctmgmt .mat-icon {
  color: #a5a0a0;
}
.acctmgmt .mat-tab-label {
  /* TODO(mdc-migration): The following rule targets internal classes of tabs that may no longer apply for the MDC version.*/
}
.acctmgmt .mat-tab-label.mat-tab-label-active {
  color: #E20074;
  font-weight: bold;
}
.acctmgmt .mat-mdc-tab-group.mat-primary .mat-ink-bar, .acctmgmt .mat-mdc-tab-nav-bar.mat-primary .mat-ink-bar {
  background-color: #E20074;
}
.acctmgmt .mat-tab-body-content {
  padding: 1rem;
}
.acctmgmt .mat-button-toggle-checked {
  background-color: #e20074;
  color: #fff;
}
.acctmgmt .mat-mdc-select-panel .mat-mdc-option.mat-selected:not(.mat-mdc-option-multiple) {
  background: #e20074 !important;
  color: #fff !important;
}
.acctmgmt .mat-mdc-fab.mat-primary, .acctmgmt .mat-mdc-unelevated-button.mat-primary, .acctmgmt .mat-mdc-mini-fab.mat-primary, .acctmgmt .mat-mdc-raised-button.mat-primary {
  background-color: #ff4081;
}
.acctmgmt .mat-mdc-fab.mat-basic, .acctmgmt .mat-mdc-unelevated-button.mat-basic, .acctmgmt .mat-mdc-mini-fab.mat-basic, .acctmgmt .mat-mdc-raised-button.mat-basic {
  background-color: #bfbfbf;
}
.acctmgmt .mat-mdc-progress-spinner {
  display: block;
  position: absolute;
  top: 40%;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}
.acctmgmt .mat-mdc-progress-spinner circle, .acctmgmt .mat-mdc-progress-spinner circle {
  stroke: #ff4081;
}
.acctmgmt mat-tab-group.filter {
  box-shadow: none;
  /* TODO(mdc-migration): The following rule targets internal classes of tabs that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of tabs that may no longer apply for the MDC version.*/
}
.acctmgmt mat-tab-group.filter .mat-tab-body-content {
  margin: 0 -15px;
}
.acctmgmt mat-tab-group.filter .mat-tab-label.mat-tab-label-active {
  background-color: #e20074;
  color: #fff;
  opacity: 1;
}
.acctmgmt mat-tab-group.filter .mat-mdc-tab-header {
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
  border-bottom: none;
}
.acctmgmt .mat-mdc-tab-group.mat-primary .mat-tab-label:not(.mat-tab-disabled):focus {
  background-color: #e20074;
  color: #fff;
}
.acctmgmt .mat-form-field-infix {
  width: auto !important;
  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/
}
.acctmgmt .mat-form-field-infix .mat-mdc-select {
  font-family: Tele-GroteskHal;
  /* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version.*/
}
.acctmgmt .mat-form-field-infix .mat-mdc-select .mat-select-value-text {
  font-family: Tele-GroteskHal;
  font-size: 1rem;
  color: #000000 !important;
  letter-spacing: 0.5px;
  line-height: 1rem;
  padding-right: 15px;
}
.acctmgmt .mat-form-field-infix .mat-mdc-select .mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label {
  display: none !important;
}
.acctmgmt .mat-form-field-infix .mat-mdc-select .mat-select-arrow-wrapper {
  padding-left: 5px;
  /* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version.*/
}
.acctmgmt .mat-form-field-infix .mat-mdc-select .mat-select-arrow-wrapper .mat-mdc-select-arrow {
  background: url("/assets/tfb-acctmgmt/images/icons/arrow-down.png");
  background-repeat: no-repeat;
  background-size: 16px auto;
  margin: 0;
  width: 100%;
  background-position: center center;
  border: none;
  padding: 8px;
}
.acctmgmt .mat-form-field-infix .mat-mdc-select .mat-select-value {
  max-width: 100%;
}
.acctmgmt .mat-form-field-infix .mat-form-field-label-wrapper .mat-form-field-label {
  font-family: Tele-GroteskHal;
  font-size: 1rem;
  font-weight: normal;
  letter-spacing: normal;
  color: #000000;
  line-height: 1;
  width: auto;
}
.acctmgmt .mat-form-field-infix:hover {
  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version.*/
}
.acctmgmt .mat-form-field-infix:hover ::ng-deep .mat-form-field-label-wrapper .mat-form-field-label {
  font-family: Tele-GroteskHal;
  font-size: 1rem;
  font-weight: normal;
  letter-spacing: normal;
  color: #E20074;
  line-height: 1;
}
.acctmgmt .mat-form-field-infix:hover ::ng-deep .mat-select-arrow-wrapper .mat-select-arrow {
  color: #e20074;
  background: url("/assets/tfb-acctmgmt/images/icons/pinkArrowDown.png");
  background-repeat: no-repeat;
  background-size: 16px;
  padding: 8px;
}
.acctmgmt .mat-primary .mat-mdc-option.mat-selected:not(.mat-option-disabled) {
  color: inherit;
}
.acctmgmt .mat-primary .mat-mdc-option.mat-selected:not(.mat-option-disabled) ::ng-deep .mat-pseudo-checkbox-checked, .acctmgmt .mat-primary .mat-mdc-option.mat-selected:not(.mat-option-disabled) .mat-pseudo-checkbox-indeterminate {
  background: #E20074;
}
.acctmgmt .mat-select-content .mat-mdc-option:hover ::ng-deep .mat-pseudo-checkbox {
  color: #E20074;
}
.acctmgmt ::ng-deep .mat-form-field-hide-placeholder .mat-select-placeholder {
  padding-right: 15px;
}
@media screen and (max-width: 767px) {
  .acctmgmt ::ng-deep .mat-form-field-hide-placeholder .mat-select-placeholder {
    font-size: 14px !important;
  }
}
.acctmgmt .mat-expansion-panel:last-child {
  box-shadow: none;
}
.acctmgmt .mat-checkbox-frame {
  border-color: #9b9b9b;
}
.acctmgmt ::ng-deep .mat-checkbox-inner-container {
  margin-right: 25px;
}
.acctmgmt .mat-mdc-select-panel .mat-mdc-optgroup-label, .acctmgmt .mat-select-panel .mat-mdc-option {
  font-size: 14px !important;
}
.acctmgmt .mat-mdc-option.mat-active, .acctmgmt .mat-option.mat-active:hover {
  background: #e20074;
  color: #fff;
}
.acctmgmt .mat-mdc-option.mat-option-disabled {
  font-weight: bold;
}
.acctmgmt .mat-mdc-form-field-infix {
  width: 100% !important;
  padding-top: 0;
  padding-bottom: 0;
  min-height: auto;
}
.acctmgmt .mdc-text-field--filled .mdc-line-ripple::before {
  border-bottom-width: 1px;
  color: rgba(0, 0, 0, 0.15);
}
.acctmgmt .mat-mdc-text-field-wrapper {
  padding-left: 0;
  padding-right: 0;
  padding-top: 12px;
}
.acctmgmt .mat-mdc-form-field-infix {
  display: flex;
}
.acctmgmt .mdc-line-ripple--active {
  color: #e20074;
}
.acctmgmt .mat-mdc-tab-link-container, .acctmgmt .mat-mdc-tab-label-container {
  height: 56px;
  border-bottom-color: rgba(0, 0, 0, 0.23);
  border-bottom-width: 1px;
}
.acctmgmt .mat-mdc-tab-links {
  height: 55px;
  align-items: center;
}
.acctmgmt .mdc-tab-indicator--active .mdc-tab-indicator__content--underline {
  color: #e20074;
}
.acctmgmt .mdc-checkbox .mdc-checkbox__native-control:enabled:not(:checked):not(:indeterminate):not([data-indeterminate=true]) ~ .mdc-checkbox__background {
  border-color: #9b9b9b;
}
.acctmgmt .mat-pseudo-checkbox-full.mat-pseudo-checkbox-checked, .acctmgmt .mat-pseudo-checkbox-full.mat-pseudo-checkbox-indeterminate,
.acctmgmt .mdc-checkbox:not(:disabled):active .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background, .acctmgmt .mdc-checkbox .mdc-checkbox__native-control:enabled:focus:checked ~ .mdc-checkbox__background,
.acctmgmt .mdc-checkbox:not(:disabled):active .mdc-checkbox__native-control:enabled:not(:checked):not(:indeterminate):not([data-indeterminate=true]) ~ .mdc-checkbox__background,
.acctmgmt .mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background, .acctmgmt .mdc-checkbox .mdc-checkbox__native-control:enabled:indeterminate ~ .mdc-checkbox__background, .acctmgmt .mdc-checkbox .mdc-checkbox__native-control[data-indeterminate=true]:enabled ~ .mdc-checkbox__background {
  border-color: #e20074;
  background-color: #e20074;
}
.acctmgmt .mdc-checkbox .mdc-checkbox__native-control:enabled ~ .mdc-checkbox__background .mdc-checkbox__checkmark {
  color: #fff;
}
.acctmgmt .mdc-list-item__primary-text {
  font-family: Roboto, "Helvetica Neue", sans-serif;
  font-size: 14px !important;
}
.acctmgmt .mat-pseudo-checkbox {
  width: 16px;
  height: 16px;
  border: 2px solid;
  border-radius: 2px;
  cursor: pointer;
  display: inline-block;
  vertical-align: middle;
  box-sizing: border-box;
  position: relative;
  flex-shrink: 0;
  transition: border-color 90ms cubic-bezier(0, 0, 0.2, 0.1), background-color 90ms cubic-bezier(0, 0, 0.2, 0.1);
}
.acctmgmt .mat-mdc-option .mat-pseudo-checkbox-full {
  margin-right: 10px;
}
.acctmgmt .mdc-checkbox__background {
  width: 16px;
  height: 16px;
}
.acctmgmt .mdc-checkbox .mdc-checkbox__native-control[disabled]:not(:checked):not(:indeterminate):not([data-indeterminate=true]) ~ .mdc-checkbox__background {
  border-color: rgba(128, 128, 128, 0.34);
  background-color: rgba(128, 128, 128, 0.34);
}
.acctmgmt .mat-pseudo-checkbox-full.mat-pseudo-checkbox-checked::after, .acctmgmt .mat-pseudo-checkbox-full.mat-pseudo-checkbox-indeterminate::after {
  color: #fff;
}
.acctmgmt .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-text-field__input {
  color: rgba(0, 0, 0, 0.7);
  font-size: 14px;
}
.acctmgmt .mat-divider {
  border-top-width: 1px;
  border-top-color: rgba(0, 0, 0, 0.12);
}
.acctmgmt .mat-mdc-option .mat-pseudo-checkbox-minimal {
  display: none;
}
.acctmgmt .mat-mdc-card-outlined {
  border-color: rgba(0, 0, 0, 0.12);
}
.acctmgmt .mat-mdc-card {
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  border: none;
}
.acctmgmt .mat-form-field-appearance-fill .mat-mdc-select-arrow-wrapper {
  transform: none;
}
.acctmgmt .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-floating-label {
  top: 12px;
}
.acctmgmt .mdc-text-field--filled .mdc-floating-label--float-above {
  transform: translateY(-120%) scale(0.75);
}
.acctmgmt .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-floating-label {
  color: rgba(0, 0, 0, 0.7);
}
.acctmgmt .mdc-text-field--filled .mdc-floating-label {
  font-size: 14px;
}
.acctmgmt .mat-mdc-tab-header.mat-mdc-tab-nav-bar-stretch-tabs .mat-mdc-tab-link {
  height: 100%;
  flex-grow: initial;
}
.acctmgmt .mat-mdc-option:hover:not(.mdc-list-item--disabled) {
  background-color: rgba(0, 0, 0, 0.04);
}
.acctmgmt .mdc-linear-progress__bar-inner {
  display: none;
}
.acctmgmt .mdc-linear-progress__bar, .acctmgmt .mdc-linear-progress__buffer {
  background: #e4e8eb;
  border-radius: 5px;
}
.acctmgmt .mdc-form-field > label {
  margin-bottom: 0;
}
.acctmgmt .mdc-text-field--filled:not(.mdc-text-field--disabled), .acctmgmt .mat-mdc-form-field.mat-focused .mat-mdc-form-field-focus-overlay, .acctmgmt .mat-mdc-text-field-wrapper:hover .mat-mdc-form-field-focus-overlay {
  background-color: #fff;
}
.acctmgmt .mdc-text-field--no-label .mat-mdc-form-field-infix {
  padding-top: 0;
  padding-bottom: 0;
}
.acctmgmt .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::after {
  border-bottom-color: #e20074;
}
.acctmgmt .mdc-text-field--filled:not(.mdc-text-field--disabled).mdc-text-field--focused .mdc-floating-label, .acctmgmt .mdc-text-field--filled:not(.mdc-text-field--disabled).mdc-text-field--focused .mdc-floating-label--float-above {
  color: rgba(0, 0, 0, 0.72);
}
.acctmgmt .mat-mdc-tab-link .mdc-tab-indicator__content--underline {
  border-top-width: 4px;
}
.acctmgmt .mdc-linear-progress__buffer {
  height: 16px;
}
.acctmgmt .mat-mdc-select-arrow svg {
  display: none !important;
}
.acctmgmt .mat-mdc-select-arrow {
  background: url("/assets/tfb-acctmgmt/images/icons/arrow-down.png");
  background-repeat: no-repeat;
  background-size: 16px auto;
  margin: 0;
  width: 100%;
  background-position: center center;
  border: none;
  padding: 8px;
}
.acctmgmt .mat-checkbox-frame {
  top: -3px;
}
.acctmgmt .mdc-linear-progress__buffer-bar {
  background-color: #e4e8eb;
}
.acctmgmt .mat-mdc-option.mat-mdc-option-active.mdc-list-item {
  background-color: #e20074 !important;
  color: #fff;
}
.acctmgmt .mat-mdc-option.mat-mdc-option-active.mdc-list-item .mdc-list-item__primary-text {
  color: #fff;
}
.acctmgmt .mat-mdc-select {
  padding-bottom: 4px;
}
.acctmgmt .mdc-checkbox .mdc-checkbox__native-control:focus:checked ~ .mdc-checkbox__ripple {
  background-color: #fff;
}
.acctmgmt .mdc-checkbox .mdc-checkbox__native-control:focus ~ .mdc-checkbox__ripple {
  background-color: #fff;
}
.acctmgmt a {
  color: #ff168e;
  font-size: 0.9rem;
  font-weight: 500;
}
.acctmgmt .text-warning {
  color: #e8200d !important;
}
.acctmgmt .footer {
  background: #000;
  padding: 15px 0;
  margin-top: 2rem;
}
.acctmgmt .no-ul {
  padding: 0;
}
.acctmgmt .no-ul li {
  list-style-type: none;
}
.acctmgmt .data-table .data-head {
  margin-bottom: 10px;
  border-bottom: 2px solid #f2f2f2;
  padding-bottom: 10px;
}
.acctmgmt .data-table .data-head .data-heading {
  font-size: 1rem;
  text-transform: uppercase;
  color: #8a8a8a;
}
.acctmgmt .data-table .data-body .each-item {
  border-bottom: 2px solid #f2f2f2;
  margin-bottom: 15px;
}
.acctmgmt .data-table .data-body .acessory-row {
  margin-bottom: 20px;
}
.acctmgmt .data-table label {
  margin: 0;
}
.acctmgmt .data-table .item-img {
  width: 65px;
  text-align: center;
}
.acctmgmt .parent-loader {
  position: relative;
}
.acctmgmt .overlay-loader {
  background: rgba(185, 176, 176, 0.3803921569);
  position: absolute;
  width: 100%;
  height: 100%;
}
.acctmgmt .overlay-loader .img-loader {
  max-width: 150px;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}
.acctmgmt .btn {
  cursor: pointer;
  padding: 0.7rem 3rem;
  border-radius: unset;
  font-weight: 600;
}
.acctmgmt .btn-link-lg {
  font-weight: 800;
  font-size: 1rem;
}
.acctmgmt .btn-link-lg:hover {
  text-decoration: none;
  color: #af005a;
}
.acctmgmt .btn-link {
  color: #E20074 !important;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
}
.acctmgmt .btn-link-bold {
  font-weight: bold !important;
}
.acctmgmt .btn-underline {
  text-decoration: underline;
}
.acctmgmt .btn-small {
  font-size: 12px;
}
.acctmgmt .btn-outline-primary {
  color: #000;
  border-color: #000;
}
.acctmgmt .btn-outline-primary.active, .acctmgmt .btn-outline-primary:active, .show > .acctmgmt .btn-outline-primary.dropdown-toggle, .acctmgmt .btn-outline-primary:hover {
  color: #fff;
  background-color: #E20074;
  border-color: #E20074;
}
.acctmgmt .btn-primary {
  background-color: #E20074;
  color: #fff;
  border-color: #E20074;
  margin: 10px 0;
}
.acctmgmt .btn-primary:hover, .acctmgmt .btn-primary:focus, .acctmgmt .btn-primary:active, .acctmgmt .btn-primary.active, .acctmgmt .btn-primary:active:hover, .acctmgmt .btn-primary.active:hover {
  background-color: #af005a;
  border-color: #af005a;
  border-width: 1px;
  border-style: solid;
}
.acctmgmt .btn-primary[disabled]:hover, .acctmgmt .btn-primary[disabled]:focus, .acctmgmt .btn-primary[disabled].focus, .acctmgmt .btn-primary.disabled:hover, .acctmgmt .btn-primary.disabled:focus, .acctmgmt .btn-primary:disabled, .acctmgmt .btn-primary.disabled {
  background-color: #cccccc;
  border-color: #cccccc;
  color: #000;
}
.acctmgmt .btn-white {
  *display: inline;
  color: #c06;
  text-align: center;
  text-shadow: 0 1px 1px rgba(255, 255, 255, 0.75);
  background-color: #f5f5f5;
  *background-color: #e6e6e6;
  background-image: linear-gradient(to bottom, #fff, #e6e6e6);
  background-repeat: repeat-x;
  border: 1px solid #ccc;
  *border: 0;
  border-color: #e6e6e6 #e6e6e6 #bfbfbf;
  border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);
  border-bottom-color: #b3b3b3;
  border-radius: 4px;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="#ffffffff", endColorstr="#ffe6e6e6", GradientType=0 );
  filter: progid:DXImageTransform.Microsoft.gradient(enabled=false);
  *zoom: 1;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2), 0 1px 2px rgba(0, 0, 0, 0.05);
}
.acctmgmt .btn-white:hover, .acctmgmt .btn-white:focus, .acctmgmt .btn-white:active, .acctmgmt .btn-white.active, .acctmgmt .btn-white:active:hover, .acctmgmt .btn-white.active:hover, .acctmgmt .btn-white[disabled]:hover, .acctmgmt .btn-white[disabled]:focus, .acctmgmt .btn-white[disabled].focus, .acctmgmt .btn-white.disabled:hover, .acctmgmt .btn-white.disabled:focus {
  color: #8c0041;
  background-color: #e6e6e6;
  *background-color: #d9d9d9;
}
.acctmgmt .btn-white:active, .acctmgmt .btn-white.active {
  background-color: #ccc \\9 ;
}
.acctmgmt .btn-white:first-child {
  *margin-left: 0;
}
.acctmgmt .btn-white:hover, .acctmgmt .btn-white:focus {
  color: #8c0041;
  text-decoration: none;
  background-position: 0 -15px;
  transition: background-position 0.1s linear;
}
.acctmgmt .btn-white:focus {
  outline: thin dotted #333;
  outline: 5px auto -webkit-focus-ring-color;
  outline-offset: -2px;
}
.acctmgmt .btn-white.active, .acctmgmt .btn-white:active {
  background-image: none;
  outline: 0;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.15), 0 1px 2px rgba(0, 0, 0, 0.05);
}
.acctmgmt .btn-white.disabled, .acctmgmt .btn-white[disabled] {
  cursor: default;
  background-image: none;
  opacity: 0.65;
  filter: alpha(opacity=65);
  box-shadow: none;
  color: #8c0041;
  background-color: #e6e6e6;
  *background-color: #d9d9d9;
}
.acctmgmt .input-custom {
  border: 0;
  outline: 0;
  border-bottom: 1px solid gray;
  display: block;
}
.acctmgmt .input-large {
  font-weight: 600;
  font-size: 2.5rem;
}
.acctmgmt .input-fluid {
  width: 100%;
}
.acctmgmt .small-ddl .dropdown-menu {
  max-width: 200px;
}
.acctmgmt .ddl-auto-height .dropdown-menu {
  height: auto !important;
}
.acctmgmt .optional_errortext {
  background-image: url('globalicons.png');
  background-repeat: no-repeat;
  padding-right: 16px;
  background-position: right 0 top -118px;
  color: #e8200d !important;
  background-size: 16px;
  width: 100%;
  height: 18px;
}
.acctmgmt .optional_errortext_20 {
  background-size: 20px !important;
  height: 20px !important;
  padding-right: 20px !important;
  background-position: right 0 top -151px !important;
}
.acctmgmt .optional_errortext ~ label {
  color: #e8200d !important;
}
.acctmgmt input.disabled-floatinglabel ~ label {
  transform: translate(-4px, -35px) scale(0.9) !important;
  margin-top: -41px !important;
  font-size: 14px !important;
}
.acctmgmt .question label {
  font-family: Arial;
  line-height: 20px !important;
  letter-spacing: 0.7px !important;
  font-size: 14px !important;
}
.acctmgmt .zindex1 {
  z-index: 1 !important;
}
.acctmgmt .zindex2 {
  z-index: 2 !important;
}
.acctmgmt .zindex3 {
  z-index: 3 !important;
}
.acctmgmt .zindex4 {
  z-index: 4 !important;
}
.acctmgmt .zindex5 {
  z-index: 5 !important;
}
.acctmgmt .position-r {
  position: relative;
}
@media (min-width: 992px) {
  .acctmgmt .mb-80 {
    margin-bottom: 80px !important;
  }
}
@media (max-width: 767px) {
  .acctmgmt .mb-80 {
    margin-bottom: 120px !important;
  }
}
@media (max-width: 476px) {
  .acctmgmt .mb-80 {
    margin-bottom: 190px !important;
  }
}
.acctmgmt .btn-outline-primary:not(:disabled):not(.disabled).active,
.acctmgmt .btn-outline-primary:not(:disabled):not(.disabled):active,
.acctmgmt .show > .btn-outline-primary.dropdown-toggle {
  background: #E20074;
}
.acctmgmt .custom-ddl-wrapper .dropdownBasic2 ~ .dropdown-menu {
  width: 100% !important;
}
.acctmgmt .custom-ddl-wrapper .dropdown-menu {
  height: auto;
  overflow-y: auto;
  overflow-x: hidden;
  border-radius: 0;
  margin: 0;
  padding: 6px;
  top: 0px !important;
  border: 0;
  background: #fff;
  box-shadow: 0px 0px 10px #988d8d;
}
.acctmgmt .custom-ddl-wrapper .dropdown-menu.show .dropdown-item {
  margin-bottom: 2px;
}
.acctmgmt .custom-ddl-wrapper .dropdown-menu.show .dropdown-item .default-item {
  padding: 8px;
}
.acctmgmt .custom-ddl-wrapper .dropdown-menu.show .dropdown-item .active-item {
  background: #e20074;
  color: #fff;
}
.acctmgmt .custom-ddl-wrapper .dropdown-menu.show .dropdown-item strong {
  display: block;
}
.acctmgmt .custom-ddl-wrapper .dropdown-menu.show .dropdown-item:hover {
  background: #e20074;
  color: #fff;
}
.acctmgmt .custom-ddl-wrapper .dropdown-menu .dropdown-item {
  padding: 0;
}
.acctmgmt .custom-ddl-wrapper .custom_floatlabel {
  visibility: hidden;
  min-height: 30px;
  z-index: -1;
}
.acctmgmt .custom-ddl-wrapper .active-ddl .custom_floatlabel {
  color: #6a6a6a;
  font-size: 16px;
  padding: 0;
  padding-bottom: 6px;
  visibility: visible;
}
.acctmgmt .custom-ddl-wrapper span {
  font-weight: normal;
}
.acctmgmt .custom-ddl-wrapper span {
  width: 90%;
  overflow: hidden;
  justify-content: start;
}
@media (max-width: 767px) {
  .acctmgmt .pl-sm-15 {
    padding-left: 0;
  }
}
.acctmgmt .floating-label-hasvalue-date {
  top: -20px !important;
  font-size: 11px !important;
  transition: all 0.3s ease-in-out;
}
.acctmgmt .date_label .datepic_box .datepicker {
  padding-left: 0;
}
.acctmgmt .datepic_box .datepicker {
  width: 100%;
  background-color: transparent;
  border-bottom: 1px solid #ddd;
  border-left: none;
  border-right: 0;
  border-top: 0;
  padding: 7px;
  border-radius: 0;
}
.acctmgmt .datepicker {
  top: 0;
  left: 0;
  padding: 4px;
  margin-top: 1px;
  border-radius: 4px;
}
.acctmgmt .label_box .date_label label {
  color: #8e8e8e;
  font-weight: 100;
  font-size: 15px;
  box-sizing: border-box;
  padding: 12px 0;
  display: block;
  position: absolute;
  pointer-events: none;
  background-color: transparent;
  top: 0;
  z-index: 99;
}
.acctmgmt .fa-calendar-alt {
  font-size: 20px;
  color: #e20074;
  position: absolute;
  right: 0;
  top: 20%;
}
.acctmgmt .box_icon {
  background-repeat: no-repeat;
  background-size: 25px;
  height: 25px;
  width: 25px;
}
.acctmgmt .datepicker:before {
  content: "";
  display: inline-block;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #ccc;
  border-bottom-color: rgba(0, 0, 0, 0.2);
  position: absolute;
  top: -7px;
  left: 6px;
}
.acctmgmt .datepicker:after {
  content: "";
  display: inline-block;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #fff;
  position: absolute;
  top: -6px;
  left: 7px;
}
.acctmgmt .gray-link, .acctmgmt a {
  display: inline-block;
  color: #6a6a6a;
  font-family: Arial;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  vertical-align: middle;
}
.acctmgmt .gray-link:hover, .acctmgmt a:hover {
  color: #6a6a6a;
  text-decoration: none;
}
.acctmgmt .small-text {
  font-family: Arial;
  font-size: 11px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1;
  letter-spacing: 0.3px;
  color: #6a6a6a;
}
.acctmgmt .white-text {
  font-family: Tele-GroteskHal;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: right;
  color: #fff;
}
.acctmgmt .white-text:hover {
  color: #fff;
  text-decoration: underline;
}
.acctmgmt h1 {
  font-family: Tele-Grotesk-Ultr;
  font-size: 4.5rem;
  color: #000000;
  letter-spacing: -1.5px;
  line-height: 64px;
  padding: 30px 0 10px;
}
@media screen and (max-width: 1191px) {
  .acctmgmt h1 {
    font-size: 40px;
    line-height: 50px;
  }
}
.acctmgmt body, .acctmgmt .regular-black {
  font-family: Arial;
  font-size: 1rem;
  color: #000000;
}
.acctmgmt body {
  cursor: default;
}
.acctmgmt .black-fourteen {
  letter-spacing: 0.5px;
  font-family: Arial;
  font-size: 14px;
  font-weight: normal;
  letter-spacing: normal;
  color: #000000;
  line-height: 1;
}
.acctmgmt .grey-sixteen {
  font-family: Arial;
  font-size: 16px;
  font-weight: normal;
  letter-spacing: normal;
  color: #6a6a6a;
  line-height: 24px;
}
.acctmgmt h6, .acctmgmt h4, .acctmgmt h2 {
  letter-spacing: normal;
  margin-top: 10px;
  margin-bottom: 5px;
  max-height: 66px;
  font-family: Tele-Grotesk-Ultr;
  font-size: 22px;
  font-weight: normal;
  letter-spacing: normal;
  color: #000000;
  line-height: 22px;
}
@media screen and (max-width: 767px) {
  .acctmgmt h6 {
    font-size: 24px;
    line-height: 24px;
  }
}
.acctmgmt h2 {
  font-size: 40px;
  line-height: 40px;
}
@media screen and (max-width: 767px) {
  .acctmgmt h2 {
    font-size: 32px;
    line-height: 32px;
  }
}
.acctmgmt h4 {
  font-size: 32px;
  line-height: 32px;
}
@media screen and (max-width: 767px) {
  .acctmgmt h4 {
    font-size: 24px;
    line-height: 24px;
  }
}
.acctmgmt .limited {
  font-family: Tele-GroteskHal;
  font-size: 14px;
  font-weight: normal;
  letter-spacing: normal;
  color: #e8200d;
  line-height: 24px;
  letter-spacing: -0.2px;
  min-height: 24px;
}
@media screen and (max-width: 1191px) {
  .acctmgmt .limited {
    font-size: 16px;
  }
}
.acctmgmt .offer {
  color: #078a14;
  font-family: Tele-GroteskHal;
  font-size: 14px;
  font-weight: normal;
  letter-spacing: normal;
  color: #078a14;
  line-height: 1;
  letter-spacing: -0.2px;
}
@media screen and (max-width: 1191px) {
  .acctmgmt .offer {
    font-size: 16px;
  }
}
.acctmgmt .small-bold-grey {
  text-transform: uppercase;
  font-family: Tele-Grotesk-Ultr;
  font-size: 14px;
  font-weight: normal;
  letter-spacing: normal;
  color: #9b9b9b;
  line-height: 1.5;
}
.acctmgmt .small-normal-black {
  font-family: Tele-GroteskHal;
  font-size: 1rem;
  font-weight: normal;
  letter-spacing: normal;
  color: #000000;
  line-height: 1.5;
}
.acctmgmt .small-bold-black {
  font-family: Tele-Grotesk-Ultr;
  font-size: 1rem;
  font-weight: bold;
  letter-spacing: 0.5px;
  color: #000000;
  line-height: 1.5;
}
.acctmgmt .small-pink {
  font-family: Tele-Grotesk-Fett;
  font-size: 1rem;
  font-weight: bold;
  letter-spacing: 0;
  color: #E20074;
  line-height: 1.5;
}
.acctmgmt .small-pink:hover {
  color: #E20074;
}
.acctmgmt .small-legal-grey {
  font-family: Arial;
  font-size: 10px;
  color: #6a6a6a;
  letter-spacing: 0.5px;
  line-height: 1.2;
}
@media screen and (max-width: 1191px) {
  .acctmgmt .small-legal-grey {
    font-size: 14px;
  }
}
.acctmgmt .device-box {
  padding: 15px 12px;
}
.acctmgmt .device-box a {
  width: 100%;
}
.acctmgmt .device-box .phone-box {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
  background-color: #fff;
  border: solid 1px rgba(0, 0, 0, 0.1);
}
.acctmgmt .device-box .phone-box .phone-wrapper {
  padding: 10px 15px;
  border-bottom: 1px solid #f2f2f2;
}
.acctmgmt .device-box .phone-box .phone-wrapper a {
  text-decoration: none;
  width: 100%;
}
.acctmgmt .device-box .phone-box .phone-wrapper:nth-child(2) {
  border-bottom: none;
}
.acctmgmt .device-box .phone-box .phone-desc .color-variation {
  float: right;
}
.acctmgmt .device-box .phone-box .phone-desc .color-variation a {
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  height: 14px;
  width: 14px;
  margin: 2px;
  font-size: 0;
}
.acctmgmt .device-box .phone-box .phone-desc .color-variation a.red {
  background: #BF1B2C;
}
.acctmgmt .device-box .phone-box .phone-desc .color-variation a.black {
  background: #000000;
}
.acctmgmt .device-box .phone-box .phone-desc .color-variation a.grey {
  background: #fff;
}
.acctmgmt .device-box .phone-box .phone-desc .color-variation a.rose-gold {
  background: #ecd7e2;
}
.acctmgmt .device-box .phone-box .phone-desc .color-variation a.gold {
  background: #e0d1b2;
}
.acctmgmt .device-box .phone-box .img-wrapper {
  text-align: center;
  padding: 15px 30px;
}
.acctmgmt .device-box .phone-box .img-wrapper img {
  height: 150px;
  margin: 0 auto;
}
.acctmgmt .ngx-pagination {
  margin: 1rem 0;
  padding: 0;
  text-align: center;
}
.acctmgmt .ngx-pagination li.current {
  padding: 12px 16px !important;
  font-weight: bold;
  border: 2px solid #e20074;
  background: transparent;
  color: #e20074;
  line-height: 1;
}
.acctmgmt .ngx-pagination li.disabled {
  vertical-align: middle;
  line-height: 1;
  opacity: 0.7;
}
.acctmgmt .ngx-pagination li.disabled span {
  font-size: 0;
}
.acctmgmt .ngx-pagination li.disabled a {
  font-family: Arial;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0.5px;
  color: rgb(139, 55, 55);
  line-height: 1;
}
.acctmgmt .ngx-pagination li.pagination-previous, .acctmgmt .ngx-pagination li.pagination-next {
  vertical-align: middle;
  line-height: 1;
  padding: 0.1875rem 0.625rem;
}
.acctmgmt .ngx-pagination li.pagination-previous:before, .acctmgmt .ngx-pagination li.pagination-next:before {
  display: none;
}
.acctmgmt .ngx-pagination li.pagination-previous.disabled {
  position: relative;
}
.acctmgmt .ngx-pagination li.pagination-previous.disabled:before {
  width: 20px;
  height: 20px;
  display: inline-block;
  content: "<" !important;
  background: none;
  color: #9b9b9b;
  font-size: 21px;
}
.acctmgmt .ngx-pagination li.pagination-previous:before {
  display: none;
}
.acctmgmt .ngx-pagination li.pagination-previous a {
  font-size: 0;
  position: relative;
  height: 40px;
  width: 40px;
  padding: 0;
}
.acctmgmt .ngx-pagination li.pagination-previous a:before {
  width: 20px;
  height: 20px;
  display: inline-block;
  position: absolute;
  top: 8px;
  left: 0;
  right: 0;
  margin: auto;
  content: "<";
  background: none;
  color: #6a6a6a;
  font-size: 21px;
}
.acctmgmt .ngx-pagination li.pagination-previous a:hover {
  background: #f41a8a;
}
.acctmgmt .ngx-pagination li.pagination-previous a:hover:before {
  width: 20px;
  height: 20px;
  display: inline-block;
  position: absolute;
  top: 8px;
  left: 0;
  right: 0;
  margin: auto;
  content: "<" !important;
  background: none;
  color: #fff;
  font-size: 21px;
}
.acctmgmt .ngx-pagination li.pagination-previous a:active {
  background: url("/assets/tfb-acctmgmt/images/icons/activepaginator.png");
}
.acctmgmt .ngx-pagination li.pagination-next.disabled:before {
  width: 20px;
  height: 20px;
  display: inline-block;
  content: ">" !important;
  background: none;
  color: #9b9b9b;
  font-size: 21px;
}
.acctmgmt .ngx-pagination li.pagination-next:after {
  display: none !important;
}
.acctmgmt .ngx-pagination li.pagination-next a {
  font-size: 0;
  position: relative;
  height: 40px;
  width: 40px;
  padding: 0;
}
.acctmgmt .ngx-pagination li.pagination-next a:before {
  width: 20px;
  height: 20px;
  display: inline-block;
  content: ">" !important;
  position: absolute;
  top: 8px;
  left: 0;
  right: 0;
  margin: auto;
  background: none;
  color: #9a9a9a;
  font-size: 21px;
}
.acctmgmt .ngx-pagination li.pagination-next a:hover {
  background: #f41a8a;
}
.acctmgmt .ngx-pagination li.pagination-next a:hover:before {
  width: 20px;
  height: 20px;
  display: inline-block;
  position: absolute;
  top: 8px;
  left: 0;
  right: 0;
  margin: auto;
  content: ">" !important;
  background: none;
  color: #fff;
  font-size: 21px;
}
.acctmgmt .ngx-pagination li.pagination-next a:active {
  background: url("/assets/tfb-acctmgmt/images/icons/activepaginator.png");
}
.acctmgmt .ngx-pagination li a {
  font-family: Arial;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0.5px;
  color: #000000;
  line-height: 1;
}
.acctmgmt .ngx-pagination li a:hover {
  background: transparent;
  text-decoration: none;
  color: #e20074;
}
.acctmgmt .filter-devices {
  padding-right: 40px;
  display: inline-block;
}
.acctmgmt .primary_btn {
  float: none;
  min-width: 150px;
  min-height: 48px;
  display: inline-block;
  background-color: #e20074;
  background-position: center;
  transition: background 0.8s;
  width: auto;
  color: #fff;
  border: none;
  border-radius: 0;
  padding: 12px 35px;
  line-height: 20px;
  font-size: 18px;
  font-family: Tele-Grotesk-Fett;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-decoration: none;
  text-align: center;
  cursor: pointer;
}
.acctmgmt .primary_btn span {
  line-height: 20px;
  font-size: 18px;
  font-family: Tele-Grotesk-Fett;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-decoration: none;
  text-align: center;
}
.acctmgmt .primary_btn:hover {
  box-shadow: 0 8px 8px 0 rgba(0, 0, 0, 0.24), 0 0 8px 0 rgba(0, 0, 0, 0.12);
  background: #f41a8a radial-gradient(circle, transparent 1%, #a10053 1%) center/15000%;
}
.acctmgmt .primary_btn:hover:disabled {
  background-color: #f2f2f2;
  color: #6a6a6a;
}
.acctmgmt .primary_btn:focus {
  background-color: #f41a8a;
  box-shadow: 0 8px 8px 0 rgba(0, 0, 0, 0.24), 0 0 8px 0 rgba(0, 0, 0, 0.12);
  text-decoration: underline;
}
.acctmgmt .primary_btn:active {
  text-decoration: none;
  background-color: #ba0060;
  background-size: 100%;
  transition: background 0s;
  box-shadow: none;
}
.acctmgmt .primary_btn:disabled {
  background-color: #f2f2f2;
  color: #9b9b9b;
  cursor: pointer;
  box-shadow: none;
}
.acctmgmt .primary_btn:disabled:hover {
  background-color: #f2f2f2;
  color: #9b9b9b;
  cursor: pointer;
  box-shadow: none;
}
.acctmgmt .primary_btn:hover[disabled] {
  background-color: #f2f2f2;
  color: #6a6a6a;
}
.acctmgmt .secondary_btn {
  float: none;
  display: inline-block;
  min-width: 150px;
  min-height: 48px;
  background-color: #fff;
  background-position: center;
  transition: background 0.8s;
  color: #000000;
  padding: 12px 35px;
  line-height: 20px;
  font-size: 18px;
  font-family: Tele-Grotesk-Fett;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  border: 1px solid #000000;
  text-decoration: none;
  text-align: center;
}
.acctmgmt .secondary_btn:hover {
  border: 2px solid #4c4c4c;
  color: #4c4c4c;
  background: #ffffff radial-gradient(circle, transparent 1%, #fff 1%) center/15000%;
}
.acctmgmt .secondary_btn:focus {
  border: 2px solid #4c4c4c;
  color: #4c4c4c;
  text-decoration: underline;
}
.acctmgmt .secondary_btn:active {
  border: 2px solid #000;
  text-decoration: none;
  background-color: #e8e8e8;
  background-size: 100%;
  transition: background 0s;
}
.acctmgmt .secondary_btn:disabled {
  border: 1px solid #9b9b9b;
  color: #9b9b9b;
  text-decoration: none;
  background: #fff;
  cursor: pointer;
}
.acctmgmt .arrow-left {
  vertical-align: middle;
  padding-right: 10px;
}
.acctmgmt .arrow-left:before {
  background: url("/assets/tfb-acctmgmt/images/icons/pink-arrow-left.png") no-repeat center center;
  display: inline-block;
  content: "";
  width: 12px;
  height: 12px;
  background-size: 100% auto;
}
.acctmgmt .mat-card-header-text {
  margin: 0 !important;
}
.acctmgmt .caps {
  text-transform: uppercase;
  padding-bottom: 5px;
}
.acctmgmt .paginations {
  width: 100%;
}
.acctmgmt .mega_spinner_box, .acctmgmt .micro_spinner_box {
  position: fixed;
  left: 50%;
  top: 50%;
  align-content: center;
  align-self: center;
  justify-content: center;
  background-color: transparent;
  overflow: hidden;
  z-index: 500000;
}
.acctmgmt .micro_spinner_box {
  margin: -30px 0 0 0;
}
.acctmgmt .megaspinner {
  display: flex;
  align-content: center;
  align-self: center;
  justify-content: center;
  animation: rotate 2s linear infinite;
}
.acctmgmt .megaspinner circle {
  fill: none;
  stroke: #ba0061;
  stroke-dasharray: 125, 155;
  stroke-dashoffset: 0;
  animation: dash 1.35s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
.acctmgmt .microspinner {
  display: flex;
  align-content: center;
  align-self: center;
  justify-content: center;
  animation: rotate 2s linear infinite;
}
.acctmgmt .microspinner circle {
  fill: none;
  stroke: #ba0060;
  stroke-dasharray: 125, 155;
  stroke-dashoffset: 0;
  animation: dash 1.35s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
.acctmgmt .modal_spinner_box {
  position: absolute;
  height: 100%;
  width: 100%;
  display: flex;
  align-content: center;
  align-self: center;
  justify-content: center;
  z-index: 150000;
  background-size: 100%;
  background-color: transparent;
  opacity: 0.8;
  overflow: hidden;
  display: none;
  z-index: 500000;
}
.acctmgmt .modalspinner {
  display: flex;
  align-content: center;
  align-self: center;
  justify-content: center;
  animation: rotate 2s linear infinite;
}
.acctmgmt .modalspinner circle {
  fill: none;
  stroke: #ba0061;
  stroke-dasharray: 125, 155;
  stroke-dashoffset: 0;
  animation: dash 1.35s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
@keyframes dash {
  0% {
    stroke-dasharray: 2, 155;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 122, 20;
    stroke-dashoffset: -20;
  }
  100% {
    stroke-dasharray: 2, 155;
    stroke-dashoffset: -155;
  }
}
@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}
.acctmgmt .cursorPointer {
  cursor: pointer;
}
.acctmgmt .padding15 {
  padding: 0 15px;
}
.acctmgmt .BG-modal {
  width: 100%;
}
.acctmgmt .floatRight {
  float: right;
}
.acctmgmt .text-right {
  text-align: right !important;
}
.acctmgmt .font32 {
  font-size: 32px;
}
.acctmgmt .upgradeSubheader .modal-header {
  border-bottom: 0px;
}
.acctmgmt .upgradeSubheader .modal-footer {
  border-top: 0px;
}
.acctmgmt .upgradeSubheader table thead tr:first-child td {
  border-top: none;
}
.acctmgmt .BG-modal {
  width: 100%;
}
.acctmgmt .borderBtmGrey {
  border-bottom: solid 1px #e8e8e8;
}
.acctmgmt .upgradeSubheader .modal-header {
  display: inline-block;
}
.acctmgmt .upgradeSubheader .modal-content {
  border: 0px;
  border-radius: 0px;
  padding: 10px;
}
.acctmgmt .upgradeLinesContainer {
  background-color: #f8f8f8;
}
.acctmgmt .lineNumber {
  font-family: Arial;
  font-size: 1rem;
  color: #000;
  font-weight: bold;
}
.acctmgmt .lineName {
  font-family: Arial;
  font-size: 1rem;
  color: #4c4c4c;
}
.acctmgmt .lineHeading {
  font-family: Tele-GroteskHal;
  font-size: 0.8rem;
  color: #9b9b9b;
  text-transform: uppercase;
  padding: 15px 0;
  border-top: solid 1px #e8e8e8;
}
.acctmgmt .small-text {
  line-height: 1.5;
}
.acctmgmt .cancelBtnPad {
  padding: 8px 35px;
  width: auto;
  margin-right: 16px;
  border: solid 1px #000000;
  background: white;
}
.acctmgmt .cancelBtnPad:hover {
  border: solid 2px #000000;
  background: white;
  background: inherit;
  border-color: inherit;
  padding: 7px 34px;
}
.acctmgmt .cancelBtnPad span {
  font-family: Tele-Grotesk-Fett;
  font-size: 18px;
  line-height: 1.11;
  text-align: center;
  color: #000000;
  font-weight: normal;
}
.acctmgmt .Oval {
  width: 34px;
  height: 34px;
  border: solid 2px #000000;
  border-radius: 50%;
  padding: 0px 7px;
  margin-left: 30px;
  vertical-align: text-bottom;
  text-align: center;
}
.acctmgmt .greenTick {
  background: url("/assets/tfb-acctmgmt/images/icons/globalicons.png");
  background-repeat: no-repeat;
  padding-right: 16px;
  background-position: 15px -221px;
  color: #e8200d !important;
  background-size: 16px;
  width: 100%;
  height: 18px;
}
.acctmgmt .blackInfo {
  background: url("/assets/tfb-acctmgmt/images/information.png");
  background-repeat: no-repeat;
  padding-right: 16px;
  background-size: 14px;
  width: 100%;
  height: 14px;
  background-position: 15px;
}
.acctmgmt .trade-text {
  margin-top: 10px;
}
.acctmgmt .BG-modal {
  overflow: auto;
}
.acctmgmt .redirect-text, .acctmgmt .Oval {
  display: inline-block;
}
.acctmgmt .optional_errortext {
  background: url("/assets/tfb-acctmgmt/images/icons/globalicons.png");
  background-repeat: no-repeat;
  padding-right: 15px;
  background-position: 15px -118px;
  color: #e8200d !important;
  background-size: 16px;
  width: 100%;
  height: 18px;
  color: #e8200d !important;
  background-size: 16px;
  width: 100%;
  height: 18px;
}
.acctmgmt .zoomIn {
  animation: zoomIn 1s;
}
.acctmgmt .zoomOut {
  animation: zoomOut 1s;
}
.acctmgmt .alert-dialog .mat-mdc-dialog-container {
  overflow: visible;
}
.acctmgmt .plp_useralert {
  float: left;
  width: 100%;
  background-color: #fff;
  height: 48px;
  padding: 18px 0;
  text-align: center;
}
@media screen and (max-width: 991px) {
  .acctmgmt .plp_useralert {
    height: auto;
  }
}
.acctmgmt .plp_useralert .small-legal-grey {
  color: #000;
}
.acctmgmt .plp_useralert .small-legal-grey span {
  text-transform: lowercase;
}
.acctmgmt .plp_useralert.staicplp_useralert {
  position: fixed;
  left: 0;
  bottom: 0;
  transform: translate3d(0px, 0px, 0px);
  z-index: 1;
  /* border-top: 2px solid #E20074; */
}
.acctmgmt .alignItem {
  align-items: center;
}
.acctmgmt .inline-blk {
  display: inline-block;
}
.acctmgmt * {
  outline: none;
}
.acctmgmt .search-line {
  padding: 15px 15px 15px 55px;
  width: 100%;
  border-radius: 4px;
  border-color: transparent;
  margin-bottom: 15px;
  background: #f8f8f8 url("/../assets/tfb-acctmgmt/images/icons/search.png");
  background-size: 19px auto;
  background-repeat: no-repeat;
  background-position: 25px center;
  font-family: Tele-Grotesk-Ultr;
  font-size: 24px;
  line-height: 1;
  color: #000;
  white-space: nowrap;
  text-overflow: ellipsis;
}
@media screen and (max-width: 960px) {
  .acctmgmt .search-line {
    margin-top: 30px;
  }
}
@media screen and (max-width: 767px) {
  .acctmgmt .search-line {
    font-size: 16px;
    background-position: 15px center;
  }
}
.acctmgmt .search-line:-ms-input-placeholder {
  padding: 15px 15px 15px 55px;
}
.acctmgmt .close-search {
  position: absolute;
  right: 30px;
  padding: 15px;
  cursor: pointer;
  color: transparent;
  background: url("/../assets/tfb-acctmgmt/images/icons/close-icon.png") no-repeat center center;
  font-family: Tele-Grotesk-Ultr;
  font-size: 24px;
  line-height: 1;
  border: 4px solid transparent;
}
@media screen and (max-width: 991px) {
  .acctmgmt .close-search {
    font-size: 16px;
  }
}
.acctmgmt .label_box {
  float: left;
  width: 100%;
  position: relative;
}
.acctmgmt .label_box .question {
  position: relative;
  padding: 12px 0;
}
.acctmgmt .label_box .question:first-of-type {
  padding-top: 0;
}
.acctmgmt .label_box .question:last-of-type {
  padding-bottom: 0;
}
.acctmgmt .label_box .question .fa-eye, .acctmgmt .label_box .question .fa-eye-slash {
  color: #6a6a6a;
  position: absolute;
  right: 0px;
  top: 25px;
  z-index: 1;
}
.acctmgmt .label_box .question label {
  color: #8e8e8e;
  font-weight: 100;
  font-size: 16px;
  box-sizing: border-box;
  padding: 12px 0;
  display: block;
  position: absolute;
  margin-top: -40px;
  pointer-events: none;
  background-color: transparent;
}
.acctmgmt .label_box .question input[type=password] {
  appearance: none;
  -webkit-appearance: none;
  background-color: none;
  line-height: 0;
  font-size: 16px;
  width: 100%;
  display: block;
  box-sizing: border-box;
  padding: 12px 0;
  color: #000000;
  position: relative;
  z-index: 1;
  border-bottom: 1px solid #dbdbdb;
  border-top: none;
  border-right: none;
  border-left: none;
  background-color: transparent;
}
.acctmgmt .label_box .question input[type=password]:focus {
  outline: none;
  color: #000000;
  margin-top: 0;
  border-bottom: 1px solid #e20074;
}
.acctmgmt .label_box .question input[type=password]:focus ~ label {
  transform: translate(0, -35px);
  margin-top: -41px;
  font-size: 10px;
}
.acctmgmt .label_box .question input[type=password]:valid {
  margin-top: 0;
  border-bottom: 1px solid #6a6a6a;
}
.acctmgmt .label_box .question input[type=password]:valid ~ label {
  transform: translate(-4px, -35px) scale(0.9);
  margin-top: -41px;
  font-size: 16px;
}
.acctmgmt .label_box .question input[type=text] {
  appearance: none;
  -webkit-appearance: none;
  background-color: none;
  line-height: 0;
  font-size: 16px;
  width: 100%;
  display: block;
  box-sizing: border-box;
  padding: 12px 0;
  color: #000000;
  position: relative;
  z-index: 1;
  border-bottom: 1px solid #dbdbdb;
  border-top: none;
  border-right: none;
  border-left: none;
  background-color: transparent;
}
.acctmgmt .label_box .question input[type=text]:focus {
  outline: none;
  color: #000000;
  margin-top: 0;
  border-bottom: 1px solid #e20074;
}
.acctmgmt .label_box .question input[type=text]:focus ~ label {
  transform: translate(0, -35px);
  margin-top: -41px;
  font-size: 10px;
}
.acctmgmt .label_box .question input[type=text]:valid {
  margin-top: 0;
  border-bottom: 1px solid #6a6a6a;
}
.acctmgmt .label_box .question input[type=text]:valid ~ label {
  transform: translate(-4px, -35px) scale(0.9);
  margin-top: -41px;
  font-size: 16px;
}
.acctmgmt .label_box .question textarea {
  appearance: none;
  -webkit-appearance: none;
  background-color: none;
  line-height: 0;
  font-size: 16px;
  width: 100%;
  display: block;
  box-sizing: border-box;
  padding: 12px 0;
  color: #000000;
  position: relative;
  z-index: 1;
  border-bottom: 1px solid #dbdbdb;
  border-top: none;
  border-right: none;
  border-left: none;
  background-color: transparent;
}
.acctmgmt .label_box .question textarea:focus {
  outline: none;
  color: #000000;
  margin-top: 0;
  border-bottom: 1px solid #e20074;
}
.acctmgmt .label_box .question textarea:focus ~ .txt_arealabel {
  transform: translate(0, -35px);
  margin-top: -30px;
  font-size: 10px;
}
.acctmgmt .label_box .question textarea:valid {
  margin-top: 0;
  border-bottom: 1px solid #e20074;
}
.acctmgmt .label_box .question textarea:valid ~ .txt_arealabel {
  text-transform: uppercase;
  transform: translate(5px, -35px) scale(0.9);
  margin-top: -30px;
  font-size: 16px;
}
.acctmgmt .label_box .question .txt_arealabel {
  margin-top: 0;
}
.acctmgmt .label_box .question .invalid_input[type=password]:focus {
  outline: none;
  color: #000000;
  margin-top: 0;
  border-bottom: 1px solid #ff0000 !important;
}
.acctmgmt .label_box .question .invalid_input[type=text]:focus {
  outline: none;
  color: #000000;
  margin-top: 0;
  border-bottom: 1px solid #ff0000 !important;
}
.acctmgmt .label_box .date_label label {
  color: #8e8e8e;
  font-weight: 100;
  font-size: 15px;
  box-sizing: border-box;
  padding: 12px 0;
  display: block;
  position: absolute;
  pointer-events: none;
  background-color: transparent;
  top: 0;
}
.acctmgmt .label_box .date_label input[type=text]:valid {
  margin-top: 0;
}
.acctmgmt .label_box .date_label input[type=text]:valid ~ label {
  font-size: 10px;
  top: -20px;
}
.acctmgmt .label_box .date_label input[type=text]:focus {
  outline: none;
  color: #000000;
  margin-top: 0;
  border-bottom: 1px solid #dddddd;
}
.acctmgmt .label_box .date_label input[type=text]:focus ~ label {
  font-size: 10px;
  top: -20px;
}
.acctmgmt .datepic_box {
  float: left;
  width: 100%;
}
.acctmgmt .date_box {
  width: 100%;
  padding: 12px;
}
.acctmgmt .date_iocn {
  background-position: -1px -769px;
  position: absolute;
  right: 0;
  top: 5px;
  cursor: pointer;
  z-index: -1;
}
.acctmgmt .datepicker {
  top: 0;
  left: 0;
  padding: 4px;
  margin-top: 1px;
  border-radius: 4px;
}
.acctmgmt .datepicker th {
  text-align: center;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  font-size: 14px;
}
.acctmgmt .datepicker th.next {
  cursor: pointer;
  font-size: 21px;
}
.acctmgmt .datepicker th.prev {
  cursor: pointer;
  font-size: 21px;
}
.acctmgmt .datepicker th.switch {
  width: 145px;
}
.acctmgmt .datepicker td {
  text-align: center;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  font-size: 14px;
}
.acctmgmt .datepicker td.day {
  color: #f41a8a;
  padding: 5px 6px;
}
.acctmgmt .datepicker td.day:hover {
  background: #eeeeee;
  cursor: pointer;
  border-radius: 100%;
}
.acctmgmt .datepicker td.day.disabled {
  color: #eeeeee;
}
.acctmgmt .datepicker td.old {
  color: #999999;
}
.acctmgmt .datepicker td.new {
  color: #999999;
}
.acctmgmt .datepicker td.active {
  color: #fff;
  background-color: #e20074;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);
  border-radius: 100%;
}
.acctmgmt .datepicker td.active:hover {
  color: #fff;
  background-color: #e20074;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);
  border-radius: 100%;
  color: #fff;
  background-color: #e20074;
}
.acctmgmt .datepicker td.active:hover:hover {
  color: #fff;
  background-color: #e20074;
}
.acctmgmt .datepicker td.active:hover:focus {
  color: #fff;
  background-color: #e20074;
}
.acctmgmt .datepicker td.active:hover:active {
  color: #fff;
  background-color: #e20074;
  background-color: #003399 \\9 ;
}
.acctmgmt .datepicker td.active:hover.active {
  color: #fff;
  background-color: #e20074;
  background-color: #003399 \\9 ;
}
.acctmgmt .datepicker td.active:hover.disabled {
  color: #fff;
  background-color: #e20074;
}
.acctmgmt .datepicker td.active:focus {
  color: #fff;
  background-color: #e20074;
}
.acctmgmt .datepicker td.active:active {
  color: #fff;
  background-color: #e20074;
  background-color: #003399 \\9 ;
}
.acctmgmt .datepicker td.active.active {
  color: #fff;
  background-color: #e20074;
  background-color: #003399 \\9 ;
}
.acctmgmt .datepicker td.active.disabled {
  color: #fff;
  background-color: #e20074;
}
.acctmgmt .datepicker td.active:hover[disabled] {
  color: #fff;
  background-color: #e20074;
}
.acctmgmt .datepicker td.active[disabled] {
  color: #fff;
  background-color: #e20074;
}
.acctmgmt .datepicker td span {
  display: block;
  width: 47px;
  height: 54px;
  line-height: 54px;
  float: left;
  margin: 2px;
  cursor: pointer;
  border-radius: 100%;
}
.acctmgmt .datepicker td span:hover {
  background: #eeeeee;
  border-radius: 100%;
}
.acctmgmt .datepicker td span.active {
  color: #fff;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);
}
.acctmgmt .datepicker td span.active:hover {
  color: #fff;
  background-color: #0044cc;
  *background-color: #0044cc;
}
.acctmgmt .datepicker td span.active:focus {
  color: #fff;
  background-color: #0044cc;
  *background-color: #0044cc;
}
.acctmgmt .datepicker td span.active:active {
  color: #fff;
  background-color: #0044cc;
  *background-color: #0044cc;
  background-color: #003399 \\9 ;
}
.acctmgmt .datepicker td span.active.active {
  color: #fff;
  background-color: #0044cc;
  *background-color: #0044cc;
  background-color: #003399 \\9 ;
}
.acctmgmt .datepicker td span.active.disabled {
  color: #fff;
  background-color: #0044cc;
  *background-color: #0044cc;
}
.acctmgmt .datepicker td span.active[disabled] {
  color: #fff;
  background-color: #0044cc;
  *background-color: #0044cc;
}
.acctmgmt .datepicker td span.old {
  color: #999999;
}
.acctmgmt .datepicker:before {
  content: "";
  display: inline-block;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #cccccc;
  border-bottom-color: rgba(0, 0, 0, 0.2);
  position: absolute;
  top: -7px;
  left: 6px;
}
.acctmgmt .datepicker:after {
  content: "";
  display: inline-block;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #fff;
  position: absolute;
  top: -6px;
  left: 7px;
}
.acctmgmt .datepicker > div {
  display: none;
}
.acctmgmt .datepicker table {
  width: 100%;
  margin: 0;
}
.acctmgmt .datepicker thead tr:first-child th {
  cursor: pointer;
}
.acctmgmt .datepicker thead tr:first-child th:hover {
  background: #eeeeee;
}
.acctmgmt .datepic_box .datepicker {
  width: 100%;
  background-color: transparent;
  border-bottom: 1px solid #dddddd;
  border-left: none;
  border-right: none;
  border-top: none;
  padding: 7px;
  border-radius: 0;
}
.acctmgmt .datepic_box .datepicker {
  padding-left: 0;
}
.acctmgmt .input-append.date .add-on i {
  display: block;
  cursor: pointer;
  width: 16px;
  height: 16px;
}
.acctmgmt .input-prepend.date .add-on i {
  display: block;
  cursor: pointer;
  width: 16px;
  height: 16px;
}
.acctmgmt .wrapper-dropdownbox {
  position: relative;
  width: 100%;
  margin: 0 auto;
  padding: 10px;
  background: #fff;
  border-bottom: 1px solid #dddddd;
  box-shadow: 0 1px 1px rgba(50, 50, 50, 0.1);
  cursor: pointer;
  outline: none;
}
.acctmgmt .wrapper-dropdownbox:after {
  content: "";
  width: 0;
  height: 0;
  position: absolute;
  right: 15px;
  top: 50%;
  margin-top: 0;
  border-width: 10px 10px 0 10px;
  border-style: solid;
  border-color: #dddddd transparent;
}
.acctmgmt .wrapper-dropdownbox .dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  padding: 0;
  margin: 0;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.17);
  font-weight: normal;
  transition: all 0.5s ease-in;
  list-style: none;
  opacity: 0;
  pointer-events: none;
}
.acctmgmt .wrapper-dropdownbox .dropdown li a {
  display: block;
  padding: 10px;
  text-decoration: none;
  color: #000000;
  border-bottom: 1px solid #e8e8e8;
  box-shadow: inset 0 1px 0 rgb(255, 255, 255);
  transition: all 0.3s ease-out;
}
.acctmgmt .wrapper-dropdownbox .dropdown li i {
  float: right;
  color: inherit;
}
.acctmgmt .wrapper-dropdownbox .dropdown li:first-of-type a {
  border-radius: 7px 7px 0 0;
}
.acctmgmt .wrapper-dropdownbox .dropdown li:last-of-type a {
  border: none;
  border-radius: 0 0 7px 7px;
}
.acctmgmt .wrapper-dropdownbox .dropdown li:hover a {
  background: #f3f8f8;
}
.acctmgmt .wrapper-dropdownbox.active .dropdown {
  opacity: 1;
  pointer-events: auto;
}
.acctmgmt .modal-content {
  border: 0px;
  border-radius: 0px;
  padding: 15px;
}
@media screen and (min-width: 1024px) {
  .acctmgmt .container {
    max-width: 1024px;
    padding: 0 20px;
  }
  .acctmgmt .textalign-right {
    text-align: right;
  }
}
@media only screen and (max-width: 1024px) {
  .acctmgmt .textalign-right {
    text-align: right;
  }
  .acctmgmt .container {
    max-width: 100%;
  }
  .acctmgmt .logo-wrapper {
    margin: 20px 0 0 0 !important;
  }
  .acctmgmt .logo-wrapper .payment-logo {
    max-width: 175px;
  }
}
@media screen and (min-width: 769px) and (max-width: 991px) {
  .acctmgmt .device-box.col-md-3 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .acctmgmt .device-box.col-md-3 a {
    width: 100%;
  }
}
@media screen and (max-width: 768px) {
  .acctmgmt #footer {
    padding: 15px;
  }
  .acctmgmt #footer .application-footer .gray-link {
    display: block;
  }
  .acctmgmt .upgradeSubheader .modal-dialog {
    max-width: 80%;
    margin: 1.75rem auto;
  }
  .acctmgmt .upgradeSubheader .modal-dialog .modal-content {
    max-height: 500px;
    overflow-y: scroll;
  }
}
@media screen and (min-width: 768px) and (max-width: 991px) {
  .acctmgmt app-choose-device .col-md-3 {
    flex: 0 0 50%;
    max-width: 50%;
    padding: 15px;
  }
  .acctmgmt .upgradeSubheader .modal-dialog {
    max-width: 80%;
    margin: 1.75rem auto;
  }
}
@media screen and (min-width: 576px) and (max-width: 1199px) {
  .acctmgmt .sort {
    text-align: left !important;
  }
  .acctmgmt .product-details .details .small-legal-grey {
    padding-left: 30px !important;
  }
}
@media screen and (max-width: 575px) {
  .acctmgmt {
    /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/
  }
  .acctmgmt .phone-box {
    max-width: 414px;
    width: 100%;
    margin: 7.5px auto !important;
  }
  .acctmgmt .phone-box .phone-box .img-wrapper img {
    max-width: 150px !important;
    width: 100%;
  }
  .acctmgmt .textalign-right {
    text-align: left;
  }
  .acctmgmt .upgradeLinesContainer .text-right {
    text-align: left !important;
  }
  .acctmgmt .storage .memory-size h6 {
    padding: 10px 30px !important;
  }
  .acctmgmt .mat-form-field-infix {
    width: 180px !important;
  }
}
.acctmgmt .modal-dialog {
  max-width: 672px !important;
}
@media screen and (max-width: 767px) {
  .acctmgmt .modal-dialog {
    height: 100%;
    width: 100%;
    transform: none !important;
    margin: 0;
    max-width: max-content !important;
    min-width: 100%;
  }
}
@media screen and (max-width: 767px) {
  .acctmgmt .modal-content {
    width: 100%;
    min-height: 100%;
    max-height: -moz-fit-content;
    max-height: fit-content;
  }
}
.acctmgmt #managePopUp .secondary_btn {
  min-width: 150px;
  min-height: 48px;
  background-color: #fff;
  color: #000;
  border: 1px solid #000;
  cursor: pointer;
}
.acctmgmt #managePopUp .modal-header, .acctmgmt #managePopUp .modal-footer {
  border: 0px solid #e9ecef;
}
.acctmgmt #managePopUp .single-change-content .head {
  font-size: 10px;
  font-weight: bold;
  margin-bottom: 2px;
}
.acctmgmt #managePopUp .single-change-content .content {
  font-size: 10px;
}
.acctmgmt #managePopUp .modal-title {
  padding-right: 32px;
  font-family: Tele-Grotesk-Ultr;
  font-size: 32px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: -0.3px;
  text-align: left;
  color: #000;
}
.acctmgmt #managePopUp .modal-header {
  border: 0;
  padding: 20px 30px;
}
.acctmgmt #managePopUp .modal-subtitle {
  font-family: Tele-GroteskHal;
  font-size: 24px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: -0.3px;
  text-align: left;
  color: #000;
  padding: 0;
  margin: 0 0 30px 0;
}
.acctmgmt #managePopUp .modal-subtitle {
  font-family: Tele-GroteskHal;
  font-size: 24px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: -0.3px;
  text-align: left;
  color: #000;
  padding: 0;
  margin: 0 0 30px 0;
}
.acctmgmt #managePopUp .acceptanceText {
  font-family: Arial;
  font-size: 11px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.45;
  letter-spacing: 0.3px;
  text-align: left;
  color: #6a6a6a;
}
.acctmgmt #managePopUp .primary_btn:disabled, .acctmgmt #managePopUp .primary_btn:disabled:hover {
  background-color: #e8e8e8;
  color: #9b9b9b;
}
.acctmgmt #managePopUp button[disabled] {
  cursor: default;
}
.acctmgmt #managePopUp .checkBoxDisabled label {
  background-color: #eee;
  cursor: not-allowed;
}
.acctmgmt #managePopUp .modal-body p {
  font-family: Arial;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: 0.6px;
  text-align: left;
  color: #4c4c4c;
  margin-bottom: 30px;
  padding: 0;
  width: 100%;
}
.acctmgmt #managePopUp .input-wrapper {
  margin-top: 10px;
  height: 27px;
  border-bottom: 1px solid #ddd;
}
.acctmgmt #managePopUp .input-select {
  border: 0;
  outline: 0;
  font-size: 15px;
  line-height: 18px;
  color: #000;
  font-family: Arial;
  width: 100%;
  -webkit-appearance: none;
  background-position: right center;
}
.acctmgmt #managePopUp .floating-label-novalue {
  color: #6a6a6a;
  font-family: Arial;
  font-size: 14px;
  line-height: 20px;
  float: left;
  letter-spacing: -0.14px;
  top: -20px;
  position: relative;
  transition: 0.2s ease all;
}
.acctmgmt #managePopUp .api-error {
  font-size: 11px;
  line-height: 16px;
  color: red;
  padding-bottom: 20px;
  float: left;
  width: 100%;
}
.acctmgmt #managePopUp .floating-label-hasvalue {
  position: relative;
  pointer-events: none;
  left: 0;
  transition: 0.2s ease all;
  color: #999;
  font-family: Arial;
  font-size: 11px;
  line-height: 16px;
  top: -50px;
  bottom: 10px;
  left: 0;
  opacity: 1;
  word-wrap: break-word;
}
@media screen and (max-width: 767px) {
  .acctmgmt #managePopUp .modal-title {
    font-size: 24px;
  }
  .acctmgmt #managePopUp .modal-header {
    border: 0;
    padding: 16px 16px;
    justify-content: normal !important;
  }
  .acctmgmt #managePopUp .modal-body {
    padding: 0 16px 0 16px;
  }
  .acctmgmt #managePopUp .modal-subtitle {
    margin-bottom: 15px;
    font-size: 18px;
  }
  .acctmgmt #managePopUp .primary_btn {
    width: 100% !important;
  }
  .acctmgmt .primary_btn {
    width: 100% !important;
  }
  .acctmgmt .secondary_btn {
    width: 100% !important;
  }
}
@media (min-width: 768px) {
  .acctmgmt #managePopUp .close {
    font-size: 40px;
    font-weight: normal;
    position: absolute;
    z-index: 150000;
    right: 24px;
    top: 24px;
    opacity: 1;
  }
  .acctmgmt #managePopUp .modal-body {
    padding: 0 32px 0 32px;
  }
  .acctmgmt .primary_btn {
    float: none;
    min-width: 150px;
    min-height: 48px;
    background-color: #e20074;
    color: #fff;
    border: 0;
  }
}
.acctmgmt .accordion-txt {
  text-decoration: none !important;
  font-size: 24px;
  font-weight: bold;
  font-family: Tele-Grotesk-Ultr;
  color: black;
  float: left;
}
.acctmgmt .mat-expansion-panel:not(.mat-expanded) .mat-expansion-panel-header:not([aria-disabled=true]) {
  background: none !important;
}
@media (max-width: 768px) {
  .acctmgmt .ngx-pagination li.pagination-previous, .acctmgmt .ngx-pagination li.pagination-next {
    padding: 10px 2px;
  }
}
@media (max-width: 576px) {
  .acctmgmt .ngx-pagination li a {
    letter-spacing: 0;
    padding: 6px;
  }
  .acctmgmt .pagination-block .ngx-pagination {
    text-align: center !important;
  }
}
.acctmgmt .mat-ink-bar {
  height: 4px !important;
}
.acctmgmt .mat-select-trigger, .acctmgmt .mat-select-trigger:hover {
  width: 100%;
}
.acctmgmt .modal-backdrop {
  z-index: 99991 !important;
}
.acctmgmt .modal {
  z-index: 99991 !important;
}
.acctmgmt .clr {
  clear: both !important;
}
.acctmgmt .modal-title {
  line-height: 32px;
  font-size: 32px;
  font-family: Tele-Grotesk-Ultr;
  letter-spacing: -1px;
}
@media (max-width: 576px) {
  .acctmgmt .modal-title {
    font-size: 26px;
  }
}
.acctmgmt #cusmodal .modal-header {
  padding: 15px;
}
.acctmgmt #cusmodal .modal-body {
  padding: 15px;
}
.acctmgmt #cusmodal .modal-footer {
  display: initial !important;
  justify-content: flex-start;
  padding: 15px;
  float: left;
  width: 100%;
  border: 0;
}
.acctmgmt .ml-15 {
  margin-left: -15px;
}
.acctmgmt #cusmodal .primary_btn {
  float: none;
  width: 100%;
}
@media (max-width: 576px) {
  .acctmgmt .acceptanceText {
    font-size: 11px;
  }
}
.acctmgmt .modal.show .modal-dialog {
  transform: translate(0, 110px);
}
.acctmgmt .modal-header .close {
  outline: none;
  font-size: 24px;
}
.acctmgmt .modal-header .close span {
  font-size: 26px;
}
.acctmgmt .modal-subtitle .selected-number {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 22px;
  font-weight: normal;
  font-style: normal;
  letter-spacing: -1px;
  text-align: left;
  color: #000;
  padding: 0;
  margin-bottom: 30px;
  display: inline-block;
}
.acctmgmt .dropdown-item.active, .acctmgmt .dropdown-item:active {
  background-color: #fff;
  color: #E20074;
}
.acctmgmt .cdk-overlay-container {
  z-index: 99999;
}
.acctmgmt .txtColor button {
  cursor: pointer;
}
.acctmgmt .w100 {
  width: 100% !important;
}
@media screen and (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {
  .acctmgmt .w100 {
    width: 150% !important;
  }
}
.acctmgmt .mat-mdc-select-panel {
  width: 100% !important;
  min-width: calc(100% + 1px) !important;
  max-width: 0 !important;
  transform-origin: 0 0 !important;
  top: 10px !important;
  position: relative !important;
  background-color: #fff;
}
.acctmgmt .mat-mdc-select-panel.manage-line-panel {
  min-width: calc(100% + 100px) !important;
}
.acctmgmt .mat-mdc-select-panel.multpl-chkbx-mat-select {
  background-color: #fff;
}
@media screen and (max-width: 1024px) {
  .acctmgmt .mat-mdc-select-panel {
    min-width: calc(100% + 0px) !important;
    left: 7px !important;
  }
}
.acctmgmt .mat-select-trigger {
  min-width: 50px !important;
}
.acctmgmt .acctmgmt .mat-mdc-select .mat-select-trigger {
  min-width: 60px !important;
  justify-content: space-between !important;
}
.acctmgmt .mat-mdc-form-field.mat-focused .mat-form-field-ripple {
  background-color: #E20074;
}
.acctmgmt .mat-mdc-dialog-container {
  width: 0px !important;
  height: 0px !important;
  padding: 0px !important;
}
.acctmgmt .mat-form-field-infix .mat-form-field-label-wrapper .mat-form-field-label {
  color: #8e8e8e;
}
@media screen and (max-width: 767px) {
  .acctmgmt .mat-form-field-infix .mat-form-field-label-wrapper .mat-form-field-label {
    font-size: 14px !important;
    color: #6A6A6A !important;
  }
}
.acctmgmt .enable-empty .mat-form-field-appearance-legacy .mat-form-field-wrapper {
  min-width: 110px !important;
}
.acctmgmt .mat-form-field-appearance-legacy .mat-form-field-underline {
  background: rgba(0, 0, 0, 0.15);
}
.acctmgmt .mat-select-content {
  width: 100% !important;
}
.acctmgmt .mat-mdc-option {
  padding: 0 12px !important;
}
.acctmgmt .cdk-overlay-pane:focus {
  overflow: hidden !important;
}
.acctmgmt .successClass {
  /*change color of underline*/
  background-color: green !important;
}
.acctmgmt .errorClass {
  /*change color of underline*/
  background-color: red !important;
}
.acctmgmt #managePopUp {
  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/
  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/
}
.acctmgmt #managePopUp .modal-header {
  padding: 1rem;
}
.acctmgmt #managePopUp .modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 1rem;
}
.acctmgmt #managePopUp .modal-footer {
  justify-content: flex-start;
}
.acctmgmt #managePopUp .mat-form-field-infix .mat-mdc-select {
  /* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version.*/
}
.acctmgmt #managePopUp .mat-form-field-infix .mat-mdc-select .mat-select-value-text {
  padding-right: 5px !important;
}
.acctmgmt .pagination-num-bx {
  width: 100px !important;
}
@media (max-width: 576px) {
  .acctmgmt .pagination-num-bx {
    width: auto;
  }
}
.acctmgmt app-change-number-form .mat-form-field-infix .mat-form-field-label-wrapper .mat-form-field-label {
  width: 100% !important;
  padding-right: 15px !important;
}
.acctmgmt .gray-bg {
  background-color: #DDDDDD !important;
}
.acctmgmt .only-bdr-btn {
  background-color: #ffffff !important;
  border: 1px solid #000 !important;
}
@media screen and (max-width: 767px) {
  .acctmgmt .bottom_aligner {
    position: absolute;
    bottom: 0;
  }
}
@media screen and (max-width: 767px) {
  .acctmgmt .popup_btnbox {
    float: left;
    width: 100%;
    padding: 0 32px 32px 0px;
    display: flex;
    flex-direction: column-reverse;
  }
}
.acctmgmt .p-t-0 {
  padding-top: 0 !important;
}
.acctmgmt .p-b-0 {
  padding-bottom: 0 !important;
}
.acctmgmt .p-l-0 {
  padding-left: 0 !important;
}
.acctmgmt .p-r-0 {
  padding-right: 0 !important;
}
.acctmgmt .p-a-0 {
  padding: 0 !important;
}
.acctmgmt .p-a-5 {
  padding: 5px !important;
}
.acctmgmt .p-a-10 {
  padding: 10px !important;
}
.acctmgmt .p-a-15 {
  padding: 15px !important;
}
.acctmgmt .p-a-20 {
  padding: 20px !important;
}
.acctmgmt .p-a-35 {
  padding: 35px !important;
}
.acctmgmt .p-a-50 {
  padding: 50px !important;
}
.acctmgmt .p-l-5 {
  padding-left: 5px !important;
}
.acctmgmt .p-l-10 {
  padding-left: 10px !important;
}
.acctmgmt .p-l-15 {
  padding-left: 15px !important;
}
.acctmgmt .p-l-20 {
  padding-left: 20px !important;
}
.acctmgmt .p-l-30 {
  padding-left: 30px !important;
}
.acctmgmt .p-l-35 {
  padding-left: 35px !important;
}
.acctmgmt .p-l-50 {
  padding-left: 50px !important;
}
.acctmgmt .p-r-5 {
  padding-right: 5px !important;
}
.acctmgmt .p-r-10 {
  padding-right: 10px !important;
}
.acctmgmt .p-r-15 {
  padding-right: 15px !important;
}
.acctmgmt .p-r-20 {
  padding-right: 20px !important;
}
.acctmgmt .p-r-35 {
  padding-right: 35px !important;
}
.acctmgmt .p-r-50 {
  padding-right: 50px !important;
}
.acctmgmt .p-t-5 {
  padding-top: 5px !important;
}
.acctmgmt .p-t-10 {
  padding-top: 10px !important;
}
.acctmgmt .p-t-15 {
  padding-top: 15px !important;
}
.acctmgmt .p-t-20 {
  padding-top: 20px !important;
}
.acctmgmt .p-t-35 {
  padding-top: 35px !important;
}
.acctmgmt .p-t-50 {
  padding-top: 50px !important;
}
.acctmgmt .p-b-5 {
  padding-bottom: 5px !important;
}
.acctmgmt .p-b-10 {
  padding-bottom: 10px !important;
}
.acctmgmt .p-b-15 {
  padding-bottom: 15px !important;
}
.acctmgmt .p-b-20 {
  padding-bottom: 20px !important;
}
.acctmgmt .p-b-35 {
  padding-bottom: 35px !important;
}
.acctmgmt .p-b-50 {
  padding-bottom: 50px !important;
}
@media screen and (min-width: 320px) {
  .acctmgmt .p-xs-t-50 {
    padding-top: 50px !important;
  }
  .acctmgmt .p-xs-b-50 {
    padding-bottom: 50px !important;
  }
  .acctmgmt .p-xs-l-50 {
    padding-left: 50px !important;
  }
  .acctmgmt .p-xs-r-50 {
    padding-right: 50px !important;
  }
  .acctmgmt .p-xs-l-35 {
    padding-left: 35px !important;
  }
  .acctmgmt .p-xs-r-35 {
    padding-right: 35px !important;
  }
  .acctmgmt .p-xs-t-35 {
    padding-top: 35px !important;
  }
  .acctmgmt .p-xs-b-35 {
    padding-bottom: 35px !important;
  }
  .acctmgmt .p-xs-l-20 {
    padding-left: 20px !important;
  }
  .acctmgmt .p-xs-r-20 {
    padding-right: 20px !important;
  }
  .acctmgmt .p-xs-t-20 {
    padding-top: 20px !important;
  }
  .acctmgmt .p-xs-b-20 {
    padding-bottom: 20px !important;
  }
  .acctmgmt .p-xs-l-15 {
    padding-left: 15px !important;
  }
  .acctmgmt .p-xs-r-15 {
    padding-right: 15px !important;
  }
  .acctmgmt .p-xs-t-15 {
    padding-top: 15px !important;
  }
  .acctmgmt .p-xs-b-15 {
    padding-bottom: 15px !important;
  }
  .acctmgmt .p-xs-l-10 {
    padding-left: 10px !important;
  }
  .acctmgmt .p-xs-r-10 {
    padding-right: 10px !important;
  }
  .acctmgmt .p-xs-t-10 {
    padding-top: 10px !important;
  }
  .acctmgmt .p-xs-b-10 {
    padding-bottom: 10px !important;
  }
  .acctmgmt .p-xs-l-5 {
    padding-left: 5px !important;
  }
  .acctmgmt .p-xs-r-5 {
    padding-right: 5px !important;
  }
  .acctmgmt .p-xs-t-5 {
    padding-top: 5px !important;
  }
  .acctmgmt .p-xs-b-5 {
    padding-bottom: 5px !important;
  }
  .acctmgmt .p-xs-l-0 {
    padding-left: 0 !important;
  }
  .acctmgmt .p-xs-r-0 {
    padding-right: 0 !important;
  }
  .acctmgmt .p-xs-t-0 {
    padding-top: 0 !important;
  }
  .acctmgmt .p-xs-b-0 {
    padding-bottom: 0 !important;
  }
  .acctmgmt .p-xs-a-0 {
    padding: 0 !important;
  }
}
@media screen and (min-width: 767px) {
  .acctmgmt .p-sm-t-50 {
    padding-top: 50px !important;
  }
  .acctmgmt .p-sm-b-50 {
    padding-bottom: 50px !important;
  }
  .acctmgmt .p-sm-l-50 {
    padding-left: 50px !important;
  }
  .acctmgmt .p-sm-r-50 {
    padding-right: 50px !important;
  }
  .acctmgmt .p-sm-l-35 {
    padding-left: 35px !important;
  }
  .acctmgmt .p-sm-r-35 {
    padding-right: 35px !important;
  }
  .acctmgmt .p-sm-t-35 {
    padding-top: 35px !important;
  }
  .acctmgmt .p-sm-b-35 {
    padding-bottom: 35px !important;
  }
  .acctmgmt .p-sm-l-20 {
    padding-left: 20px !important;
  }
  .acctmgmt .p-sm-r-20 {
    padding-right: 20px !important;
  }
  .acctmgmt .p-sm-t-20 {
    padding-top: 20px !important;
  }
  .acctmgmt .p-sm-b-20 {
    padding-bottom: 20px !important;
  }
  .acctmgmt .p-sm-l-15 {
    padding-left: 15px !important;
  }
  .acctmgmt .p-sm-r-15 {
    padding-right: 15px !important;
  }
  .acctmgmt .p-sm-t-15 {
    padding-top: 15px !important;
  }
  .acctmgmt .p-sm-b-15 {
    padding-bottom: 15px !important;
  }
  .acctmgmt .p-sm-l-10 {
    padding-left: 10px !important;
  }
  .acctmgmt .p-sm-r-10 {
    padding-right: 10px !important;
  }
  .acctmgmt .p-sm-t-10 {
    padding-top: 10px !important;
  }
  .acctmgmt .p-sm-b-10 {
    padding-bottom: 10px !important;
  }
  .acctmgmt .p-sm-l-5 {
    padding-left: 5px !important;
  }
  .acctmgmt .p-sm-r-5 {
    padding-right: 5px !important;
  }
  .acctmgmt .p-sm-t-5 {
    padding-top: 5px !important;
  }
  .acctmgmt .p-sm-b-5 {
    padding-bottom: 5px !important;
  }
  .acctmgmt .p-sm-a-0 {
    padding: 0 !important;
  }
  .acctmgmt .p-sm-l-0 {
    padding-left: 0 !important;
  }
  .acctmgmt .p-sm-r-0 {
    padding-right: 0 !important;
  }
  .acctmgmt .p-sm-t-0 {
    padding-top: 0 !important;
  }
  .acctmgmt .p-sm-b-0 {
    padding-bottom: 0 !important;
  }
}
@media screen and (min-width: 992px) {
  .acctmgmt .p-md-t-50 {
    padding-top: 50px !important;
  }
  .acctmgmt .p-md-b-50 {
    padding-bottom: 50px !important;
  }
  .acctmgmt .p-md-l-50 {
    padding-left: 50px !important;
  }
  .acctmgmt .p-md-r-50 {
    padding-right: 50px !important;
  }
  .acctmgmt .p-md-l-35 {
    padding-left: 35px !important;
  }
  .acctmgmt .p-md-r-35 {
    padding-right: 35px !important;
  }
  .acctmgmt .p-md-t-35 {
    padding-top: 35px !important;
  }
  .acctmgmt .p-md-b-35 {
    padding-bottom: 35px !important;
  }
  .acctmgmt .p-md-l-20 {
    padding-left: 20px !important;
  }
  .acctmgmt .p-md-r-20 {
    padding-right: 20px !important;
  }
  .acctmgmt .p-md-t-20 {
    padding-top: 20px !important;
  }
  .acctmgmt .p-md-b-20 {
    padding-bottom: 20px !important;
  }
  .acctmgmt .p-md-l-15 {
    padding-left: 15px !important;
  }
  .acctmgmt .p-md-r-15 {
    padding-right: 15px !important;
  }
  .acctmgmt .p-md-t-15 {
    padding-top: 15px !important;
  }
  .acctmgmt .p-md-b-15 {
    padding-bottom: 15px !important;
  }
  .acctmgmt .p-md-l-10 {
    padding-left: 10px !important;
  }
  .acctmgmt .p-md-r-10 {
    padding-right: 10px !important;
  }
  .acctmgmt .p-md-t-10 {
    padding-top: 10px !important;
  }
  .acctmgmt .p-md-b-10 {
    padding-bottom: 10px !important;
  }
  .acctmgmt .p-md-l-5 {
    padding-top: 5px !important;
  }
  .acctmgmt .p-md-r-5 {
    padding-right: 5px !important;
  }
  .acctmgmt .p-md-t-5 {
    padding-top: 5px !important;
  }
  .acctmgmt .p-md-b-5 {
    padding-bottom: 5px !important;
  }
  .acctmgmt .p-md-l-0 {
    padding-left: 0 !important;
  }
  .acctmgmt .p-md-r-0 {
    padding-right: 0 !important;
  }
  .acctmgmt .p-md-t-0 {
    padding-top: 0 !important;
  }
  .acctmgmt .p-md-b-0 {
    padding-bottom: 0 !important;
  }
  .acctmgmt .p-md-a-0 {
    padding: 0 !important;
  }
}
@media screen and (min-width: 1200px) {
  .acctmgmt .p-lg-t-50 {
    padding-top: 50px !important;
  }
  .acctmgmt .p-lg-b-50 {
    padding-bottom: 50px !important;
  }
  .acctmgmt .p-lg-l-50 {
    padding-left: 50px !important;
  }
  .acctmgmt .p-lg-r-50 {
    padding-right: 50px !important;
  }
  .acctmgmt .p-lg-a-50 {
    padding: 50px !important;
  }
  .acctmgmt .p-lg-l-35 {
    padding-left: 35px !important;
  }
  .acctmgmt .p-lg-r-35 {
    padding-right: 35px !important;
  }
  .acctmgmt .p-lg-t-35 {
    padding-top: 35px !important;
  }
  .acctmgmt .p-lg-b-35 {
    padding-bottom: 35px !important;
  }
  .acctmgmt .p-lg-a-35 {
    padding: 35px !important;
  }
  .acctmgmt .p-lg-l-20 {
    padding-left: 20px !important;
  }
  .acctmgmt .p-lg-r-20 {
    padding-right: 20px !important;
  }
  .acctmgmt .p-lg-t-20 {
    padding-top: 20px !important;
  }
  .acctmgmt .p-lg-b-20 {
    padding-bottom: 20px !important;
  }
  .acctmgmt .p-lg-a-20 {
    padding: 20px !important;
  }
  .acctmgmt .p-lg-l-15 {
    padding-left: 15px !important;
  }
  .acctmgmt .p-lg-r-15 {
    padding-right: 15px !important;
  }
  .acctmgmt .p-lg-t-15 {
    padding-top: 15px !important;
  }
  .acctmgmt .p-lg-b-15 {
    padding-bottom: 15px !important;
  }
  .acctmgmt .p-lg-a-15 {
    padding: 15px !important;
  }
  .acctmgmt .p-lg-l-10 {
    padding-left: 10px !important;
  }
  .acctmgmt .p-lg-r-10 {
    padding-right: 10px !important;
  }
  .acctmgmt .p-lg-t-10 {
    padding-top: 10px !important;
  }
  .acctmgmt .p-lg-b-10 {
    padding-bottom: 10px !important;
  }
  .acctmgmt .p-lg-a-10 {
    padding: 10px !important;
  }
  .acctmgmt .p-lg-l-5 {
    padding-left: 5px !important;
  }
  .acctmgmt .p-lg-r-5 {
    padding-right: 5px !important;
  }
  .acctmgmt .p-lg-t-5 {
    padding-top: 5px !important;
  }
  .acctmgmt .p-lg-b-5 {
    padding-bottom: 5px !important;
  }
  .acctmgmt .p-lg-a-5 {
    padding: 5px !important;
  }
  .acctmgmt .p-lg-l-0 {
    padding-left: 0 !important;
  }
  .acctmgmt .p-lg-r-0 {
    padding-right: 0 !important;
  }
  .acctmgmt .p-lg-t-0 {
    padding-top: 0 !important;
  }
  .acctmgmt .p-lg-b-0 {
    padding-bottom: 0 !important;
  }
  .acctmgmt .p-lg-a-0 {
    padding: 0 !important;
  }
}
.acctmgmt .no-margin {
  margin: 0 !important;
}
.acctmgmt .no-margin-top {
  margin-top: 0 !important;
}
.acctmgmt .no-margin-bottom {
  margin-bottom: 0 !important;
}
.acctmgmt .m-a-5 {
  margin: 5px !important;
}
.acctmgmt .m-a-10 {
  margin: 10px !important;
}
.acctmgmt .m-a-15 {
  margin: 15px !important;
}
.acctmgmt .m-a-20 {
  margin: 20px !important;
}
.acctmgmt .m-a-35 {
  margin: 35px !important;
}
.acctmgmt .m-a-50 {
  margin: 50px !important;
}
.acctmgmt .m-t-0 {
  margin-top: 0 !important;
}
.acctmgmt .m-b-0 {
  margin-bottom: 0 !important;
}
.acctmgmt .m-l-0 {
  margin-left: 0 !important;
}
.acctmgmt .m-r-0 {
  margin-right: 0 !important;
}
.acctmgmt .m-a-0 {
  margin: 0 !important;
}
.acctmgmt .m-t-50 {
  margin-top: 50px;
}
.acctmgmt .m-b-50 {
  margin-bottom: 50px;
}
.acctmgmt .m-l-50 {
  margin-left: 50px;
}
.acctmgmt .m-r-50 {
  margin-right: 50px;
}
.acctmgmt .m-l-35 {
  margin-left: 35px;
}
.acctmgmt .m-r-35 {
  margin-right: 35px;
}
.acctmgmt .m-t-35 {
  margin-top: 35px;
}
.acctmgmt .m-b-35 {
  margin-bottom: 35px;
}
.acctmgmt .m-l-20 {
  margin-left: 20px;
}
.acctmgmt .m-r-20 {
  margin-right: 20px;
}
.acctmgmt .m-t-20 {
  margin-top: 20px;
}
.acctmgmt .m-b-20 {
  margin-bottom: 20px;
}
.acctmgmt .m-l-15 {
  margin-left: 15px;
}
.acctmgmt .m-r-15 {
  margin-right: 15px;
}
.acctmgmt .m-t-15 {
  margin-top: 15px;
}
.acctmgmt .m-b-15 {
  margin-bottom: 15px;
}
.acctmgmt .m-l-10 {
  margin-left: 10px;
}
.acctmgmt .m-r-10 {
  margin-right: 10px;
}
.acctmgmt .m-t-10 {
  margin-top: 10px;
}
.acctmgmt .m-b-10 {
  margin-bottom: 10px;
}
.acctmgmt .m-l-5 {
  margin-left: 5px;
}
.acctmgmt .m-r-5 {
  margin-right: 5px;
}
.acctmgmt .m-t-5 {
  margin-top: 5px;
}
.acctmgmt .m-b-5 {
  margin-bottom: 5px;
}
@media screen and (min-width: 320px) {
  .acctmgmt .m-xs-t-50 {
    margin-top: 50px;
  }
  .acctmgmt .m-xs-b-50 {
    margin-bottom: 50px;
  }
  .acctmgmt .m-xs-l-50 {
    margin-left: 50px;
  }
  .acctmgmt .m-xs-r-50 {
    margin-right: 50px;
  }
  .acctmgmt .m-xs-a-50 {
    margin: 50px;
  }
  .acctmgmt .m-xs-l-35 {
    margin-left: 35px;
  }
  .acctmgmt .m-xs-r-35 {
    margin-right: 35px;
  }
  .acctmgmt .m-xs-t-35 {
    margin-top: 35px;
  }
  .acctmgmt .m-xs-b-35 {
    margin-bottom: 35px;
  }
  .acctmgmt .m-xs-a-35 {
    margin: 35px;
  }
  .acctmgmt .m-xs-l-20 {
    margin-left: 20px;
  }
  .acctmgmt .m-xs-r-20 {
    margin-right: 20px;
  }
  .acctmgmt .m-xs-t-20 {
    margin-top: 20px;
  }
  .acctmgmt .m-xs-b-20 {
    margin-bottom: 20px;
  }
  .acctmgmt .m-xs-a-20 {
    margin: 20px;
  }
  .acctmgmt .m-xs-l-15 {
    margin-left: 15px;
  }
  .acctmgmt .m-xs-r-15 {
    margin-right: 15px;
  }
  .acctmgmt .m-xs-t-15 {
    margin-top: 15px;
  }
  .acctmgmt .m-xs-b-15 {
    margin-bottom: 15px;
  }
  .acctmgmt .m-xs-a-15 {
    margin: 15px;
  }
  .acctmgmt .m-xs-l-10 {
    margin-left: 10px;
  }
  .acctmgmt .m-xs-r-10 {
    margin-right: 10px;
  }
  .acctmgmt .m-xs-t-10 {
    margin-top: 10px;
  }
  .acctmgmt .m-xs-b-10 {
    margin-bottom: 10px;
  }
  .acctmgmt .m-xs-a-10 {
    margin: 10px;
  }
  .acctmgmt .m-xs-l-5 {
    margin-left: 5px;
  }
  .acctmgmt .m-xs-r-5 {
    margin-right: 5px;
  }
  .acctmgmt .m-xs-t-5 {
    margin-top: 5px;
  }
  .acctmgmt .m-xs-b-5 {
    margin-bottom: 5px;
  }
  .acctmgmt .m-xs-a-5 {
    margin: 5px;
  }
  .acctmgmt .m-xs-l-0 {
    margin-left: 0;
  }
  .acctmgmt .m-xs-r-0 {
    margin-right: 0;
  }
  .acctmgmt .m-xs-t-0 {
    margin-top: 0;
  }
  .acctmgmt .m-xs-b-0 {
    margin-bottom: 0;
  }
  .acctmgmt .m-xs-a-0 {
    margin: 0;
  }
}
@media screen and (min-width: 767px) {
  .acctmgmt .m-sm-t-50 {
    margin-top: 50px;
  }
  .acctmgmt .m-sm-b-50 {
    margin-bottom: 50px;
  }
  .acctmgmt .m-sm-l-50 {
    margin-left: 50px;
  }
  .acctmgmt .m-sm-r-50 {
    margin-right: 50px;
  }
  .acctmgmt .m-sm-a-50 {
    margin: 50px;
  }
  .acctmgmt .m-sm-l-35 {
    margin-left: 35px;
  }
  .acctmgmt .m-sm-r-35 {
    margin-right: 35px;
  }
  .acctmgmt .m-sm-t-35 {
    margin-top: 35px;
  }
  .acctmgmt .m-sm-b-35 {
    margin-bottom: 35px;
  }
  .acctmgmt .m-sm-a-35 {
    margin: 35px;
  }
  .acctmgmt .m-sm-l-20 {
    margin-left: 20px;
  }
  .acctmgmt .m-sm-r-20 {
    margin-right: 20px;
  }
  .acctmgmt .m-sm-t-20 {
    margin-top: 20px;
  }
  .acctmgmt .m-sm-b-20 {
    margin-bottom: 20px;
  }
  .acctmgmt .m-sm-a-20 {
    margin: 20px;
  }
  .acctmgmt .m-sm-l-15 {
    margin-left: 15px;
  }
  .acctmgmt .m-sm-r-15 {
    margin-right: 15px;
  }
  .acctmgmt .m-sm-t-15 {
    margin-top: 15px;
  }
  .acctmgmt .m-sm-b-15 {
    margin-bottom: 15px;
  }
  .acctmgmt .m-sm-a-15 {
    margin: 15px;
  }
  .acctmgmt .m-sm-l-10 {
    margin-left: 10px;
  }
  .acctmgmt .m-sm-r-10 {
    margin-right: 10px;
  }
  .acctmgmt .m-sm-t-10 {
    margin-top: 10px;
  }
  .acctmgmt .m-sm-b-10 {
    margin-bottom: 10px;
  }
  .acctmgmt .m-sm-a-10 {
    margin: 10px;
  }
  .acctmgmt .m-sm-l-5 {
    margin-left: 5px;
  }
  .acctmgmt .m-sm-r-5 {
    margin-right: 5px;
  }
  .acctmgmt .m-sm-t-5 {
    margin-top: 5px;
  }
  .acctmgmt .m-sm-b-5 {
    margin-bottom: 5px;
  }
  .acctmgmt .m-sm-a-5 {
    margin: 5px;
  }
  .acctmgmt .m-sm-l-0 {
    margin-left: 0;
  }
  .acctmgmt .m-sm-r-0 {
    margin-right: 0;
  }
  .acctmgmt .m-sm-t-0 {
    margin-top: 0;
  }
  .acctmgmt .m-sm-b-0 {
    margin-bottom: 0;
  }
  .acctmgmt .m-sm-a-0 {
    margin: 0;
  }
}
@media screen and (min-width: 992px) {
  .acctmgmt .m-md-t-50 {
    margin-top: 50px;
  }
  .acctmgmt .m-md-b-50 {
    margin-bottom: 50px;
  }
  .acctmgmt .m-md-l-50 {
    margin-left: 50px;
  }
  .acctmgmt .m-md-r-50 {
    margin-right: 50px;
  }
  .acctmgmt .m-md-a-50 {
    margin: 50px;
  }
  .acctmgmt .m-md-l-35 {
    margin-left: 35px;
  }
  .acctmgmt .m-md-r-35 {
    margin-right: 35px;
  }
  .acctmgmt .m-md-t-35 {
    margin-top: 35px;
  }
  .acctmgmt .m-md-b-35 {
    margin-bottom: 35px;
  }
  .acctmgmt .m-md-a-35 {
    margin: 35px;
  }
  .acctmgmt .m-md-l-20 {
    margin-left: 20px;
  }
  .acctmgmt .m-md-r-20 {
    margin-right: 20px;
  }
  .acctmgmt .m-md-t-20 {
    margin-top: 20px;
  }
  .acctmgmt .m-md-b-20 {
    margin-bottom: 20px;
  }
  .acctmgmt .m-md-a-20 {
    margin: 20px;
  }
  .acctmgmt .m-md-l-15 {
    margin-left: 15px;
  }
  .acctmgmt .m-md-r-15 {
    margin-right: 15px;
  }
  .acctmgmt .m-md-t-15 {
    margin-top: 15px;
  }
  .acctmgmt .m-md-b-15 {
    margin-bottom: 15px;
  }
  .acctmgmt .m-md-a-15 {
    margin: 15px;
  }
  .acctmgmt .m-md-l-10 {
    margin-left: 10px;
  }
  .acctmgmt .m-md-r-10 {
    margin-right: 10px;
  }
  .acctmgmt .m-md-t-10 {
    margin-top: 10px;
  }
  .acctmgmt .m-md-b-10 {
    margin-bottom: 10px;
  }
  .acctmgmt .m-md-a-10 {
    margin: 10px;
  }
  .acctmgmt .m-md-l-5 {
    margin-top: 5px;
  }
  .acctmgmt .m-md-r-5 {
    margin-right: 5px;
  }
  .acctmgmt .m-md-t-5 {
    margin-top: 5px;
  }
  .acctmgmt .m-md-b-5 {
    margin-bottom: 5px;
  }
  .acctmgmt .m-md-a-5 {
    margin: 5px;
  }
  .acctmgmt .m-md-l-0 {
    margin-left: 0;
  }
  .acctmgmt .m-md-r-0 {
    margin-right: 0;
  }
  .acctmgmt .m-md-t-0 {
    margin-top: 0;
  }
  .acctmgmt .m-md-b-0 {
    margin-bottom: 0;
  }
  .acctmgmt .m-md-a-0 {
    margin: 0;
  }
}
@media screen and (min-width: 1200px) {
  .acctmgmt .m-lg-t-50 {
    margin-top: 50px;
  }
  .acctmgmt .m-lg-b-50 {
    margin-bottom: 50px;
  }
  .acctmgmt .m-lg-l-50 {
    margin-left: 50px;
  }
  .acctmgmt .m-lg-r-50 {
    margin-right: 50px;
  }
  .acctmgmt .m-lg-a-50 {
    margin: 50px;
  }
  .acctmgmt .m-lg-l-35 {
    margin-left: 35px;
  }
  .acctmgmt .m-lg-r-35 {
    margin-right: 35px;
  }
  .acctmgmt .m-lg-t-35 {
    margin-top: 35px;
  }
  .acctmgmt .m-lg-b-35 {
    margin-bottom: 35px;
  }
  .acctmgmt .m-lg-a-35 {
    margin: 35px;
  }
  .acctmgmt .m-lg-l-20 {
    margin-left: 20px;
  }
  .acctmgmt .m-lg-r-20 {
    margin-right: 20px;
  }
  .acctmgmt .m-lg-t-20 {
    margin-top: 20px;
  }
  .acctmgmt .m-lg-b-20 {
    margin-bottom: 20px;
  }
  .acctmgmt .m-lg-a-20 {
    margin: 20px;
  }
  .acctmgmt .m-lg-l-15 {
    margin-left: 15px;
  }
  .acctmgmt .m-lg-r-15 {
    margin-right: 15px;
  }
  .acctmgmt .m-lg-t-15 {
    margin-top: 15px;
  }
  .acctmgmt .m-lg-b-15 {
    margin-bottom: 15px;
  }
  .acctmgmt .m-lg-a-15 {
    margin: 15px;
  }
  .acctmgmt .m-lg-l-10 {
    margin-left: 10px;
  }
  .acctmgmt .m-lg-r-10 {
    margin-right: 10px;
  }
  .acctmgmt .m-lg-t-10 {
    margin-top: 10px;
  }
  .acctmgmt .m-lg-b-10 {
    margin-bottom: 10px;
  }
  .acctmgmt .m-lg-a-10 {
    margin: 10px;
  }
  .acctmgmt .m-lg-l-5 {
    margin-left: 5px;
  }
  .acctmgmt .m-lg-r-5 {
    margin-right: 5px;
  }
  .acctmgmt .m-lg-t-5 {
    margin-top: 5px;
  }
  .acctmgmt .m-lg-b-5 {
    margin-bottom: 5px;
  }
  .acctmgmt .m-lg-a-5 {
    margin: 5px;
  }
  .acctmgmt .m-lg-l-0 {
    margin-left: 0;
  }
  .acctmgmt .m-lg-r-0 {
    margin-right: 0;
  }
  .acctmgmt .m-lg-t-0 {
    margin-top: 0;
  }
  .acctmgmt .m-lg-b-0 {
    margin-bottom: 0;
  }
  .acctmgmt .m-lg-a-0 {
    margin: 0;
  }
}
.acctmgmt .text-black {
  color: #000000;
}
.acctmgmt .text-white {
  color: #fff;
}
.acctmgmt .text-white-smoke {
  color: #f5f5f5;
}
.acctmgmt .text-magenta, .acctmgmt .text-brand-magenta, .acctmgmt .text-primary {
  color: #e20074;
}
.acctmgmt .text-dark-magenta {
  color: #ba0060;
}
.acctmgmt .text-very-dark-magenta {
  color: #a10053;
}
.acctmgmt .text-gray {
  color: #767676;
}
.acctmgmt .text-gray-dark {
  color: #5a5a5a;
}
.acctmgmt .text-gray-darker {
  color: #323232;
}
.acctmgmt .text-gray-light {
  color: #bebebe;
}
.acctmgmt .text-gray-lighter {
  color: #dddddd;
}
.acctmgmt .text-gray-light-1 {
  color: #cccccc;
}
.acctmgmt .text-gray-light-2 {
  color: #e6e6e6;
}
.acctmgmt .text-green-true {
  color: #07ac0f;
}
.acctmgmt .text-green-light {
  color: #8dc63f;
}
.acctmgmt .text-green-medium {
  color: #39b54a;
}
.acctmgmt .text-green {
  color: #09B119;
}
.acctmgmt .text-red, .acctmgmt .text-error {
  color: #ff0000;
}
.acctmgmt .text-pinkish-red {
  color: #ed1c24;
}
.acctmgmt .text-squash {
  color: #f7941d;
}
.acctmgmt .text-bright-yellow {
  color: #fff200;
}
.acctmgmt .bg-black {
  background-color: #000000;
}
.acctmgmt .bg-white {
  background-color: #fff;
}
.acctmgmt .bg-white-smoke {
  background-color: #f5f5f5;
}
.acctmgmt .bg-magenta, .acctmgmt .bg-brand-magenta {
  background-color: #e20074;
}
.acctmgmt .bg-dark-magenta {
  background-color: #ba0060;
}
.acctmgmt .bg-very-dark-magenta {
  background-color: #a10053;
}
.acctmgmt .bg-gray {
  background-color: #767676;
}
.acctmgmt .bg-gray-dark {
  background-color: #5a5a5a;
}
.acctmgmt .bg-gray-darker {
  background-color: #323232;
}
.acctmgmt .bg-gray-light {
  background-color: #bebebe;
}
.acctmgmt .bg-gray-lighter {
  background-color: #dddddd;
}
.acctmgmt .bg-gray-light-1 {
  background-color: #cccccc;
}
.acctmgmt .bg-gray-light-2 {
  background-color: #e6e6e6;
}
.acctmgmt .bg-green-true {
  background-color: #07ac0f;
}
.acctmgmt .bg-green-light {
  background-color: #8dc63f;
}
.acctmgmt .bg-green-medium {
  background-color: #39b54a;
}
.acctmgmt .bg-green {
  background-color: #09B119;
}
.acctmgmt .bg-red {
  background-color: #ff0000;
}
.acctmgmt .bg-pinkish-red {
  background-color: #ed1c24;
}
.acctmgmt .bg-squash {
  background-color: #f7941d;
}
.acctmgmt .bg-bright-yellow {
  background-color: #fff200;
}
.acctmgmt .bg-cart {
  background-color: #f3f3f3;
}
.acctmgmt .bg-cart-boxes {
  background-color: #fafafa;
}
.acctmgmt .text-bold {
  font-family: Tele-Ult, sans-serif;
}
.acctmgmt .paragraph-bold {
  font-family: Arial-Bold, sans-serif;
}
.acctmgmt .text-strike-through {
  text-decoration: line-through;
}
.acctmgmt .font-bold {
  font-weight: bold;
}
.acctmgmt .lead {
  font-size: 18px;
  line-height: 22px;
}
@media screen and (max-width: 767px) {
  .acctmgmt .lead {
    font-size: 1.6rem;
  }
}
.acctmgmt .regular {
  font-size: 16px;
  line-height: 19px;
}
@media screen and (max-width: 767px) {
  .acctmgmt .regular {
    font-size: 14px;
    line-height: 17px;
  }
}
.acctmgmt .small {
  font-size: 14px;
  line-height: 17px;
  font-family: ArialMT;
}
@media screen and (max-width: 767px) {
  .acctmgmt .small {
    font-size: 12px;
    line-height: 15px;
  }
}
.acctmgmt .xsmall {
  font-size: 12px;
  line-height: 15px;
}
@media screen and (max-width: 767px) {
  .acctmgmt .xsmall {
    font-size: 11px;
    line-height: 13px;
  }
}
.acctmgmt .legal {
  font-size: 10px;
  line-height: 12px;
  font-family: ArialMT;
}
.acctmgmt .display-none {
  display: none !important;
}
.acctmgmt .display-block, .acctmgmt .block {
  display: block !important;
}
.acctmgmt .display-inline {
  display: inline !important;
}
.acctmgmt .display-flex {
  display: flex !important;
}
.acctmgmt .display-inline-block, .acctmgmt .inline, .acctmgmt .inline-block {
  display: inline-block !important;
}
.acctmgmt .display-inline-flex, .acctmgmt .inline-flex {
  display: inline-flex !important;
}
.acctmgmt .hidden {
  visibility: hidden !important;
}
.acctmgmt .overflow-hidden {
  overflow: hidden !important;
}
.acctmgmt .overflow-auto {
  overflow: auto !important;
}
.acctmgmt .overflow-visible {
  overflow: visible !important;
}
@media (max-width: 767px) {
  .acctmgmt .display-none-xs {
    display: none !important;
  }
}
@media (min-width: 767px) {
  .acctmgmt .display-none-sm {
    display: none !important;
  }
}
@media (min-width: 991px) {
  .acctmgmt .display-none-md {
    display: none !important;
  }
}
@media (max-width: 992px) {
  .acctmgmt .display-none-max-md {
    display: none !important;
  }
}
@media (min-width: 1199px) {
  .acctmgmt .display-none-lg {
    display: none !important;
  }
}
@media (max-width: 768px) {
  .acctmgmt .display-none-max-sm {
    display: none !important;
  }
}
@media (max-width: 992px) {
  .acctmgmt .display-none-max-md {
    display: none !important;
  }
}
.acctmgmt .display-none-pseudo:before,
.acctmgmt .display-none-pseudo:after {
  display: none !important;
}
.acctmgmt .display-none-pseudo-before:before {
  display: none !important;
}
.acctmgmt .display-none-pseudo-after:after {
  display: none !important;
}
@media (max-width: 767px) {
  .acctmgmt .display-inline-xs {
    display: inline !important;
  }
}
@media (max-width: 767px) {
  .acctmgmt .display-block-xs {
    display: block !important;
  }
}
.acctmgmt .word-wrap {
  word-wrap: break-word;
}
.acctmgmt .main-loader-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.5);
  z-index: 99999;
  display: block;
  right: 0;
  bottom: 0;
  margin: auto;
}
.acctmgmt .main-loader-wrapper .loader-image {
  position: absolute;
  top: 50%;
  left: 50%;
}
.acctmgmt .hr-loader {
  text-align: center;
  width: 80px;
  height: 50px;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}
.acctmgmt .hr-loader .hr-loading-title {
  font-size: 19px;
}
.acctmgmt .hr-loader span {
  display: inline-block;
  vertical-align: middle;
  width: 15px;
  height: 15px;
  margin: 25px auto;
  background: #E8488B;
  -moz-border-radius: 50px;
  -moz-animation: hr-loader 0.8s infinite alternate;
  -webkit-border-radius: 50px;
  -webkit-animation: hr-loader 0.8s infinite alternate;
  -ms-border-radius: 50px;
  -ms-animation: hr-loader 0.8s infinite alternate;
  -o-border-radius: 50px;
  -o-animation: hr-loader 0.8s infinite alternate;
  border-radius: 50px;
  animation: hr-loader 0.8s infinite alternate;
}
.acctmgmt #hr_bubbling_1 {
  animation-delay: 0s;
}
.acctmgmt #hr_bubbling_2 {
  animation-delay: 0.24s;
}
.acctmgmt #hr_bubbling_3 {
  animation-delay: 0.48s;
}
@keyframes hr-loader {
  0% {
    width: 10px;
    height: 10px;
    background-color: #E8488B;
    transform: translateY(0);
  }
  100% {
    width: 24px;
    height: 24px;
    background-color: #D10F63;
    transform: translateY(-21px);
  }
}
.acctmgmt html, .acctmgmt body {
  height: 100%;
  --mdc-filled-text-field-focus-label-text-color:var(--mdc-tab-indicator-active-indicator-color);
}
.acctmgmt body {
  margin: 0;
  font-family: "Roboto", sans-serif;
}
.acctmgmt #am-container-custom {
  background-color: #fff;
}
.acctmgmt .cdk-global-overlay-wrapper, .acctmgmt .cdk-overlay-container {
  z-index: 10000000 !important;
}
.acctmgmt input::-ms-clear {
  display: none;
  width: 0;
  height: 0;
}
.acctmgmt .mat-accordion .mat-expansion-panel:not([class*=mat-elevation-z]) {
  box-shadow: none;
}
.acctmgmt .datepicker.dropdown-menu {
  width: 100%;
  min-width: 16em;
}
.acctmgmt .datepicker .ngb-dp-month {
  width: 100%;
}
.acctmgmt .datepicker .ngb-dp-week .ngb-dp-day, .acctmgmt .datepicker .ngb-dp-week .ngb-dp-weekday {
  width: 3rem;
}
.acctmgmt .datepicker .ngb-dp-week .ngb-dp-day .btn-light, .acctmgmt .datepicker .ngb-dp-week .ngb-dp-weekday .btn-light {
  width: auto;
}
.acctmgmt .datepicker .ngb-dp-week .ngb-dp-weekday {
  color: #6a6a6a;
  font-style: normal;
}
.acctmgmt .datepicker .btn-link {
  color: #6a6a6a;
  padding: 0 0.25rem;
}
.acctmgmt .modal-scroll img {
  width: 99%;
  height: auto;
}
.acctmgmt .btn-light {
  color: #f41a8a;
  background-color: #f2f2f2;
}
.acctmgmt .ngb-dp-arrow .btn-link {
  color: black;
  padding: 0 0.25rem;
}
.acctmgmt .ngb-dp-weekday {
  color: black;
}
.acctmgmt .bg-primary {
  background-color: #e20074;
  border-radius: 2px;
}
.acctmgmt .bg-light {
  background-color: transparent !important;
}
.acctmgmt .ngb-dp-header {
  font-family: '"Helvetica Neue",Helvetica,Arial,sans-serif';
  font-weight: 700 !important;
  font-size: 14px !important;
}
.acctmgmt .ngb-dp-weekday {
  font-family: Arial !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  font-style: normal !important;
  color: #6a6a6a !important;
}
.acctmgmt .ngb-dp-month-name {
  font-size: 16px;
}
.acctmgmt .ngb-dp-navigation-chevron {
  border-width: 2px 2px 0 0;
  width: 10px;
  height: 10px;
}
.acctmgmt .min-content-height {
  min-height: 100%;
}
.acctmgmt .bs-datepicker {
  display: flex;
  align-items: stretch;
  flex-flow: row wrap;
  background: #fff;
  box-shadow: 0 0 10px 0 #aaa;
  position: relative;
  z-index: 1;
}
.acctmgmt .bs-datepicker .is-other-month {
  color: rgba(0, 0, 0, 0.25);
}
.acctmgmt .bs-datepicker-container {
  padding: 0 5px;
}
.acctmgmt .bs-datepicker-head {
  min-width: 300px;
  height: 50px;
  padding: 10px;
  border-radius: 3px 3px 0 0;
  text-align: justify;
}
.acctmgmt .bs-datepicker-head .previous span, .acctmgmt .bs-datepicker-head .next span {
  font-size: 28px;
  line-height: 24px;
}
.acctmgmt .bs-datepicker-head bs-datepicker-navigation-view {
  display: flex;
}
.acctmgmt .bs-datepicker-head bs-datepicker-navigation-view .previous {
  width: 40px;
}
.acctmgmt .bs-datepicker-head bs-datepicker-navigation-view .month-year-block {
  flex: 1;
  text-align: center;
}
.acctmgmt .bs-datepicker-head bs-datepicker-navigation-view .next {
  width: 40px;
}
.acctmgmt .bs-datepicker-body {
  padding: 10px;
  border-radius: 0 0 3px 3px;
  min-height: 232px;
  min-width: 278px;
}
.acctmgmt .bs-datepicker-body .days.weeks {
  position: relative;
  z-index: 1;
}
.acctmgmt .bs-datepicker-body table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}
.acctmgmt .bs-datepicker-body table td {
  color: #54708b;
  text-align: center;
  position: relative;
  padding: 0;
}
.acctmgmt .bs-datepicker-body table td span {
  display: block;
  margin: 0 auto;
  font-size: 13px;
  position: relative;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}
.acctmgmt .bs-datepicker-body table td:not(.disabled) span {
  cursor: pointer;
}
.acctmgmt .bs-datepicker-body table th {
  font-size: 13px;
  color: #9aaec1;
  font-weight: 400;
  text-align: center;
}
.acctmgmt .bs-datepicker-body table.days span {
  width: 32px;
  height: 32px;
  line-height: 32px;
  color: #000;
  font-family: Arial;
  font-size: 12px;
}
.acctmgmt .bs-datepicker-body table.days span.disabled {
  cursor: default;
  color: #6a6a6a;
  font-style: italic;
}
.acctmgmt .bs-datepicker-body table.years td {
  color: #e20074;
}
.acctmgmt .bs-datepicker-body table.years td span {
  width: 46px;
  height: 46px;
  line-height: 45px;
  margin: 0 auto;
  font-family: Arial;
}
.acctmgmt .bs-datepicker-body table.months td {
  text-align: left;
  color: #6a6a6a;
  font-family: Arial;
  font-style: normal;
  line-height: 1.5;
}
.acctmgmt .bs-datepicker-body table.months td span {
  padding: 6px;
  border-radius: 15px;
  color: #e20074;
  font-family: Arial;
}
.acctmgmt .bs-datepicker-head button {
  display: inline-block;
  vertical-align: top;
  padding: 0;
  height: 30px;
  line-height: 30px;
  border: 0;
  background: 0 0;
  text-align: center;
  cursor: pointer;
  color: #6a6a6a;
  transition: 0.3s;
}
.acctmgmt .bs-datepicker-head button.next, .acctmgmt .bs-datepicker-head button.previous {
  border-radius: 50%;
  width: 30px;
  height: 30px;
}
.acctmgmt .bs-datepicker-head button.current {
  border-radius: 15px;
  max-width: 155px;
  padding: 0 5px;
  font-family: Tele-Grotesk-Ultr;
  font-size: 24px;
  color: #000000;
}
.acctmgmt .bs-datepicker-head button.next, .acctmgmt .bs-datepicker-head button.previous {
  border-radius: 50%;
  width: 30px;
  height: 30px;
}
.acctmgmt .theme-green .bs-datepicker-body table td span.selected,
.acctmgmt .theme-green .bs-datepicker-body table td span[class*=select-]:after,
.acctmgmt .theme-green .bs-datepicker-body table td.selected span,
.acctmgmt .theme-green .bs-datepicker-body table td[class*=select-] span:after,
.acctmgmt .theme-green .bs-datepicker-head {
  background-color: #e20074;
  color: #fff;
}
.acctmgmt .theme-green .bs-datepicker-head {
  background: #fff;
  color: #000;
}
.acctmgmt .theme-green .bs-datepicker-body table td.week span {
  color: #5cb85c;
}
.acctmgmt .theme-green .bs-datepicker-body table.days span {
  font-size: 14px;
  color: #000;
  font-weight: 700;
}
.acctmgmt .theme-green .bs-datepicker-body table.days span.disabled, .acctmgmt .theme-green .bs-datepicker-body table.days span.is-other-month {
  font-weight: 400;
  color: #6a6a6a;
}
.acctmgmt .theme-green .bs-datepicker-body table.days span.due-date {
  border: 1px solid #E20074;
}
.acctmgmt .theme-green .bs-datepicker-body table.days span.autopay-date {
  background: #F2F2F2;
}
.acctmgmt .theme-green .bs-datepicker-body table.years td.disabled span, .acctmgmt .theme-green .bs-datepicker-body table.months td.disabled span {
  color: #ccc;
}
.acctmgmt .pagination-block .ngx-pagination {
  text-align: left;
}
.acctmgmt .tmobilelinelisting {
  min-height: 100%;
}
@media screen and (min-width: 768px) {
  .acctmgmt .vertical-wrap {
    padding: 0 48px !important;
  }
}
.acctmgmt .f-12 {
  font-size: 12px;
}
.acctmgmt .f-16 {
  font-size: 16px;
}
.acctmgmt .f-18 {
  font-size: 18px;
}
.acctmgmt .f-20 {
  font-size: 20px;
}
.acctmgmt .f-24 {
  font-size: 24px;
}
.acctmgmt .pull-right {
  float: right;
}
.acctmgmt .carousel-indicators li {
  height: 12px;
  width: 12px;
  margin: 0 10px;
  border-radius: 50%;
  background-color: #9b9b9b;
}
.acctmgmt .carousel-indicators {
  bottom: -100px;
}
.acctmgmt .bg-white {
  background-color: #fff;
}
.acctmgmt .cdk-overlay-pane {
  display: block;
}
.acctmgmt .error-circle {
  background-image: url(/assets/tfb-acctmgmt/images/icons/error.svg);
}
.acctmgmt .check-circle {
  background-image: url(/assets/tfb-acctmgmt/images/green-check-circle.svg);
}
.acctmgmt .text-red {
  color: #e8200d;
}
.acctmgmt .error-triangle {
  background-image: url(/assets/tfb-acctmgmt/images/icons/errorfilled.svg);
}
.acctmgmt .error-circle, .acctmgmt .error-triangle {
  width: 20px;
  display: inline-block;
  height: 20px;
  background-repeat: no-repeat;
  vertical-align: middle;
  margin-right: 6px;
  background-size: 18px;
}
.acctmgmt .check-circle {
  width: 20px;
  display: inline-block;
  height: 20px;
  background-repeat: no-repeat;
  vertical-align: middle;
  margin-right: 6px;
  background-size: 18px;
}
.acctmgmt a:focus, .acctmgmt button:focus, .acctmgmt textarea:focus, .acctmgmt select:focus, .acctmgmt area:focus {
  outline: 1px solid #78aeda !important;
}
.acctmgmt [role=button]:focus {
  outline: 1px solid #78aeda !important;
}
.acctmgmt iot-confirmation-modal, .acctmgmt app-package-products-modal {
  height: 100%;
}
.acctmgmt .tmobilelinelisting .mat-pseudo-checkbox.mat-pseudo-checkbox-checked, .acctmgmt .mat-pseudo-checkbox.mat-pseudo-checkbox-indeterminate {
  background: #E20074;
}
.acctmgmt .headingSize {
  font-size: 64pt !important;
}
@media only screen and (max-width: 767px) {
  .acctmgmt .headingSize {
    font-size: 40px !important;
  }
}
@media only screen and (max-width: 1024px) and (min-width: 768px) {
  .acctmgmt .headingSize {
    font-size: 56px !important;
  }
}

.dialPadDropdown .ng-select {
  border-radius: 0px;
}
.dialPadDropdown .ng-select .ng-select-container {
  outline: none;
}
.dialPadDropdown .ng-select .ng-select-container {
  min-width: 500px;
  min-height: 48px;
  border-radius: 0px;
}
.dialPadDropdown .ng-dropdown-panel {
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.06);
  min-width: 500px;
}
.dialPadDropdown .ng-select.ng-select-focused > .ng-select-container {
  background: url(/../assets/tfb-acctmgmt/images/icons/searchImage.png);
  background-size: 18px auto;
  background-repeat: no-repeat;
  background-position: left 8px center;
  padding-left: 1.5rem;
}
.dialPadDropdown .ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected, .dialPadDropdown .ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected.ng-option-marked {
  background-color: #F8F8F8;
}
.dialPadDropdown .ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-marked {
  background-color: #F8F8F8;
}
.dialPadDropdown .ng-select.ng-select-focused:not(.ng-select-opened) > .ng-select-container {
  box-shadow: none;
  border-color: #ccc;
}
.dialPadDropdown .ng-select .ng-select-container .ng-value-container .ng-input > input {
  padding-left: 1.5rem;
  margin-top: 4px;
}
.dialPadDropdown .ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-disabled {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/assets/tfb-acctmgmt/sass/variables.scss","webpack://./src/assets/tfb-acctmgmt/sass/fonts.scss","webpack://./src/styles.scss","webpack://./src/assets/tfb-acctmgmt/sass/main.scss","webpack://./src/assets/tfb-acctmgmt/sass/mixins.scss","webpack://./src/assets/tfb-acctmgmt/sass/custom-mat.scss","webpack://./src/assets/tfb-acctmgmt/sass/global.scss","webpack://./src/assets/tfb-acctmgmt/sass/master.scss","webpack://./src/assets/tfb-acctmgmt/sass/responsive.scss","webpack://./src/assets/tfb-acctmgmt/sass/customall.scss","webpack://./src/assets/tfb-acctmgmt/sass/spacing.scss","webpack://./src/assets/tfb-acctmgmt/sass/parent.scss","webpack://./src/assets/tfb-acctmgmt/sass/typography.scss","webpack://./src/assets/tfb-acctmgmt/sass/display-visibility.scss"],"names":[],"mappings":"AAAA,oBAAA;AAiBA,SAAA;AAMA,WAAA;AAoCA,cAAA;AAiDA,oBAAA;AC1GA;EACC,8BAAA;EACA,4NACC;ACIF;ADCA;EACE,gCAAA;EACA,sWACA;ACAF;ADOA;EACC,sBAAA;EACA,iQACC;ACNF;ADYA;EACC,gCAAA;EACA,4NACC;ACXF;ADgBA;EACC,8BAAA;EACA,yOACC;ACfF;ADoBA;EACC,gCAAA;EACA,sWACC;ACnBF;ADyBE;EACD,sBAAA;EACA,iJACC;EAED,gBAAA;EACA,kBAAA;ACzBD;AD2BA;EACC,sBAAA;EACA,6JACC;EAED,gBAAA;EACA,kBAAA;AC3BD;AD6BA;EACC,sBAAA;EACA,uJACC;EAED,gBAAA;EACA,kBAAA;AC7BD;AD+BA;EACC,sBAAA;EACA,mKACC;EAED,gBAAA;EACA,kBAAA;AC/BD;ADiCA;EACC,sBAAA;EACA,qJACC;EAED,gBAAA;EACA,kBAAA;ACjCD;ADmCA;EACC,sBAAA;EACA,iKACC;EAED,gBAAA;EACA,kBAAA;ACnCD;ADqCA;EACC,sBAAA;EACA,iJACC;EAED,gBAAA;EACA,kBAAA;ACrCD;ADuCA;EACC,sBAAA;EACA,6JACC;EAED,gBAAA;EACA,kBAAA;ACvCD;ADyCA;EACC,sBAAA;EACA,2JACC;EAED,gBAAA;EACA,kBAAA;ACzCD;AD2CA;EACC,sBAAA;EACA,uKACC;EAED,gBAAA;EACA,kBAAA;AC3CD;AD6CA;EAAiB,wCAAA;AC1CjB;;AAxFA;EACI,mDAAA;EACA,6CAAA;EACA,mDAAA;EACA,6FAAA;EACA,oGAAA;EACA,8FAAA;EACA;sFAAA;EAEA,gFAAA;AA2FJ;;AAtFA;EClBA,gCAAA;EHAA,oBAAA;EAiBA,SAAA;EAMA,WAAA;EAoCA,cAAA;EAiDA,oBAAA;EIfA;;;;GAAA;EClFA,0HAAA;EACA,0HAAA;EAaA,0HAAA;EAKA,4HAAA;EAgCA,0HAAA;EACA,0HAAA;EAqBA,0HAAA;EAKA,gIAAA;EACA,gIAAA;EACA,gIAAA;EAkEA,4HAAA;EAOA,4HAAA;EACA,4HAAA;EAUA,4HAAA;EAYA,8HAAA;EAIA,8HAAA;EAiBA,4HAAA;EF3MQ,2DAAA;EGLR,UAAA;EAsCA,WAAA;EAcA,0DAAA;EAEA,WAAA;EAoDA,8BAAA;EA0OA,8BAAA;EAOA,mBAAA;EAgCA,6BAAA;EAwEA,2BAAA;ECgFA,yHAAA;EClZA,+CAAA;ERjIA,oBAAA;EAiBA,SAAA;EAMA,WAAA;EAoCA,cAAA;EAiDA,oBAAA;ES3FA,4HAAA;EAcA,iBAAA;EAqCA,eAAA;EACA,2BAAA;EAkCA,yBAAA;EA0DA,4HAAA;EAEA,4HAAA;EAKE,gIAAA;EAaF,gIAAA;EAQA,gIAAA;EAIA,gIAAA;EAIA,4HAAA;EA0DA,gIAAA;ET/PA,oBAAA;EAiBA,SAAA;EAMA,WAAA;EAoCA,cAAA;EAiDA,oBAAA;EUzGA,eAAA;EAOA,gBAAA;EAQA,iBAAA;EASA,kBAAA;EAQA,gBAAA;EAQA,mBAAA;EA4KA,eAAA;EVvNA,oBAAA;EAiBA,SAAA;EAMA,WAAA;EAoCA,cAAA;EAiDA,oBAAA;EW3GA,WAAA;ATsLA;ADrLA;EACC,8BAAA;EACA,4NACC;ACsLF;ADjLA;EACE,gCAAA;EACA,sWACA;ACkLF;AD3KA;EACC,sBAAA;EACA,iQACC;AC4KF;ADtKA;EACC,gCAAA;EACA,4NACC;ACuKF;ADlKA;EACC,8BAAA;EACA,yOACC;ACmKF;AD9JA;EACC,gCAAA;EACA,sWACC;AC+JF;ADzJE;EACD,sBAAA;EACA,iJACC;EAED,gBAAA;EACA,kBAAA;ACyJD;ADvJA;EACC,sBAAA;EACA,6JACC;EAED,gBAAA;EACA,kBAAA;ACuJD;ADrJA;EACC,sBAAA;EACA,uJACC;EAED,gBAAA;EACA,kBAAA;ACqJD;ADnJA;EACC,sBAAA;EACA,mKACC;EAED,gBAAA;EACA,kBAAA;ACmJD;ADjJA;EACC,sBAAA;EACA,qJACC;EAED,gBAAA;EACA,kBAAA;ACiJD;AD/IA;EACC,sBAAA;EACA,iKACC;EAED,gBAAA;EACA,kBAAA;AC+ID;AD7IA;EACC,sBAAA;EACA,iJACC;EAED,gBAAA;EACA,kBAAA;AC6ID;AD3IA;EACC,sBAAA;EACA,6JACC;EAED,gBAAA;EACA,kBAAA;AC2ID;ADzIA;EACC,sBAAA;EACA,2JACC;EAED,gBAAA;EACA,kBAAA;ACyID;ADvIA;EACC,sBAAA;EACA,uKACC;EAED,gBAAA;EACA,kBAAA;ACuID;ADrIA;EAAiB,wCAAA;ACwIjB;AExME;EAcE;IAAK,UAAA;IAA8C,iCAAA;EFwOrD;EEvOE;IAAI,UAAA;EF0ON;AACF;AE1PE;EAkBE;IAAK,UAAA;EFgSP;EE/RE;IAAI,UAAA;IAA8C,iCAAA;EFoSpD;EEnSE;IAAG,UAAA;EFsSL;AACF;AGjYA;;;;EAII,4BAAA;AHmYJ;AGhYA;EACI,cAAA;AHkYJ;AG7XA;EACI,0HAAA;AH+XJ;AG9XI;EACI,cLfK;EKgBL,iBAAA;AHgYR;AG5XA;EACI,yBLrBS;AEmZb;AG1XA;EACI,aAAA;AH4XJ;AGxXA;EACI,yBAAA;EACA,WAAA;AH0XJ;AGvXA;EACI,8BAAA;EACA,sBAAA;AHyXJ;AGtXA;EACI,yBAAA;AHwXJ;AGrXA;EACI,yBAAA;AHuXJ;AGpXA;EACI,cAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;AHsXJ;AGnXA;EACI,eAAA;AHqXJ;AGjXA;EAEQ,gBAAA;EACA,0HAAA;EAIJ,0HAAA;AH+WJ;AGlXQ;EACI,eAAA;AHoXZ;AGjXI;EAGI,yBAAA;EACA,WAAA;EACA,UAAA;AHiXR;AG/WI;EACI,+GAAA;EACA,mBAAA;AHiXR;AG7WA;EACI,yBAAA;EACA,WAAA;AH+WJ;AG1WA;EACG,sBAAA;EA0CC,gIAAA;AHmUJ;AG5WI;EAGI,4BL4BC;EK3BL,4HAAA;EASA,gIAAA;EAEA,4HAAA;EACA,4HAAA;EAiBA,4HAAA;AHmVJ;AG/WI;EACI,4BLyBC;EKxBD,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;AHiXR;AG9WI;EAA4E,wBAAA;AHiXhF;AG9WI;EACI,iBAAA;EACA,4HAAA;AHgXR;AG/WQ;EAEI,mELkBJ;EKjBI,4BAAA;EACA,0BAAA;EACA,SAAA;EACA,WAAA;EACA,kCAAA;EACD,YAAA;EACC,YAAA;AHgXZ;AG3WI;EAEG,eAAA;AH4WP;AGtWI;EDtFA,4BJ2EK;EI1EL,eCsF0B;EDrF1B,mBCqF+B;EDpF/B,sBCoFsC;EDnFtC,cJ9BI;EI+BJ,cCkFoD;EAChD,WAAA;AH6WR;AG3WI;EACI,gIAAA;EAII,4HAAA;AH0WZ;AG7WQ;ED5FJ,4BJ2EK;EI1EL,eC4F8B;ED3F9B,mBC2FmC;ED1FnC,sBC0F0C;EDzF1C,cJrDS;EIsDT,cCwF6D;AHoXjE;AGjXY;EACI,cAAA;EACA,sELLP;EKMO,4BAAA;EACA,qBAAA;EACA,YAAA;AHmXhB;AG5WA;EACI,cAAA;AH8WJ;AG7WI;EACI,mBLhKK;AE+gBb;AGvWY;EACI,cLzKH;AEkhBb;AGnWA;EACI,mBAAA;AHqWJ;AGpWI;EAFJ;IAGQ,0BAAA;EHuWN;AACF;AGpWA;EACI,gBAAA;AHsWJ;AGlWA;EACI,qBAAA;AHoWJ;AGjWA;EACI,kBAAA;AHmWJ;AG5VA;EACI,0BAAA;AH8VJ;AG5VA;EACI,mBAAA;EACA,WAAA;AH8VJ;AG1VA;EACI,iBAAA;AH4VJ;AGxVA;EACI,sBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AH0VJ;AGvVA;EACI,wBAAA;EACA,0BAAA;AHyVJ;AGtVA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;AHwVJ;AGtVA;EACI,aAAA;AHwVJ;AGtVA;EACI,cAAA;AHwVJ;AGrVA;EACI,YAAA;EACA,wCAAA;EACA,wBAAA;AHuVJ;AGrVA;EACI,YAAA;EACA,mBAAA;AHuVJ;AGpVA;EACI,cAAA;AHsVJ;AGnVA;EACI,qBAAA;AHqVJ;AGnVA;;;;EAII,qBAAA;EACA,yBAAA;AHqVJ;AGnVA;EACI,WAAA;AHqVJ;AGlVA;EACI,iDAAA;EACA,0BAAA;AHoVJ;AGlVA;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,8GAAA;AHoVJ;AGlVA;EACI,kBAAA;AHoVJ;AGlVA;EACI,WAAA;EACA,YAAA;AHoVJ;AGlVA;EACI,uCAAA;EACA,2CAAA;AHoVJ;AGjVA;EACI,WAAA;AHmVJ;AGjVA;EACI,yBAAA;EACA,eAAA;AHmVJ;AGjVA;EACI,qBAAA;EACA,qCAAA;AHmVJ;AGjVA;EACI,aAAA;AHmVJ;AGjVA;EACI,iCAAA;AHmVJ;AGhVA;EAEI,yHAAA;EACA,YAAA;AHkVJ;AG/UA;EACI,eAAA;AHiVJ;AG/UA;EACI,SAAA;AHiVJ;AG/UA;EACI,wCAAA;AHiVJ;AG/UA;EACI,yBAAA;AHiVJ;AG/UA;EACI,eAAA;AHiVJ;AG/UA;EACI,YAAA;EACA,kBAAA;AHiVJ;AG/UA;EACI,qCAAA;AHiVJ;AG/UA;EACI,aAAA;AHiVJ;AG/UA;EACI,mBAAA;EACA,kBAAA;AHiVJ;AG/UA;EACI,gBAAA;AHiVJ;AG/UA;EACI,sBAAA;AHiVJ;AG/UA;EACI,cAAA;EACA,iBAAA;AHiVJ;AG3UA;EACA,4BAAA;AH6UA;AG1UA;EACI,0BAAA;AH4UJ;AG1UA;EACI,qBAAA;AH4UJ;AG1UA;EACI,YAAA;AH4UJ;AG1UA;EACI,wBAAA;AH4UJ;AGzUA;EAEI,mELvPI;EKwPJ,4BAAA;EACA,0BAAA;EACA,SAAA;EACA,WAAA;EACA,kCAAA;EACD,YAAA;EACC,YAAA;AH0UJ;AGvUA;EACI,SAAA;AHyUJ;AGvUA;EACI,yBAAA;AHyUJ;AGvUA;EACI,oCAAA;EACA,WAAA;AHyUJ;AGxUI;EACI,WAAA;AH0UR;AGvUA;EACI,mBAAA;AHyUJ;AGvUA;EACI,sBAAA;AHyUJ;AGvUA;EACI,sBAAA;AHyUJ;AI1sBA;EACE,cNxBiB;EMyBjB,iBAAA;EACA,gBAAA;AJ4sBF;AIxsBE;EACE,yBAAA;AJ0sBJ;AIrsBA;EACE,gBN9BW;EM+BX,eAAA;EACA,gBAAA;AJusBF;AIpsBA;EACE,UAAA;AJssBF;AIrsBE;EACE,qBAAA;AJusBJ;AI9rBE;EACE,mBAAA;EFjBA,gCAAA;EEmBA,oBAAA;AJgsBJ;AI/rBI;EACE,eAAA;EACA,yBAAA;EACA,cN3Da;AE4vBnB;AI7rBI;EF3BA,gCAAA;EE6BE,mBAAA;AJ+rBN;AI7rBI;EACE,mBAAA;AJ+rBN;AI5rBE;EACE,SAAA;AJ8rBJ;AI5rBE;EACE,WAAA;EACA,kBAAA;AJ8rBJ;AI1rBA;EACE,kBAAA;AJ4rBF;AIzrBA;EACE,6CAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AJ2rBF;AIzrBE;EACE,gBAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;AJ2rBJ;AIrrBA;EACE,eAAA;EACA,oBAAA;EACA,oBAAA;EACA,gBAAA;AJurBF;AIrrBE;EACE,gBAAA;EACA,eAAA;AJurBJ;AIrrBI;EACE,qBAAA;EACA,cNtHY;AE6yBlB;AIprBE;EACE,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;AJsrBJ;AIrrBI;EACE,4BAAA;AJurBN;AIprBE;EACE,0BAAA;AJsrBJ;AIprBE;EACE,eAAA;AJsrBJ;AInrBI;EACE,WNlIO;EMmIP,kBNnIO;AEwzBb;AIprBM;EAIE,WAAA;EACA,yBNlJK;EMmJL,qBNnJK;AEs0Bb;AI/qBE;EACE,yBNxJS;EMyJT,WAAA;EACA,qBN1JS;EM2JT,cAAA;AJirBJ;AIhrBI;EAME,yBNjKY;EMkKZ,qBNlKY;EMmKZ,iBAAA;EACA,mBAAA;AJ6qBN;AI3qBI;EAOE,yBNzKa;EM0Kb,qBN1Ka;EM2Kb,WNvKO;AE80Bb;AIpqBE;GJsqBA,eIrqBE;EACA,WAAA;EACA,kBAAA;EACA,gDAAA;EACA,yBAAA;GJsqBF,yBIrqBE;EAWA,2DAAA;EACA,2BAAA;EACA,sBAAA;GJgqBF,SI/pBE;EACA,qCAAA;EACA,uEAAA;EACA,4BAAA;EAGA,kBAAA;EACA,wHAAA;EAKA,iEAAA;GJ4pBF,OI3pBE;EAKA,iFAAA;AJ0pBJ;AIxpBI;EAWE,cAAA;EACA,yBAAA;GJgpBJ,yBI/oBI;AJgpBN;AI9oBI;EAEE,0BAAA;AJ+oBN;AI7oBI;GJ+oBF,cI9oBI;AJ+oBN;AI7oBI;EAEE,cAAA;EACA,qBAAA;EACA,4BAAA;EAIA,2CAAA;AJ8oBN;AI5oBI;EACE,yBAAA;EACA,0CAAA;EACA,oBAAA;AJ8oBN;AI5oBI;EAEE,sBAAA;EACA,UAAA;EAKA,8EAAA;AJ2oBN;AIxoBI;EAEE,eAAA;EACA,sBAAA;EACA,aAAA;EACA,yBAAA;EAGA,gBAAA;EACA,cAAA;EACA,yBAAA;GJyoBJ,yBIxoBI;AJyoBN;AIloBE;EACE,SAAA;EACA,UAAA;EACA,6BAAA;EACA,cAAA;AJooBJ;AIloBE;EACE,gBAAA;EACA,iBAAA;AJooBJ;AIloBE;EACE,WAAA;AJooBJ;AI/nBE;EACE,gBAAA;AJioBJ;AI5nBE;EACE,uBAAA;AJ8nBJ;AI1nBA;EACE,wCAAA;EACA,4BAAA;EACA,mBAAA;EACA,uCAAA;EACA,yBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;AJ4nBF;AIznBA;EACE,gCAAA;EACA,uBAAA;EACA,8BAAA;EACA,kDAAA;AJ2nBF;AIxnBA;EACE,yBAAA;AJ0nBF;AIvnBA;EACE,uDAAA;EACA,4BAAA;EACA,0BAAA;AJynBF;AItnBA;EACE,kBAAA;EACA,4BAAA;EACE,gCAAA;EACA,0BAAA;AJwnBJ;AIrnBA;EACE,qBAAA;AJunBF;AIrnBA;EACE,qBAAA;AJunBF;AIrnBA;EACE,qBAAA;AJunBF;AIrnBA;EACE,qBAAA;AJunBF;AIrnBA;EACE,qBAAA;AJunBF;AIrnBA;EAAY,kBAAA;AJwnBZ;AItnBI;EADJ;IAEM,8BAAA;EJynBJ;AACF;AIvnBI;EALJ;IAMM,+BAAA;EJ0nBJ;AACF;AIxnBI;EATJ;IAUM,+BAAA;EJ2nBJ;AACF;AIrnBA;;;EAGE,mBN/XW;AEs/Bb;AInnBE;EACI,sBAAA;AJqnBN;AInnBE;EACI,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,YAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,gCAAA;AJqnBN;AInnBU;EACI,kBAAA;AJqnBd;AIpnBc;EACI,YAAA;AJsnBlB;AIpnBc;EACI,mBAAA;EACA,WAAA;AJsnBlB;AIpnBc;EACI,cAAA;AJsnBlB;AIpnBc;EACI,mBAAA;EACA,WAAA;AJsnBlB;AIlnBM;EACI,UAAA;AJonBV;AIhnBE;EACI,kBAAA;EACA,gBAAA;EACA,WAAA;AJknBN;AI/mBM;EACI,cAAA;EACA,eAAA;EACA,UAAA;EACA,mBAAA;EACA,mBAAA;AJinBV;AI7mBA;EACE,mBAAA;AJ+mBF;AI5mBE;EACI,UAAA;EACA,gBAAA;EACA,sBAAA;AJ8mBN;AIzmBE;EADF;IAEI,eAAA;EJ4mBF;AACF;AIzmBA;EACE,qBAAA;EACA,0BAAA;EACA,gCAAA;AJ2mBF;AIxmBA;EACE,eAAA;AJ0mBF;AIvmBA;EACE,WAAA;EACA,6BAAA;EACA,6BAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;AJymBF;AItmBA;EACE,MAAA;EACA,OAAA;EACA,YAAA;EACA,eAAA;EAGA,kBAAA;AJwmBF;AIpmBA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,6BAAA;EACA,MAAA;EACA,WAAA;AJsmBF;AIpmBA;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;AJsmBF;AIpmBA;EACE,4BAAA;EACA,qBAAA;EACA,YAAA;EACA,WAAA;AJsmBF;AInmBA;EACE,WAAA;EACA,qBAAA;EACA,kCAAA;EACA,mCAAA;EACA,6BAAA;EACA,uCAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;AJqmBF;AIlmBA;EACE,WAAA;EACA,qBAAA;EACA,kCAAA;EACA,mCAAA;EACA,6BAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;AJomBF;AK7nCA;EACI,qBAAA;EACA,cPiCqB;EOhCrB,kBP6HK;EO5HL,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,sBAAA;EACA,sBAAA;AL+nCJ;AK9nCI;EACI,cPwBiB;EOvBjB,qBAAA;ALgoCR;AK7nCA;EACI,kBPgHK;EO/GL,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,qBAAA;EACA,cPYqB;AEmnCzB;AK7nCA;EACI,4BPmGK;EOlGP,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,sBAAA;EACA,iBAAA;EACA,WP2BM;AEomCR;AK9nCE;EACE,WPyBI;EOxBJ,0BAAA;ALgoCJ;AK7nCA;EACI,8BPqFK;EOpFL,iBAAA;EACA,cPnBI;EOoBJ,sBAAA;EACA,iBAAA;EACA,oBAAA;AL+nCJ;AK7nCI;EARJ;IASQ,eAAA;IACA,iBAAA;ELgoCN;AACF;AK7nCA;EACI,kBPyEK;EOxEL,eAAA;EACA,cPjCI;AEgqCR;AK3nCA;EACI,eAAA;AL6nCJ;AK3nCA;EACI,qBAAA;EHfA,kBJ8EK;EI7EL,eGesB;EHdtB,mBGc2B;EHb3B,sBGakC;EHZlC,cJ9BI;EI+BJ,cGWgD;ALkoCpD;AKhoCA;EHlBI,kBJ8EK;EI7EL,eGkBsB;EHjBtB,mBGiB2B;EHhB3B,sBGgBkC;EHflC,cGeyC;EHdzC,iBGciD;ALuoCrD;AKroCA;EACE,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EHzBE,8BJ4EK;EI3EL,eGyBoB;EHxBpB,mBGwByB;EHvBzB,sBGuBgC;EHtBhC,cJ9BI;EI+BJ,iBGqB8C;AL4oClD;AKvoCI;EADJ;IAEQ,eAAA;IACA,iBAAA;EL0oCN;AACF;AKxoCA;EACI,eAAA;EACA,iBAAA;AL0oCJ;AKxoCI;EAJJ;IAKQ,eAAA;IACA,iBAAA;EL2oCN;AACF;AKzoCA;EACI,eAAA;EACA,iBAAA;AL2oCJ;AKzoCI;EAJJ;IAKQ,eAAA;IACA,iBAAA;EL4oCN;AACF;AK1oCA;EHtDI,4BJ2EK;EI1EL,eGsDsB;EHrDtB,mBGqD2B;EHpD3B,sBGoDkC;EHnDlC,cGmDyC;EHlDzC,iBGkDiD;EACjD,sBAAA;EACA,gBAAA;ALipCJ;AKhpCI;EAJJ;IAKQ,eAAA;ELmpCN;AACF;AKjpCA;EACI,cPpGY;EIqCZ,4BJ2EK;EI1EL,eG+DsB;EH9DtB,mBG8D2B;EH7D3B,sBG6DkC;EH5DlC,cJzCY;EI0CZ,cG2DwD;EACxD,sBAAA;ALwpCJ;AKtpCI;EALJ;IAMQ,eAAA;ELypCN;AACF;AKvpCE;EAEE,yBAAA;EHzEA,8BJ4EK;EI3EL,eGyEsB;EHxEtB,mBGwE2B;EHvE3B,sBGuEkC;EHtElC,cJtBqB;EIuBrB,gBGqEiE;AL6pCrE;AK3pCE;EH5EE,4BJ2EK;EI1EL,eG4EsB;EH3EtB,mBG2E2B;EH1E3B,sBG0EkC;EHzElC,cJ9BI;EI+BJ,gBGwEgD;ALkqCpD;AKhqCE;EH/EE,8BJ4EK;EI3EL,eG+EsB;EH9EtB,iBG8E2B;EH7E3B,qBG6EgC;EH5EhC,cJ9BI;EI+BJ,gBG2E6C;ALuqCjD;AKrqCE;EHlFE,8BJ6EK;EI5EL,eGkFsB;EHjFtB,iBGiF2B;EHhF3B,iBGgFgC;EH/EhC,cJrDS;EIsDT,gBG8E8C;AL4qClD;AK3qCI;EACI,cPtIK;AEmzCb;AK1qCE;EACE,kBPXK;EOYL,eAAA;EACA,cPzIS;EO0IT,qBAAA;EACA,gBAAA;AL4qCJ;AK1qCI;EAPF;IAQM,eAAA;EL6qCN;AACF;AK1qCC;EACG,kBAAA;AL4qCJ;AK3qCI;EACI,WAAA;AL6qCR;AK3qCI;EACI,2CAAA;EACA,sBPhGA;EOiGA,oCAAA;AL6qCR;AK1qCQ;EACI,kBAAA;EACA,gCAAA;AL4qCZ;AK3qCY;EACI,qBAAA;EACA,WAAA;AL6qChB;AK1qCQ;EAEI,mBAAA;AL2qCZ;AKvqCY;EACI,YAAA;ALyqChB;AKxqCgB;EAEI,oCAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;ALyqCpB;AKvqCoB;EAAM,mBAAA;AL0qC1B;AKzqCoB;EAAQ,mBPnKpB;AE+0CR;AK1qCoB;EAAO,gBPhInB;AE6yCR;AK3qCoB;EAAY,mBAAA;AL8qChC;AK7qCoB;EAAO,mBAAA;ALgrC3B;AK3qCQ;EACI,kBAAA;EACA,kBAAA;AL6qCZ;AK3qCY;EACI,aAAA;EACA,cAAA;AL6qChB;AKtqCA;EACI,cAAA;EACA,UAAA;EACA,kBAAA;ALwqCJ;AKpqCY;EACA,6BAAA;EACA,iBAAA;EACC,yBAAA;EACA,uBAAA;EACA,cPpMa;EOqMV,cAAA;ALsqChB;AKnqCY;EACQ,sBAAA;EACA,cAAA;EACA,YAAA;ALqqCpB;AKlqCoB;EACI,YAAA;ALoqCxB;AKjqCgB;EH1LZ,kBJ8EK;EI7EL,eG0LsC;EHzLtC,iBGyL2C;EHxL3C,qBGwLgD;EHvLhD,uBGuLsD;EHtLtD,cGsLuE;ALwqC3E;AKpqCY;EACI,sBAAA;EACA,cAAA;EACA,2BAAA;ALsqChB;AKpqCgB;EACI,aAAA;ALsqCpB;AKhqCgB;EACI,kBAAA;ALkqCpB;AKjqCoB;EAEI,WAAA;EACA,YAAA;EACA,qBAAA;EAEA,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;ALiqCxB;AK9pCgB;EAEI,aAAA;AL+pCpB;AK7pCgB;EACI,YAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;AL+pCpB;AK9pCoB;EAEI,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AL+pCxB;AK7pCoB;EACI,mBAAA;AL+pCxB;AK9pCwB;EACK,WAAA;EACL,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;ALgqCxB;AK5pCoB;EACI,wEP3KhB;AEy0CR;AKvpCoB;EACI,WAAA;EACA,YAAA;EACA,qBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;ALypCxB;AKrpCgB;EAEI,wBAAA;ALspCpB;AKnpCgB;EACI,YAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;ALqpCpB;AKnpCoB;EACI,WAAA;EACA,YAAA;EACA,qBAAA;EACA,uBAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;ALqpCxB;AKnpCoB;EACI,mBAAA;ALqpCxB;AKnpCwB;EACI,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;ALqpC5B;AKlpCoB;EACI,wEP1OhB;AE83CR;AK/oCY;EHzUR,kBJ8EK;EI7EL,eGyUkC;EHxUlC,iBGwUuC;EHvUvC,qBGuU4C;EHtU5C,cJ9BI;EI+BJ,cGqUyD;ALspC7D;AKrpCgB;EACI,uBAAA;EACA,qBAAA;EACA,cPtWM;AE6/C1B;AKhpCA;EACI,mBAAA;EAEA,qBAAA;ALipCJ;AK9oCA;EACI,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBPxXsB;EOyXzB,2BAAA;EACA,2BAAA;EACG,WAAA;EACA,WPzVI;EO0VJ,YAAA;EACA,gBAAA;EACH,kBAAA;EACA,iBAAA;EACA,eAAA;EACG,8BAAA;EACH,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,sBAAA;EACG,qBAAA;EACA,kBAAA;EAaA,eAAA;ALooCJ;AKhpCI;EACI,iBAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,sBAAA;EACA,qBAAA;EACA,kBAAA;ALkpCR;AK9oCI;EACI,0EAAA;EACN,qFAAA;ALgpCF;AK9oCQ;EACI,yBP7YD;EO8YC,cPnZa;AEmiDzB;AK7oCI;EACF,yBP/Z0B;EOga1B,0EAAA;EACA,0BAAA;AL+oCF;AK7oCC;EACC,qBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;EACA,gBAAA;AL+oCF;AK7oCC;EACC,yBP9ZS;EO+ZT,cPvauB;EOwavB,eAAA;EACA,gBAAA;AL+oCF;AK7oCE;EACC,yBPpaQ;EOqaR,cP7asB;EO8atB,eAAA;EACA,gBAAA;AL+oCH;AK5oCI;EACI,yBP3aG;EO4aH,cPjbiB;AE+jDzB;AK1oCA;EACC,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBPhaO;EOiaP,2BAAA;EACA,2BAAA;EACA,cPxcO;EOycP,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,sBAAA;EACA,yBAAA;EACG,qBAAA;EACA,kBAAA;AL4oCJ;AK3oCC;EACC,yBAAA;EACA,cAAA;EACA,kFAAA;AL6oCF;AK3oCC;EACC,yBAAA;EACA,cAAA;EACA,0BAAA;AL6oCF;AK3oCC;EACC,sBAAA;EACA,qBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;AL6oCF;AK3oCC;EACC,yBAAA;EACA,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;AL6oCF;AKxoCA;EACI,sBAAA;EACA,mBAAA;AL0oCJ;AKzoCI;EACI,gGAAA;EACA,qBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,0BAAA;AL2oCR;AKvoCA;EACI,oBAAA;ALyoCJ;AKvoCA;EACI,yBAAA;EACA,mBAAA;ALyoCJ;AKtoCA;EACI,WAAA;ALwoCJ;AKroCA;EACC,eAAA;EACA,SAAA;EACG,QAAA;EACH,qBAAA;EACA,kBAAA;EACA,uBAAA;EACA,6BAAA;EACA,gBAAA;EACA,eAAA;ALuoCD;AKroCA;EACC,mBAAA;ALuoCD;AKroCA;EACC,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,uBAAA;EACA,oCAAA;ALuoCD;AKtoCC;EACC,UAAA;EACA,ePxhBsB;EOyhBtB,0BAAA;EACA,oBAAA;EACA,2DAAA;ALwoCF;AKroCA;EACI,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,uBAAA;EACH,oCAAA;ALuoCD;AKtoCC;EACC,UAAA;EACA,eAAA;EACA,0BAAA;EACA,oBAAA;EACA,2DAAA;ALwoCF;AKroCA;EACC,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,qBAAA;EACA,6BAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;ALuoCD;AKroCA;EACC,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,uBAAA;EACA,oCAAA;ALuoCD;AKtoCC;EACC,UAAA;EACA,ePpkBsB;EOqkBtB,0BAAA;EACA,oBAAA;EACA,2DAAA;ALwoCF;AKroCA;EACC;IACC,wBAAA;IACA,oBAAA;ELuoCA;EKroCD;IACC,yBAAA;IACA,sBAAA;ELuoCA;EKroCD;IACC,wBAAA;IACA,uBAAA;ELuoCA;AACF;AKroCA;EACC;IAEC,yBAAA;ELsoCA;AACF;AKpoCA;EACI,eAAA;ALsoCJ;AKpoCA;EACI,eAAA;ALsoCJ;AKpoCA;EACI,WAAA;ALsoCJ;AKloCA;EACI,YAAA;ALooCJ;AKloCA;EACI,4BAAA;ALooCJ;AKjoCA;EACI,eAAA;ALmoCJ;AKjoCA;EACI,kBAAA;ALmoCJ;AKjoCA;EACI,eAAA;ALmoCJ;AKjoCA;EACI,gBAAA;ALmoCJ;AKjoCA;EACI,WAAA;ALmoCJ;AKhoCA;EACI,gCAAA;ALkoCJ;AKhoCA;EACI,qBAAA;ALkoCJ;AK/nCA;EACI,WAAA;EACA,kBAAA;EACA,aAAA;ALioCJ;AK/nCA;EACI,yBAAA;ALioCJ;AK9nCA;EACI,kBAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;ALgoCJ;AK9nCA;EACI,kBAAA;EACA,eAAA;EACA,cAAA;ALgoCJ;AK9nCA;EACI,4BAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,eAAA;EACA,6BAAA;ALgoCJ;AK9nCA;EACI,gBAAA;ALgoCJ;AK7nCA;EACI,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;AL+nCJ;AK9nCI;EACI,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;EACA,iBAAA;ALgoCR;AK9nCI;EACI,8BAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;ALgoCR;AK7nCA;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,2BAAA;EACA,kBAAA;AL+nCJ;AK7nCA;EACI,oEPtlBK;EOulBL,4BAAA;EACA,mBAAA;EACA,gCAAA;EACA,yBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;AL+nCJ;AK7nCA;EACI,8DP/lBK;EOgmBL,4BAAA;EACA,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;AL+nCJ;AK7nCA;EACI,gBAAA;AL+nCJ;AK7nCA;EACI,cAAA;AL+nCJ;AK7nCA;EACI,qBAAA;AL+nCJ;AK7nCA;EACI,oEPlnBK;EOmnBL,4BAAA;EACA,mBAAA;EACA,gCAAA;EACA,yBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;AL+nCJ;AK3nCI;EHjsBF,oBAAA;AFm0DF;AKhoCI;EHnsBF,qBAAA;AF00DF;AKpoCA;EACA,iBAAA;ALsoCA;AKloCA;EACI,WAAA;EACA,WAAA;EACA,sBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;ALooCJ;AKloCI;EARJ;IASM,YAAA;ELqoCJ;AACF;AKpoCI;EACE,WAAA;ALsoCN;AKroCM;EACE,yBAAA;ALuoCR;AKnoCI;EACE,eAAA;EACA,OAAA;EACA,SAAA;EACA,qCAAA;EACI,UAAA;EAEJ,mCAAA;ALooCN;AKjoCE;EACI,mBAAA;ALmoCN;AKjoCE;EACI,qBAAA;ALmoCN;AKjoCE;EAAE,aAAA;ALooCJ;AKloCE;EACE,4BAAA;EACA,WAAA;EAEA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,0EAAA;EACA,0BAAA;EACA,4BAAA;EACA,gCAAA;EACA,8BP5sBK;EO6sBL,eAAA;EACA,cAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;ALmoCJ;AKjoCI;EAlBF;IAmBM,gBAAA;ELooCN;AACF;AKloCI;EAtBF;IAuBK,eAAA;IACA,gCAAA;ELqoCL;AACF;AKnoCA;EACI,4BAAA;ALqoCJ;AKloCA;EAEI,kBAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,8FAAA;EAEA,8BAAA;EACA,eAAA;EACA,cAAA;EACA,6BAAA;ALkoCJ;AKjoCI;EAbJ;IAcQ,eAAA;ELooCN;AACF;AKhoCA;EACI,WAAA;EACA,WAAA;EACA,kBAAA;ALkoCJ;AKhoCI;EACI,kBAAA;EACA,eAAA;ALkoCR;AKjoCQ;EACI,cAAA;ALmoCZ;AKjoCQ;EACI,iBAAA;ALmoCZ;AKjoCQ;EACI,cAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;ALmoCZ;AKjoCQ;EAEI,cPl2BS;EOm2BT,gBAAA;EACA,eAAA;EAEA,sBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,6BAAA;ALioCZ;AK/nCQ;EACI,gBAAA;EACA,wBAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;EACA,cAAA;EAEA,sBAAA;EACA,eAAA;EACA,cPv4BJ;EOw4BI,kBAAA;EACA,UAAA;EACA,gCAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;ALgoCZ;AK/nCY;EACI,aAAA;EACA,cPj5BR;EOk5BQ,aAAA;EACA,gCAAA;ALioChB;AKhoCgB;EACI,8BAAA;EACA,iBAAA;EACA,eAAA;ALkoCpB;AK/nCY;EACI,aAAA;EACA,gCAAA;ALioChB;AKhoCgB;EACI,4CAAA;EACA,iBAAA;EACA,eAAA;ALkoCpB;AK9nCQ;EACI,gBAAA;EACA,wBAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;EACA,cAAA;EAEA,sBAAA;EACA,eAAA;EACA,cP/6BJ;EOg7BI,kBAAA;EACA,UAAA;EACA,gCAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;AL+nCZ;AK9nCY;EACI,aAAA;EACA,cPz7BR;EO07BQ,aAAA;EACA,gCAAA;ALgoChB;AK/nCgB;EACI,8BAAA;EACA,iBAAA;EACA,eAAA;ALioCpB;AK9nCY;EACI,aAAA;EACA,gCAAA;ALgoChB;AK/nCgB;EACI,4CAAA;EACA,iBAAA;EACA,eAAA;ALioCpB;AK7nCQ;EACI,gBAAA;EACA,wBAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;EACA,cAAA;EAEA,sBAAA;EACA,eAAA;EACA,cPv9BJ;EOw9BI,kBAAA;EACA,UAAA;EACA,gCAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;AL8nCZ;AK7nCY;EACI,aAAA;EACA,cPj+BR;EOk+BQ,aAAA;EACA,gCAAA;AL+nChB;AK9nCgB;EACI,8BAAA;EACA,iBAAA;EACA,eAAA;ALgoCpB;AK7nCY;EACI,aAAA;EACA,gCAAA;AL+nChB;AK9nCgB;EACI,yBAAA;EACA,2CAAA;EACA,iBAAA;EACA,eAAA;ALgoCpB;AK5nCQ;EACI,aAAA;AL8nCZ;AK5nCQ;EACI,aAAA;EACA,cP1/BJ;EO2/BI,aAAA;EACA,2CAAA;AL8nCZ;AK5nCQ;EACI,aAAA;EACA,cPhgCJ;EOigCI,aAAA;EACA,2CAAA;AL8nCZ;AK1nCQ;EACI,cPz/BS;EO0/BT,gBAAA;EACA,eAAA;EAEA,sBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,6BAAA;EACA,MAAA;AL2nCZ;AKxnCY;EACI,aAAA;AL0nChB;AKznCgB;EACI,eAAA;EACA,UAAA;AL2nCpB;AKxnCY;EACI,aAAA;EACA,cP7hCR;EO8hCQ,aAAA;EACA,gCAAA;AL0nChB;AKznCgB;EACI,eAAA;EACA,UAAA;AL2nCpB;AKpnCA;EACI,WAAA;EACA,WAAA;ALsnCJ;AKnnCA;EACC,WAAA;EACA,aAAA;ALqnCD;AKnnCA;EACC,gCAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,eAAA;EACA,WAAA;ALqnCD;AKnnCA;EACC,MAAA;EACA,OAAA;EACA,YAAA;EACA,eAAA;EAEA,kBAAA;ALonCD;AKnnCC;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EAEA,kBAAA;EACA,eAAA;ALonCF;AKnnCE;EACC,eAAA;EACA,eAAA;ALqnCH;AKnnCE;EACC,eAAA;EACA,eAAA;ALqnCH;AKnnCE;EACC,YAAA;ALqnCH;AKlnCC;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EAEA,kBAAA;EACA,eAAA;ALmnCF;AKlnCE;EACC,cPzlCyB;EO0lCzB,gBAAA;ALonCH;AKnnCG;EACC,mBP3kCmB;EO4kCnB,eAAA;EAEA,mBAAA;ALonCJ;AKlnCG;EACC,cPjlCmB;AEqsEvB;AKjnCE;EACC,cPtlC0B;AEysE7B;AKjnCE;EACC,cPzlC0B;AE4sE7B;AKjnCE;EACC,WP1kCK;EO2kCL,yBP9mCuB;EOgnCvB,yCAAA;EAEA,mBAAA;ALinCH;AKhnCG;EACC,WPjlCI;EOklCJ,yBPrnCsB;EOunCtB,yCAAA;EAEA,mBAAA;EACA,WPvlCI;EOwlCJ,yBP3nCsB;AE2uE1B;AK/mCI;EACC,WP1lCG;EO2lCH,yBP9nCqB;AE+uE1B;AK/mCI;EACC,WP9lCG;EO+lCH,yBPloCqB;AEmvE1B;AK/mCI;EACC,WPlmCG;EOmmCH,yBPtoCqB;EOuoCrB,6BAAA;ALinCL;AK/mCI;EACC,WPvmCG;EOwmCH,yBP3oCqB;EO4oCrB,6BAAA;ALinCL;AK/mCI;EACC,WP5mCG;EO6mCH,yBPhpCqB;AEiwE1B;AK9mCG;EACC,WPjnCI;EOknCJ,yBPrpCsB;AEqwE1B;AK9mCG;EACC,WPrnCI;EOsnCJ,yBPzpCsB;EO0pCtB,6BAAA;ALgnCJ;AK9mCG;EACC,WP1nCI;EO2nCJ,yBP9pCsB;EO+pCtB,6BAAA;ALgnCJ;AK9mCG;EACC,WP/nCI;EOgoCJ,yBPnqCsB;AEmxE1B;AK9mCG;EACC,WPnoCI;EOooCJ,yBPvqCsB;AEuxE1B;AK7mCE;EACC,WPxoCK;EOyoCL,yBP5qCuB;AE2xE1B;AK7mCE;EACC,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;EAEA,mBAAA;AL8mCH;AK7mCG;EACC,mBPvqCmB;EOyqCnB,mBAAA;AL8mCJ;AK5mCG;EACC,WP3pCI;EO6pCJ,yCAAA;AL6mCJ;AK5mCI;EACC,WP/pCG;EOgqCH,yBPvqCiB;GEqxEpB,yBFrxEoB;AEsxEtB;AK5mCI;EACC,WPpqCG;EOqqCH,yBP5qCiB;GE0xEpB,yBF1xEoB;AE2xEtB;AK5mCI;EACC,WPzqCG;EO0qCH,yBPjrCiB;GE+xEpB,yBF/xEoB;EOmrCjB,6BAAA;AL8mCL;AK5mCI;EACC,WP/qCG;EOgrCH,yBPvrCiB;GEqyEpB,yBFryEoB;EOyrCjB,6BAAA;AL8mCL;AK5mCI;EACC,WPrrCG;EOsrCH,yBP7rCiB;GE2yEpB,yBF3yEoB;AE4yEtB;AK3mCG;EACC,WP3rCI;EO4rCJ,yBPnsCkB;GEgzEpB,yBFhzEoB;AEizEtB;AK3mCG;EACC,cPltCyB;AE+zE7B;AKzmCC;EACC,WAAA;EACA,qBAAA;EACA,kCAAA;EACA,mCAAA;EACA,gCAAA;EACA,uCPptCS;EOqtCT,kBAAA;EACA,SAAA;EACA,SAAA;AL2mCF;AKzmCC;EACC,WAAA;EACA,qBAAA;EACA,kCAAA;EACA,mCAAA;EACA,6BAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;AL2mCF;AKzmCC;EACC,aAAA;AL2mCF;AKzmCC;EACC,WAAA;EACA,SAAA;AL2mCF;AKzmCC;EACC,eAAA;AL2mCF;AK1mCE;EACC,mBPpvCoB;AEg2EvB;AKvmCA;EACC,WAAA;EACA,6BAAA;EACA,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EAEA,gBAAA;ALwmCD;AKtmCA;EACC,eAAA;ALwmCD;AKrmCA;EACC,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;ALumCD;AKrmCA;EACC,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;ALumCD;AKpmCA;EACC,kBAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;EACA,gBPzwCO;EO0wCP,gCAAA;EAEA,2CAAA;EACA,eAAA;EACA,aAAA;ALqmCD;AKpmCC;EACC,WAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iCAAA;ALsmCF;AKpmCC;EACC,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;EACA,gBPlyCM;EOmyCN,qCAAA;EACA,mBAAA;EAEA,4BAAA;EACA,gBAAA;EACA,UAAA;EACA,oBAAA;ALqmCF;AKnmCG;EACC,cAAA;EACA,aAAA;EACA,qBAAA;EACA,cPp1CI;EOq1CJ,gCAAA;EAEA,4CAAA;EAEA,6BAAA;ALmmCJ;AKjmCG;EACC,YAAA;EACA,cAAA;ALmmCJ;AKjmCG;EAEC,0BAAA;ALkmCJ;AKhmCG;EACC,YAAA;EAEA,0BAAA;ALimCJ;AK/lCG;EACC,mBP/0CyB;AEg7E7B;AK7lCC;EACC,UAAA;EACA,oBAAA;AL+lCF;AK3lCA;EACI,WAAA;EACA,kBAAA;EACA,aAAA;AL6lCJ;AM1+EI;EACI;IACI,iBAAA;IACA,eAAA;EN4+EV;EMz+EM;IAAiB,iBAAA;EN4+EvB;AACF;AM3+EI;EACI;IAAiB,iBAAA;EN8+EvB;EM7+EE;IACI,eAAA;EN++EN;EM5+EE;IACI,6BAAA;EN8+EN;EM7+EM;IACI,gBAAA;EN++EV;AACF;AM3+EI;EACI;IACI,aAAA;IACA,cAAA;EN6+EV;EM3+EU;IACI,WAAA;EN6+Ed;AACF;AMz+EA;EAEI;IACI,aAAA;EN0+EN;EMx+EU;IACI,cAAA;EN0+Ed;EMt+EE;IACI,cAAA;IACA,oBAAA;ENw+EN;EMt+EM;IAEI,iBAAA;IACA,kBAAA;ENu+EV;AACF;AMj+EA;EAGQ;IACI,aAAA;IACA,cAAA;IACA,aAAA;ENi+EV;EM99EE;IACI,cAAA;IACA,oBAAA;ENg+EN;AACF;AM79EA;EACI;IACI,2BAAA;EN+9EN;EMz9EE;IACI,6BAAA;EN29EN;AACF;AMl9EA;EN1EA;IMqGA,gIAAA;EN27EE;EMr9EE;IACI,gBAAA;IACA,WAAA;IAEJ,6BAAA;ENs9EF;EMp9EM;IACI,2BAAA;IACA,WAAA;ENs9EV;EMn9EE;IAAiB,gBAAA;ENs9EnB;EMj9EM;IACI,2BAAA;ENm9EV;EM78EU;IAAG,6BAAA;ENg9Eb;EM58EF;IACI,uBAAA;EN88EF;AACF;AMr8EA;EACI,2BAAA;ANu8EJ;AMt8EK;EAFL;IAGQ,YAAA;IACA,WAAA;IACA,0BAAA;IACA,SAAA;IACA,iCAAA;IACA,eAAA;ENy8EN;AACF;AMr8EI;EADJ;IAEQ,WAAA;IACA,gBAAA;IACA,4BAAA;IAAA,uBAAA;ENw8EN;AACF;AMp8EI;EACI,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,WAAA;EACA,sBAAA;EACA,eAAA;ANs8ER;AMn8EI;EACI,yBAAA;ANq8ER;AMl8EQ;EACI,eAAA;EACA,iBAAA;EACA,kBAAA;ANo8EZ;AMl8EQ;EACI,eAAA;ANo8EZ;AMj8EI;EACI,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;ANm8ER;AMj8EI;EACI,SAAA;EACA,kBAAA;ANm8ER;AMj8EI;EACI,4BAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;ANm8ER;AMj8EI;EACI,4BAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;ANm8ER;AMj8EI;EACI,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,qBAAA;EACA,gBAAA;EACA,cAAA;ANm8ER;AMj8EI;EACI,yBAAA;EACA,cAAA;ANm8ER;AMj8EI;EACI,eAAA;ANm8ER;AMh8EI;EACI,sBAAA;EACA,mBAAA;ANk8ER;AMh8EI;EACI,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,qBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,UAAA;EACA,WAAA;ANk8ER;AMh8EI;EACI,gBAAA;EACA,YAAA;EACA,6BAAA;ANk8ER;AMh8EI;EACI,SAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,wBAAA;EACA,iCAAA;ANk8ER;AM/7EI;EACI,cAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,uBAAA;EACA,UAAA;EACA,kBAAA;EACA,yBAAA;ANi8ER;AM97EI;EACI,eAAA;EACA,iBAAA;EACA,UAAA;EACA,oBAAA;EACA,WAAA;EACA,WAAA;ANg8ER;AM77EI;EACI,kBAAA;EACA,oBAAA;EACA,OAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;EACA,YAAA;EACA,OAAA;EACA,UAAA;EACA,qBAAA;AN+7ER;AM17EA;EAEQ;IACA,eAAA;EN27EN;EMz7EM;IACI,SAAA;IACA,kBAAA;IACA,kCAAA;EN27EV;EMz7EM;IACI,sBAAA;EN27EV;EMz7EM;IACI,mBAAA;IACA,eAAA;EN27EV;EMz7EM;IACI,sBAAA;EN27EV;EMx7EE;IACI,sBAAA;EN07EN;EMx7EE;IACI,sBAAA;EN07EN;AACF;AMv7EA;EAGQ;IACI,eAAA;IACA,mBAAA;IACA,kBAAA;IACA,eAAA;IACA,WAAA;IACA,SAAA;IACA,UAAA;ENu7EV;EMr7EM;IACI,sBAAA;ENu7EV;EMp7EE;IACI,WAAA;IACA,gBAAA;IACA,gBAAA;IACA,yBAAA;IACA,WAAA;IACA,SAAA;ENs7EN;AACF;AMn7EA;EACI,gCAAA;EACA,eAAA;EACA,iBAAA;EACA,8BAAA;EACA,YAAA;EACA,WAAA;ANq7EJ;AMl7EA;EAEI,2BAAA;ANm7EJ;AOryFA;EACI;IAA4E,iBAAA;EPwyF9E;AACF;AOvyFA;EACI;IAAqB,iBAAA;IAAmB,YAAA;EP2yF1C;EOzyFM;IACA,6BAAA;EP2yFN;AACF;AOvyFA;EACI,sBAAA;APyyFJ;AOtyFA;EACI,WAAA;APwyFJ;AOjyFA;EAAgB,yBAAA;APoyFhB;AOnyFA;EAAO,yBAAA;APsyFP;AOpyFA;EAAK,sBAAA;APuyFL;AOpyFA;EACI,iBAAA;EACA,eAAA;EACA,8BAAA;EACA,oBAAA;APsyFJ;AOryFI;EALJ;IAMQ,eAAA;EPwyFN;AACF;AOryFA;EACA,aAAA;APuyFA;AOryFA;EACI,aAAA;APuyFJ;AOryFA;EACI,2BAAA;EACA,2BAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;APuyFJ;AOryFA;EACI,kBAAA;APuyFJ;AOryFA;EACI,WAAA;EACA,WAAA;APuyFJ;AOpyFI;EADJ;IAEQ,eAAA;EPuyFN;AACF;AO/xFI;EAEA,8BAAA;APiyFJ;AO5xFI;EACA,aAAA;EACA,eAAA;AP8xFJ;AO7xFI;EACI,eAAA;AP+xFR;AO1xFI;EACI,yCAAA;EACJ,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;EACA,mBAAA;EACA,qBAAA;AP4xFJ;AOvxFA;EACI,sBAAA;EACA,cT1GS;AEm4Fb;AOtxFA;EACI,cAAA;APwxFJ;AO/wFI;EACI,eAAA;APixFR;AO9wFA;EACI,sBAAA;APgxFJ;AO/wFI;EAFJ;IAGQ,sBAAA;EPkxFN;AACF;AOzwFA;EACI,sBAAA;EACA,sCAAA;EACA,uBAAA;EAEA,gCAAA;EACA,oBAAA;EACA,6BAAA;EACA,sBAAA;AP0wFJ;AOzwFI;EACE,wCAAA;AP2wFN;AOzwFI;EAEE,sBAAA;AP0wFN;AOxwFK;EAhBL;IAiBQ,sCAAA;IACA,oBAAA;EP2wFN;AACF;AOrwFA;EAAsB,0BAAA;APwwFtB;AOtwFA;EACI,0BAAA;EACA,yCAAA;APwwFJ;AOrwFE;EACI,yBTzKO;AEg7Fb;AOrwFA;EACI,qBAAA;EACA,sBAAA;EACA,uBAAA;APuwFJ;AOhwFA;EACI,cAAA;APkwFJ;AOjwFI;EAFJ;IAGQ,0BAAA;IACA,yBAAA;EPowFN;AACF;AOjwFA;EACI,2BAAA;APmwFJ;AOhwFA;EACI,+BAAA;APkwFJ;AO/vFA;EACI,sBAAA;APiwFJ;AO9vFA;EACI,0BAAA;APgwFJ;AO9vFA;EACI,2BAAA;APgwFJ;AO9vFA;EACI,4BAAA;EACA,kCAAA;APgwFJ;AO9vFA;EACI,4BAAA;EACD,gCAAA;APgwFH;AOxvFA;EAYI,gIAAA;EACA,gIAAA;AP+uFJ;AO3vFI;EACI,aAAA;AP6vFR;AO3vFI;EACI,kBAAA;EACA,cAAA;EACA,aAAA;AP6vFR;AO3vFI;EACI,2BAAA;AP6vFR;AOxvFQ;EACI,4HAAA;AP0vFZ;AOzvFY;EACI,6BAAA;AP2vFhB;AOpvFA;EACI,uBAAA;APsvFJ;AOrvFI;EAFJ;IAGQ,WAAA;EPwvFN;AACF;AOnvFA;EACI,sBAAA;EACA,8BAAA;APqvFJ;AOnvFA;EAEI,oCAAA;APovFJ;AOlvFA;EAEI,oCAAA;EACA,iCAAA;APmvFJ;AO7uFI;EADJ;IAEQ,kBAAA;IACA,SAAA;EPgvFN;AACF;AO5uFI;EADJ;IAEQ,WAAA;IACA,WAAA;IACA,wBAAA;IACA,aAAA;IACF,8BAAA;EP+uFJ;AACF;AQzgGA;EAAO,yBAAA;AR4gGP;AQ3gGA;EAAO,4BAAA;AR8gGP;AQ7gGA;EAAO,0BAAA;ARghGP;AQ/gGA;EAAO,2BAAA;ARkhGP;AQjhGA;EAAO,qBAAA;ARohGP;AQjhGA;EAAO,uBAAA;ARohGP;AQnhGA;EAAQ,wBAAA;ARshGR;AQrhGA;EAAQ,wBAAA;ARwhGR;AQvhGA;EAAQ,wBAAA;AR0hGR;AQzhGA;EAAQ,wBAAA;AR4hGR;AQ3hGA;EAAQ,wBAAA;AR8hGR;AQ3hGA;EAAO,4BAAA;AR8hGP;AQ7hGA;EAAQ,6BAAA;ARgiGR;AQ/hGA;EAAQ,6BAAA;ARkiGR;AQjiGA;EAAQ,6BAAA;ARoiGR;AQniGA;EAAQ,6BAAA;ARsiGR;AQriGA;EAAQ,6BAAA;ARwiGR;AQviGA;EAAQ,6BAAA;AR0iGR;AQviGA;EAAO,6BAAA;AR0iGP;AQziGA;EAAQ,8BAAA;AR4iGR;AQ3iGA;EAAQ,8BAAA;AR8iGR;AQ7iGA;EAAQ,8BAAA;ARgjGR;AQ/iGA;EAAQ,8BAAA;ARkjGR;AQjjGA;EAAQ,8BAAA;ARojGR;AQjjGA;EAAO,2BAAA;ARojGP;AQnjGA;EAAQ,4BAAA;ARsjGR;AQrjGA;EAAQ,4BAAA;ARwjGR;AQvjGA;EAAQ,4BAAA;AR0jGR;AQzjGA;EAAQ,4BAAA;AR4jGR;AQ3jGA;EAAQ,4BAAA;AR8jGR;AQ3jGA;EAAO,8BAAA;AR8jGP;AQ7jGA;EAAQ,+BAAA;ARgkGR;AQ/jGA;EAAQ,+BAAA;ARkkGR;AQjkGA;EAAQ,+BAAA;ARokGR;AQnkGA;EAAQ,+BAAA;ARskGR;AQrkGA;EAAQ,+BAAA;ARwkGR;AQtkGA;EACE;IAAa,4BAAA;ERykGb;EQxkGA;IAAa,+BAAA;ER2kGb;EQ1kGA;IAAa,6BAAA;ER6kGb;EQ5kGA;IAAa,8BAAA;ER+kGb;EQ7kGA;IAAa,6BAAA;ERglGb;EQ/kGA;IAAa,8BAAA;ERklGb;EQjlGA;IAAa,4BAAA;ERolGb;EQnlGA;IAAa,+BAAA;ERslGb;EQplGA;IAAa,6BAAA;ERulGb;EQtlGA;IAAa,8BAAA;ERylGb;EQxlGA;IAAa,4BAAA;ER2lGb;EQ1lGA;IAAa,+BAAA;ER6lGb;EQ3lGA;IAAa,6BAAA;ER8lGb;EQ7lGA;IAAa,8BAAA;ERgmGb;EQ/lGA;IAAa,4BAAA;ERkmGb;EQjmGA;IAAa,+BAAA;ERomGb;EQlmGA;IAAa,6BAAA;ERqmGb;EQpmGA;IAAa,8BAAA;ERumGb;EQtmGA;IAAa,4BAAA;ERymGb;EQxmGA;IAAa,+BAAA;ER2mGb;EQzmGA;IAAY,4BAAA;ER4mGZ;EQ3mGA;IAAY,6BAAA;ER8mGZ;EQ7mGA;IAAY,2BAAA;ERgnGZ;EQ/mGA;IAAY,8BAAA;ERknGZ;EQhnGA;IAAY,0BAAA;ERmnGZ;EQlnGA;IAAY,2BAAA;ERqnGZ;EQpnGA;IAAY,yBAAA;ERunGZ;EQtnGA;IAAY,4BAAA;ERynGZ;EQxnGA;IAAY,qBAAA;ER2nGZ;AACF;AQznGA;EACE;IAAa,4BAAA;ER4nGb;EQ3nGA;IAAa,+BAAA;ER8nGb;EQ7nGA;IAAa,6BAAA;ERgoGb;EQ/nGA;IAAa,8BAAA;ERkoGb;EQhoGA;IAAa,6BAAA;ERmoGb;EQloGA;IAAa,8BAAA;ERqoGb;EQpoGA;IAAa,4BAAA;ERuoGb;EQtoGA;IAAa,+BAAA;ERyoGb;EQvoGA;IAAa,6BAAA;ER0oGb;EQzoGA;IAAa,8BAAA;ER4oGb;EQ3oGA;IAAa,4BAAA;ER8oGb;EQ7oGA;IAAa,+BAAA;ERgpGb;EQ9oGA;IAAa,6BAAA;ERipGb;EQhpGA;IAAa,8BAAA;ERmpGb;EQlpGA;IAAa,4BAAA;ERqpGb;EQppGA;IAAa,+BAAA;ERupGb;EQrpGA;IAAa,6BAAA;ERwpGb;EQvpGA;IAAa,8BAAA;ER0pGb;EQzpGA;IAAa,4BAAA;ER4pGb;EQ3pGA;IAAa,+BAAA;ER8pGb;EQ5pGA;IAAY,4BAAA;ER+pGZ;EQ9pGA;IAAY,6BAAA;ERiqGZ;EQhqGA;IAAY,2BAAA;ERmqGZ;EQlqGA;IAAY,8BAAA;ERqqGZ;EQnqGA;IAAY,qBAAA;ERsqGZ;EQrqGA;IAAY,0BAAA;ERwqGZ;EQvqGA;IAAY,2BAAA;ER0qGZ;EQzqGA;IAAY,yBAAA;ER4qGZ;EQ3qGA;IAAY,4BAAA;ER8qGZ;AACF;AQ5qGA;EACE;IAAa,4BAAA;ER+qGb;EQ9qGA;IAAa,+BAAA;ERirGb;EQhrGA;IAAa,6BAAA;ERmrGb;EQlrGA;IAAa,8BAAA;ERqrGb;EQnrGA;IAAa,6BAAA;ERsrGb;EQrrGA;IAAa,8BAAA;ERwrGb;EQvrGA;IAAa,4BAAA;ER0rGb;EQzrGA;IAAa,+BAAA;ER4rGb;EQ1rGA;IAAa,6BAAA;ER6rGb;EQ5rGA;IAAa,8BAAA;ER+rGb;EQ9rGA;IAAa,4BAAA;ERisGb;EQhsGA;IAAa,+BAAA;ERmsGb;EQjsGA;IAAa,6BAAA;ERosGb;EQnsGA;IAAa,8BAAA;ERssGb;EQrsGA;IAAa,4BAAA;ERwsGb;EQvsGA;IAAa,+BAAA;ER0sGb;EQxsGA;IAAa,6BAAA;ER2sGb;EQ1sGA;IAAa,8BAAA;ER6sGb;EQ5sGA;IAAa,4BAAA;ER+sGb;EQ9sGA;IAAa,+BAAA;ERitGb;EQ/sGA;IAAY,2BAAA;ERktGZ;EQjtGA;IAAY,6BAAA;ERotGZ;EQntGA;IAAY,2BAAA;ERstGZ;EQrtGA;IAAY,8BAAA;ERwtGZ;EQttGA;IAAY,0BAAA;ERytGZ;EQxtGA;IAAY,2BAAA;ER2tGZ;EQ1tGA;IAAY,yBAAA;ER6tGZ;EQ5tGA;IAAY,4BAAA;ER+tGZ;EQ9tGA;IAAY,qBAAA;ERiuGZ;AACF;AQ/tGA;EACE;IAAa,4BAAA;ERkuGb;EQjuGA;IAAa,+BAAA;ERouGb;EQnuGA;IAAa,6BAAA;ERsuGb;EQruGA;IAAa,8BAAA;ERwuGb;EQvuGA;IAAa,wBAAA;ER0uGb;EQxuGA;IAAa,6BAAA;ER2uGb;EQ1uGA;IAAa,8BAAA;ER6uGb;EQ5uGA;IAAa,4BAAA;ER+uGb;EQ9uGA;IAAa,+BAAA;ERivGb;EQhvGA;IAAa,wBAAA;ERmvGb;EQjvGA;IAAa,6BAAA;ERovGb;EQnvGA;IAAa,8BAAA;ERsvGb;EQrvGA;IAAa,4BAAA;ERwvGb;EQvvGA;IAAa,+BAAA;ER0vGb;EQzvGA;IAAa,wBAAA;ER4vGb;EQ1vGA;IAAa,6BAAA;ER6vGb;EQ5vGA;IAAa,8BAAA;ER+vGb;EQ9vGA;IAAa,4BAAA;ERiwGb;EQhwGA;IAAa,+BAAA;ERmwGb;EQlwGA;IAAa,wBAAA;ERqwGb;EQnwGA;IAAa,6BAAA;ERswGb;EQrwGA;IAAa,8BAAA;ERwwGb;EQvwGA;IAAa,4BAAA;ER0wGb;EQzwGA;IAAa,+BAAA;ER4wGb;EQ3wGA;IAAa,wBAAA;ER8wGb;EQ5wGA;IAAY,4BAAA;ER+wGZ;EQ9wGA;IAAY,6BAAA;ERixGZ;EQhxGA;IAAY,2BAAA;ERmxGZ;EQlxGA;IAAY,8BAAA;ERqxGZ;EQpxGA;IAAY,uBAAA;ERuxGZ;EQrxGA;IAAY,0BAAA;ERwxGZ;EQvxGA;IAAY,2BAAA;ER0xGZ;EQzxGA;IAAY,yBAAA;ER4xGZ;EQ3xGA;IAAY,4BAAA;ER8xGZ;EQ7xGA;IAAY,qBAAA;ERgyGZ;AACF;AQ5xGA;EAAa,oBAAA;AR+xGb;AQ9xGA;EAAiB,wBAAA;ARiyGjB;AQhyGA;EAAoB,2BAAA;ARmyGpB;AQhyGA;EAAO,sBAAA;ARmyGP;AQlyGA;EAAQ,uBAAA;ARqyGR;AQpyGA;EAAQ,uBAAA;ARuyGR;AQtyGA;EAAQ,uBAAA;ARyyGR;AQxyGA;EAAQ,uBAAA;AR2yGR;AQ1yGA;EAAQ,uBAAA;AR6yGR;AQ3yGA;EAAS,wBAAA;AR8yGT;AQ7yGA;EAAS,2BAAA;ARgzGT;AQ/yGA;EAAS,yBAAA;ARkzGT;AQjzGA;EAAS,0BAAA;ARozGT;AQnzGA;EAAS,oBAAA;ARszGT;AQpzGA;EAAU,gBVhIS;AEu7GnB;AQtzGA;EAAU,mBVjIS;AE07GnB;AQxzGA;EAAU,iBVlIS;AE67GnB;AQ1zGA;EAAU,kBVnIS;AEg8GnB;AQ3zGA;EAAU,iBVpIQ;AEk8GlB;AQ7zGA;EAAU,kBVrIQ;AEq8GlB;AQ/zGA;EAAU,gBVtIQ;AEw8GlB;AQj0GA;EAAU,mBVvIQ;AE28GlB;AQl0GA;EAAU,iBVxIW;AE68GrB;AQp0GA;EAAU,kBVzIW;AEg9GrB;AQt0GA;EAAU,gBV1IW;AEm9GrB;AQx0GA;EAAU,mBV3IW;AEs9GrB;AQz0GA;EAAU,iBV5IY;AEw9GtB;AQ30GA;EAAU,kBV7IY;AE29GtB;AQ70GA;EAAU,gBV9IY;AE89GtB;AQ/0GA;EAAU,mBV/IY;AEi+GtB;AQh1GA;EAAU,iBVhJW;AEm+GrB;AQl1GA;EAAU,kBVjJW;AEs+GrB;AQp1GA;EAAU,gBVlJW;AEy+GrB;AQt1GA;EAAU,mBVnJW;AE4+GrB;AQv1GA;EAAS,gBVpJa;AE8+GtB;AQz1GA;EAAS,iBVrJa;AEi/GtB;AQ31GA;EAAS,eVtJa;AEo/GtB;AQ71GA;EAAS,kBVvJa;AEu/GtB;AQ91GA;EACE;IAAa,gBV/JI;EEggHjB;EQh2GA;IAAa,mBVhKI;EEmgHjB;EQl2GA;IAAa,iBVjKI;EEsgHjB;EQp2GA;IAAa,kBVlKI;EEygHjB;EQt2GA;IAAa,YVnKI;EE4gHjB;EQv2GA;IAAa,iBVpKG;EE8gHhB;EQz2GA;IAAa,kBVrKG;EEihHhB;EQ32GA;IAAa,gBVtKG;EEohHhB;EQ72GA;IAAa,mBVvKG;EEuhHhB;EQ/2GA;IAAa,YVxKG;EE0hHhB;EQh3GA;IAAa,iBVzKM;EE4hHnB;EQl3GA;IAAa,kBV1KM;EE+hHnB;EQp3GA;IAAa,gBV3KM;EEkiHnB;EQt3GA;IAAa,mBV5KM;EEqiHnB;EQx3GA;IAAa,YV7KM;EEwiHnB;EQz3GA;IAAa,iBV9KO;EE0iHpB;EQ33GA;IAAa,kBV/KO;EE6iHpB;EQ73GA;IAAa,gBVhLO;EEgjHpB;EQ/3GA;IAAa,mBVjLO;EEmjHpB;EQj4GA;IAAa,YVlLO;EEsjHpB;EQl4GA;IAAa,iBVnLM;EEwjHnB;EQp4GA;IAAa,kBVpLM;EE2jHnB;EQt4GA;IAAa,gBVrLM;EE8jHnB;EQx4GA;IAAa,mBVtLM;EEikHnB;EQ14GA;IAAa,YVvLM;EEokHnB;EQ34GA;IAAY,gBVxLQ;EEskHpB;EQ74GA;IAAY,iBVzLQ;EEykHpB;EQ/4GA;IAAY,eV1LQ;EE4kHpB;EQj5GA;IAAY,kBV3LQ;EE+kHpB;EQn5GA;IAAY,WV5LQ;EEklHpB;EQp5GA;IAAY,cAAA;ERu5GZ;EQt5GA;IAAY,eAAA;ERy5GZ;EQx5GA;IAAY,aAAA;ER25GZ;EQ15GA;IAAY,gBAAA;ER65GZ;EQ55GA;IAAY,SAAA;ER+5GZ;AACF;AQ75GA;EACE;IAAa,gBV3MI;EE2mHjB;EQ/5GA;IAAa,mBV5MI;EE8mHjB;EQj6GA;IAAa,iBV7MI;EEinHjB;EQn6GA;IAAa,kBV9MI;EEonHjB;EQr6GA;IAAa,YV/MI;EEunHjB;EQt6GA;IAAa,iBVhNG;EEynHhB;EQx6GA;IAAa,kBVjNG;EE4nHhB;EQ16GA;IAAa,gBVlNG;EE+nHhB;EQ56GA;IAAa,mBVnNG;EEkoHhB;EQ96GA;IAAa,YVpNG;EEqoHhB;EQ/6GA;IAAa,iBVrNM;EEuoHnB;EQj7GA;IAAa,kBVtNM;EE0oHnB;EQn7GA;IAAa,gBVvNM;EE6oHnB;EQr7GA;IAAa,mBVxNM;EEgpHnB;EQv7GA;IAAa,YVzNM;EEmpHnB;EQx7GA;IAAa,iBV1NO;EEqpHpB;EQ17GA;IAAa,kBV3NO;EEwpHpB;EQ57GA;IAAa,gBV5NO;EE2pHpB;EQ97GA;IAAa,mBV7NO;EE8pHpB;EQh8GA;IAAa,YV9NO;EEiqHpB;EQj8GA;IAAa,iBV/NM;EEmqHnB;EQn8GA;IAAa,kBVhOM;EEsqHnB;EQr8GA;IAAa,gBVjOM;EEyqHnB;EQv8GA;IAAa,mBVlOM;EE4qHnB;EQz8GA;IAAa,YVnOM;EE+qHnB;EQ18GA;IAAY,gBVpOQ;EEirHpB;EQ58GA;IAAY,iBVrOQ;EEorHpB;EQ98GA;IAAY,eVtOQ;EEurHpB;EQh9GA;IAAY,kBVvOQ;EE0rHpB;EQl9GA;IAAY,WVxOQ;EE6rHpB;EQn9GA;IAAY,cAAA;ERs9GZ;EQr9GA;IAAY,eAAA;ERw9GZ;EQv9GA;IAAY,aAAA;ER09GZ;EQz9GA;IAAY,gBAAA;ER49GZ;EQ39GA;IAAY,SAAA;ER89GZ;AACF;AQ59GA;EACE;IAAa,gBVvPI;EEstHjB;EQ99GA;IAAa,mBVxPI;EEytHjB;EQh+GA;IAAa,iBVzPI;EE4tHjB;EQl+GA;IAAa,kBV1PI;EE+tHjB;EQp+GA;IAAa,YV3PI;EEkuHjB;EQr+GA;IAAa,iBV5PG;EEouHhB;EQv+GA;IAAa,kBV7PG;EEuuHhB;EQz+GA;IAAa,gBV9PG;EE0uHhB;EQ3+GA;IAAa,mBV/PG;EE6uHhB;EQ7+GA;IAAa,YVhQG;EEgvHhB;EQ9+GA;IAAa,iBVjQM;EEkvHnB;EQh/GA;IAAa,kBVlQM;EEqvHnB;EQl/GA;IAAa,gBVnQM;EEwvHnB;EQp/GA;IAAa,mBVpQM;EE2vHnB;EQt/GA;IAAa,YVrQM;EE8vHnB;EQv/GA;IAAa,iBVtQO;EEgwHpB;EQz/GA;IAAa,kBVvQO;EEmwHpB;EQ3/GA;IAAa,gBVxQO;EEswHpB;EQ7/GA;IAAa,mBVzQO;EEywHpB;EQ//GA;IAAa,YV1QO;EE4wHpB;EQhgHA;IAAa,iBV3QM;EE8wHnB;EQlgHA;IAAa,kBV5QM;EEixHnB;EQpgHA;IAAa,gBV7QM;EEoxHnB;EQtgHA;IAAa,mBV9QM;EEuxHnB;EQxgHA;IAAa,YV/QM;EE0xHnB;EQzgHA;IAAY,eVhRQ;EE4xHpB;EQ3gHA;IAAY,iBVjRQ;EE+xHpB;EQ7gHA;IAAY,eVlRQ;EEkyHpB;EQ/gHA;IAAY,kBVnRQ;EEqyHpB;EQjhHA;IAAY,WVpRQ;EEwyHpB;EQlhHA;IAAY,cAAA;ERqhHZ;EQphHA;IAAY,eAAA;ERuhHZ;EQthHA;IAAY,aAAA;ERyhHZ;EQxhHA;IAAY,gBAAA;ER2hHZ;EQ1hHA;IAAY,SAAA;ER6hHZ;AACF;AQ1hHA;EACE;IAAa,gBVpSI;EEi0HjB;EQ5hHA;IAAa,mBVrSI;EEo0HjB;EQ9hHA;IAAa,iBVtSI;EEu0HjB;EQhiHA;IAAa,kBVvSI;EE00HjB;EQliHA;IAAa,YVxSI;EE60HjB;EQniHA;IAAa,iBVzSG;EE+0HhB;EQriHA;IAAa,kBV1SG;EEk1HhB;EQviHA;IAAa,gBV3SG;EEq1HhB;EQziHA;IAAa,mBV5SG;EEw1HhB;EQ3iHA;IAAa,YV7SG;EE21HhB;EQ5iHA;IAAa,iBV9SM;EE61HnB;EQ9iHA;IAAa,kBV/SM;EEg2HnB;EQhjHA;IAAa,gBVhTM;EEm2HnB;EQljHA;IAAa,mBVjTM;EEs2HnB;EQpjHA;IAAa,YVlTM;EEy2HnB;EQrjHA;IAAa,iBVnTO;EE22HpB;EQvjHA;IAAa,kBVpTO;EE82HpB;EQzjHA;IAAa,gBVrTO;EEi3HpB;EQ3jHA;IAAa,mBVtTO;EEo3HpB;EQ7jHA;IAAa,YVvTO;EEu3HpB;EQ9jHA;IAAa,iBVxTM;EEy3HnB;EQhkHA;IAAa,kBVzTM;EE43HnB;EQlkHA;IAAa,gBV1TM;EE+3HnB;EQpkHA;IAAa,mBV3TM;EEk4HnB;EQtkHA;IAAa,YV5TM;EEq4HnB;EQvkHA;IAAY,gBV7TQ;EEu4HpB;EQzkHA;IAAY,iBV9TQ;EE04HpB;EQ3kHA;IAAY,eV/TQ;EE64HpB;EQ7kHA;IAAY,kBVhUQ;EEg5HpB;EQ/kHA;IAAY,WVjUQ;EEm5HpB;EQhlHA;IAAY,cAAA;ERmlHZ;EQllHA;IAAY,eAAA;ERqlHZ;EQplHA;IAAY,aAAA;ERulHZ;EQtlHA;IAAY,gBAAA;ERylHZ;EQxlHA;IAAY,SAAA;ER2lHZ;AACF;AU1gIE;EAAa,cZqBP;AEw/HR;AU5gIE;EAAa,WZyDP;AEs9HR;AU9gIE;EAAmB,cZyDT;AEw9HZ;AUhhIE;EAAmD,cZyDtC;AE09Hf;AUlhIE;EAAoB,cZyDR;AE49Hd;AUphIE;EAAyB,cZyDT;AE89HlB;AUthIE;EAAY,cZ8DP;AE29HP;AUxhIE;EAAiB,cZ+DR;AE49HX;AU1hIE;EAAmB,cZgER;AE69Hb;AU5hIE;EAAkB,cZuDR;AEw+HZ;AU9hIE;EAAoB,cZqDR;AE4+Hd;AUhiIE;EAAoB,cZuDR;AE4+Hd;AUliIE;EAAoB,cZqDR;AEg/Hd;AUpiIE;EAAkB,cZ4DR;AE2+HZ;AUtiIE;EAAmB,cZ4DR;AE6+Hb;AUxiIE;EAAoB,cZ4DR;AE++Hd;AU1iIE;EAAa,cZ4DP;AEi/HR;AU5iIE;EAAwB,cZ4DpB;AEm/HN;AU9iIE;EAAmB,cZ4DR;AEq/Hb;AUhjIE;EAAc,cZ6DP;AEs/HT;AUljIE;EAAqB,cZ8DR;AEu/Hf;AUjjIE;EAAW,yBZHL;AEujIR;AUnjIE;EAAW,sBZiCL;AEqhIR;AUrjIE;EAAiB,yBZiCP;AEuhIZ;AUvjIE;EAAgC,yBZiCnB;AEyhIf;AUzjIE;EAAkB,yBZiCN;AE2hId;AU3jIE;EAAuB,yBZiCP;AE6hIlB;AU7jIE;EAAU,yBZsCL;AE0hIP;AU/jIE;EAAe,yBZuCN;AE2hIX;AUjkIE;EAAiB,yBZwCN;AE4hIb;AUnkIE;EAAgB,yBZ+BN;AEuiIZ;AUrkIE;EAAkB,yBZ6BN;AE2iId;AUvkIE;EAAkB,yBZ+BN;AE2iId;AUzkIE;EAAkB,yBZ6BN;AE+iId;AU3kIE;EAAgB,yBZoCN;AE0iIZ;AU7kIE;EAAiB,yBZoCN;AE4iIb;AU/kIE;EAAkB,yBZoCN;AE8iId;AUjlIE;EAAW,yBZoCL;AEgjIR;AUnlIE;EAAS,yBZoCL;AEkjIN;AUrlIE;EAAiB,yBZoCN;AEojIb;AUvlIE;EAAY,yBZqCL;AEqjIT;AUzlIE;EAAmB,yBZsCN;AEsjIf;AU3lIE;EAAU,yBZ8CK;AEgjIjB;AU7lIE;EAAgB,yBZ8CN;AEkjIZ;AU7lIE;EAAY,iCAAA;AVgmId;AU/lIE;EAAiB,mCAAA;AVkmInB;AUjmIE;EAAsB,6BAAA;AVomIxB;AUnmIE;EAAa,iBAAA;AVsmIf;AUnmIE;EACE,eAAA;EACA,iBAAA;AVqmIJ;AFp/HI;EYnHF;IAKI,iBAAA;EVsmIJ;AACF;AUnmIE;EACE,eAAA;EACA,iBAAA;AVqmIJ;AF7/HI;EY1GF;IAKI,eAAA;IACA,iBAAA;EVsmIJ;AACF;AUnmIE;EACE,eAAA;EACA,iBAAA;EACA,oBAAA;AVqmIJ;AFxgII;EYhGF;IAMI,eAAA;IACA,iBAAA;EVsmIJ;AACF;AUnmIE;EACE,eAAA;EACA,iBAAA;AVqmIJ;AFlhII;EYrFF;IAKI,eAAA;IACA,iBAAA;EVsmIJ;AACF;AUnmIE;EACE,eAAA;EACA,iBAAA;EACA,oBAAA;AVqmIJ;AWxsIA;EACI,wBAAA;AX0sIJ;AWvsIE;EACE,yBAAA;AXysIJ;AWtsIE;EACE,0BAAA;AXwsIJ;AWrsIE;EACE,wBAAA;AXusIJ;AWpsIE;EACE,gCAAA;AXssIJ;AWnsIE;EACE,+BAAA;AXqsIJ;AWlsIE;EACE,6BAAA;AXosIJ;AWjsIE;EACE,2BAAA;AXmsIJ;AWhsIE;EACE,yBAAA;AXksIJ;AW/rIE;EACE,4BAAA;AXisIJ;AW9rIE;EACE;IACE,wBAAA;EXgsIJ;AACF;AW7rIE;EACE;IACE,wBAAA;EX+rIJ;AACF;AW5rIE;EACE;IACE,wBAAA;EX8rIJ;AACF;AW5rIE;EACE;IACE,wBAAA;EX8rIJ;AACF;AW3rIE;EACE;IACE,wBAAA;EX6rIJ;AACF;AW1rIE;EACE;IACE,wBAAA;EX4rIJ;AACF;AWzrIE;EACE;IACE,wBAAA;EX2rIJ;AACF;AWxrIE;;EAEE,wBAAA;AX0rIJ;AWvrIE;EACE,wBAAA;AXyrIJ;AWtrIE;EACE,wBAAA;AXwrIJ;AWrrIE;EACE;IACE,0BAAA;EXurIJ;AACF;AWprIE;EACE;IACE,yBAAA;EXsrIJ;AACF;AWnrIE;EACE,qBAAA;AXqrIJ;AShyIA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,oCAAA;EACA,cAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;ATkyIJ;AS7xIA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;AT+xIJ;AS3xIA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;AT6xIJ;AS1xIA;EACI,eAAA;AT4xIJ;ASzxIA;EACQ,qBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,wBAAA;EACA,iDAAA;EACA,2BAAA;EACA,oDAAA;EACA,uBAAA;EACA,gDAAA;EACA,sBAAA;EACA,+CAAA;EACA,mBAAA;EACA,4CAAA;AT2xIR;ASxxIA;EAKI,mBAAA;AT0xIJ;ASvxIA;EAKI,sBAAA;ATyxIJ;AStxIA;EAKI,sBAAA;ATwxIJ;ASjtIA;EACI;IACA,WAAA;IACA,YAAA;IACA,yBAAA;IACA,wBAAA;ET2wIF;ESxwIE;IACA,WAAA;IACA,YAAA;IACA,yBAAA;IACA,4BAAA;ET0wIF;AACF;AAv5IE;EACE,YAAA;EACA,8FAAA;AAy5IJ;AAt5IE;EACE,SAAA;EACA,iCAAA;AAw5IJ;AAt5II;EACC,sBAAA;AAw5IL;AAr5IE;EACE,4BAAA;AAu5IJ;AAp5II;EAAmB,aAAA;EAAe,QAAA;EAAW,SAAA;AAy5IjD;AAv5II;EAGI,gBAAA;AAy5IR;AAr5IQ;EACI,WAAA;EACA,eAAA;AAu5IZ;AAr5IQ;EACI,WAAA;AAu5IZ;AAp5IY;EACI,WAAA;AAs5IhB;AAr5IgB;EACI,WAAA;AAu5IpB;AAp5IY;EACI,cAAA;EACA,kBAAA;AAs5IhB;AAn5IQ;EACI,cAAA;EACA,kBAAA;AAq5IZ;AAj5II;EACI,UAAA;EACA,YAAA;AAm5IR;AAj5II;EACI,cAAA;EACA,yBAAA;AAm5IR;AAj5II;EACI,YAAA;EACA,kBAAA;AAm5IR;AAj5II;EACI,YAAA;AAm5IR;AAj5II;EACI,yBAAA;EACA,kBAAA;AAm5IR;AAj5II;EACI,wCAAA;AAm5IR;AAj5II;EACI,0DAAA;EACA,2BAAA;EACA,0BAAA;AAm5IR;AAj5II;EACI,6BAAA;EACA,2BAAA;EACA,0BAAA;EACA,6BAAA;EACA,yBAAA;AAm5IR;AAj5II;EACI,eAAA;AAm5IR;AAj5II;EACI,yBAAA;EACA,WAAA;EACA,YAAA;AAm5IR;AAj5II;EACI,gBAAA;AAm5IR;AAh5II;EACI,aAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,2BAAA;EACA,kBAAA;EACA,UAAA;AAk5IR;AAj5IQ;EACI,0BAAA;AAm5IZ;AAh5II;EACI,cAAA;AAk5IR;AAh5II;EACI,gBAAA;EACA,YAAA;EACA,aAAA;EACA,0BAAA;EACA,mBAAA;AAk5IR;AAh5IY;EACI,eAAA;EACA,iBAAA;AAk5IhB;AA/4IQ;EACI,aAAA;AAi5IZ;AAh5IY;EACI,WAAA;AAk5IhB;AAh5IY;EACI,OAAA;EACA,kBAAA;AAk5IhB;AAh5IY;EACI,WAAA;AAk5IhB;AA94II;EACI,aAAA;EACA,0BAAA;EACA,iBAAA;EACA,gBAAA;AAg5IR;AA94IY;EACI,kBAAA;EACA,UAAA;AAg5IhB;AA74IQ;EACI,WAAA;EACA,yBAAA;EACA,iBAAA;AA+4IZ;AA94IY;EACI,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;AAg5IhB;AA/4IgB;EACI,cAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,qBAAA;AAi5IpB;AA/4IgB;EACI,eAAA;AAi5IpB;AA74IY;EACI,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AA+4IhB;AA54IgB;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;AA84IhB;AA74IgB;EACI,eAAA;EACA,cAAA;EACA,kBAAA;AA+4IpB;AA14IgB;EACI,cAAA;AA44IpB;AA34IoB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AA64IxB;AAx4IgB;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AA04IpB;AAz4IoB;EACI,YAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AA24IxB;AAp4II;EACI,qBAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;EACA,iBAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAs4IR;AAp4II;EACI,kBAAA;EACA,WAAA;EACA,YAAA;AAs4IR;AAp4II;EACI,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,8BAAA;EACA,eAAA;EACA,cAAA;AAs4IR;AAp4II;EACI,kBAAA;EACA,WAAA;EACA,YAAA;AAs4IR;AAp4II;;;;;EAKI,yBAAA;EACA,WAAA;AAs4IR;AAn4IQ;EACI,gBAAA;EACA,WAAA;AAq4IZ;AA/3IwB;EACI,cAAA;AAi4I5B;AA33IoB;EACI,eAAA;EACA,WAAA;EACA,gBAAA;AA63IxB;AA53IwB;EACI,gBAAA;EACA,cAAA;AA83I5B;AA53IwB;EACI,yBAAA;AA83I5B;AA53IwB;EACI,mBAAA;AA83I5B;AAv3I4B;EACI,WAAA;AAy3IhC;AA92IQ;EACI,gBAAA;AAg3IZ;AA72II;EACI,gBAAA;AA+2IR;AA52IQ;EADJ;IAEQ,0BAAA;EA+2IV;AACF;AA32II;EACI,eAAA;AA62IR;AA32II;EACI,eAAA;AA62IR;AA12II;EACI,eAAA;AA42IR;AA12II;EACI,eAAA;AA42IR;AAz2II;EACI,eAAA;AA22IR;AAz2II;EACI,YAAA;AA22IR;AAz2II;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;AA22IJ;AAx2II;EACA,cAAA;AA02IJ;AAx2II;EACI,sBAAA;AA02IR;AAx2II;EAAoB,cAAA;AA22IxB;AAz2II;EACI,kEAAA;AA22IR;AAx2II;EACI,yEAAA;AA02IR;AAv2II;EACI,cAAA;AAy2IR;AAv2II;EACI,wEAAA;AAy2IR;AAt2II;EACI,WAAA;EACA,qBAAA;EACA,YAAA;EACA,4BAAA;EACA,sBAAA;EACA,iBAAA;EACA,qBAAA;AAw2IR;AAt2II;EACI,WAAA;EACA,qBAAA;EACA,YAAA;EACA,4BAAA;EACA,sBAAA;EACA,iBAAA;EACA,qBAAA;AAw2IR;AAr2II;EACI,qCAAA;AAu2IR;AAr2II;EACI,qCAAA;AAu2IR;AAr2II;EACI,YAAA;AAu2IR;AAp2II;EACI,mBFzaK;AE+wJb;AAn2IK;EACG,0BAAA;AAq2IR;AAp2IQ;EAFH;IAGO,0BAAA;EAu2IV;AACF;AAt2IQ;EALH;IAMO,0BAAA;EAy2IV;AACF;;AAp2II;EAEI,kBAAA;AAs2IR;AAr2IQ;EACE,aAAA;AAu2IV;AAp2IM;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;AAs2IR;AAp2IM;EACC,uCAAA;EACA,gBAAA;AAs2IP;AAn2IM;EACE,qEAAA;EACA,0BAAA;EACA,4BAAA;EACA,oCAAA;EACA,oBAAA;AAq2IR;AAn2IM;EACI,yBAAA;AAq2IV;AAn2IM;EACI,yBAAA;AAq2IV;AAn2IM;EACI,gBAAA;EACA,kBAAA;AAq2IV;AAn2IM;EACI,oBAAA;EACA,eAAA;AAq2IV;AAn2IM;EACE,aAAA;AAq2IR","sourcesContent":["/* COLOR VARIABLES */\n$base-color: #E20074;\n$base-color-dark: darken($base-color,10);\n$base-color-light: lighten($base-color,10);\n$color-gray: #6a6a6a;\n$color-normal-gray:#8a8a8a;\n$color-light-gray: #cccccc;\n$color-lightest-gray: #f2f2f2;\n$color-lightester-gray: #f8f8f8;\n$color-magenta: $base-color;\n$color-dark: #000;\n$color-green: #05a205;\n$color-light-green: #7dc55e;\n$color-success: #078a14;\n$color-warning: #e8200d;\n$color-danger: #d31407;\n\n/* PATH */\n$img-fonts: \"../fonts/\";\n$fa-font-path: \"~font-awesome/fonts\";\n$img-path: \"/assets/tfb-acctmgmt/images/\";\n$icon-path: '#{$img-path}icons/';\n\n/* colors */\n$black: #000000;\n$white: #ffffff;\n$color_razzmatazz_approx: #e20074;\n$color_persian_rose_approx: #f41a8a;\n$color_shark_approx: #262626;\n$red: red;\n$color_lipstick_approx: #ba0061;\n$color_gray_nurse_approx: #e8e8e8;\n$color_star_dust_approx: #9b9b9b;\n$color_jazzberry_jam_approx: #a10053;\n$color_celeste_approx: #cccccc;\n$color_dove_gray_approx: #6a6a6a;\n$color_alto_approx: #dddddd;\n$color_desert_storm_approx: #f8f8f8;\n$color_stack_approx: #8e8e8e;\n$alto: #dbdbdb;\n$concrete: #f2f2f2;\n$color_thunderbird_approx: #cf230f;\n$color_mine_shaft_approx: #333;\n$color_mountain_mist_approx: #999999;\n$color_gallery_approx: #eeeeee;\n$color_boston_blue_approx: #428bca;\n$color_gravel_approx: #4c4c4c;\n$mine_shaft_10: rgba(50,50,50,0.1);\n$black_17: rgba(0,0,0,0.17);\n$white_100: rgba(255,255,255,1);\n$color_black_squeeze_approx: #f3f8f8;\n$black_20: rgba(0, 0, 0, 0.2);\n$black_25: rgba(0, 0, 0, 0.25);\n$smalt: #003399;\n$color_cobalt_approx: #0044cc;\n$black_24: rgba(0, 0, 0, 0.24);\n$black_12: rgba(0, 0, 0, 0.12);\n\n\n/* Variables */\n$black-16: rgba(0, 0, 0, .16);\n$white: #fff;\n$whiteSmoke:#f5f5f5;\n$brandMagenta: #e20074;\n$darkMagenta: #ba0060;\n$veryDarkMagenta: #a10053;\n$grayLighter: #dddddd;\n$grayLight: #bebebe;\n$grayLight-2: #e6e6e6;\n$grayLight-1: #cccccc;\n$grayLight-1-24: rgba(204,204,204, .24);\n$gray: #767676;\n$gray-medium: #e4e2e2;\n$grayDark: #5a5a5a;\n$grayDark-16: rgba(90, 90, 90, .16);\n$grayDarker: #323232;\n$greenTrue: #07ac0f;\n$greenlight: #8dc63f;\n$greenMedium: #39b54a;\n$green: #09B119;\n$red: #ff0000;\n$pinkishRed: #ed1c24;\n$pink-light: rgba(224, 0, 115, .24);\n$squash: #f7941d;\n$teal: #66aef9;\n$brightYellow: #fff200;\n\n$zebra-striping-dark: #efefef;\n$zebra-striping-light: #f8f8f8;\n\n$border: #dddddd;\n$accordion-border: #d6d6d6;\n$input-border: #cfcfcf;\n\n$cartBackground: #f3f3f3;\n$cartBoxes: #fafafa;\n\n$disclaimerBackground: #dcdcdc;\n\n$dotted-border: 1px dotted #6a6a6a;\n\n$globalSpacingXXL: 50px;\n$globalSpacingXL: 35px;\n$globalSpacingLarge: 20px;\n$globalSpacingMedium: 15px;\n$globalSpacingSmall: 10px;\n$globalSpacingXSmall: 5px;\n\n/* Breakpoint Vars */\n$desktopMin: 992px;\n$tabLandscapeMax: 1200px;\n$tabletMax: 991px;\n$mobileMax: 767px;\n$mobileMin: 320px;\n\n$device-min-xs: 543px;\n$device-max-xs: 544px;\n$device-min-sm: 767px;\n$device-max-sm: 768px;\n$device-min-md: 991px;\n$device-max-md: 992px;\n$device-min-lg: 1199px;\n$device-max-lg: 1200px;\n\n\n$font_0: Tele-GroteskHal;\n$font_1: Tele-Grotesk-Ultr;\n$font_2: Tele-Grotesk-Fett;\n$font_3: Arial;\n$font_4: FontAwesome;\n\n\n$url_0: url('#{$icon-path}greenvalidator.png');\n$url_1: url('#{$icon-path}globalicons.png');\n$url_2: url('#{$icon-path}arrow-down.png');\n$url_3: url('#{$icon-path}overlay.png');\n$url_4: url('#{$icon-path}activepaginator.png');\n$url_5: url('#{$icon-path}activefilterbg.png');\n$url_6: url('#{$icon-path}filterbg.png');\n$url_7: url('#{$icon-path}globalicons-transparent.png');\n$url_8: url('#{$icon-path}activepaginator.png');\n$url_9: url('#{$icon-path}pink-arrow-left.png');\n$url_10: url('#{$icon-path}activepaginator1.png');\n$url_11: url('#{$icon-path}pinkArrowDown.png');\n$url_12: url('#{$icon-path}globalicons.png');\n$url_13: url('#{$img-path}information.png');\n\n\n\n\n\n$screen-xs:                  480px !default;\n$screen-xs-min:              $screen-xs !default;\n$screen-phone:               $screen-xs-min !default;\n\n\n$screen-sm:                  768px !default;\n$screen-sm-min:              $screen-sm !default;\n$screen-tablet:              $screen-sm-min !default;\n\n$screen-md:                  992px !default;\n$screen-md-min:              $screen-md !default;\n$screen-desktop:             $screen-md-min !default;\n\n$screen-lg:                  1200px !default;\n$screen-lg-min:              $screen-lg !default;\n$screen-lg-desktop:          $screen-lg-min !default;\n\n$screen-xs-max:              ($screen-sm-min - 1) !default;\n$screen-sm-max:              ($screen-md-min - 1) !default;\n$screen-md-max:              ($screen-lg-min - 1) !default;\n\n@mixin break-max($breakpoint) {\n    @media screen and (max-width: $breakpoint) {\n      @content;\n    }\n  }\n\n  @mixin break-min($breakpoint) {\n    @media screen and (min-width: $breakpoint) {\n      @content;\n    }\n  }\n\n  @mixin break-min-max($minBreakpoint, $maxBreakpoint) {\n    @media screen and (min-width: $minBreakpoint) and (max-width: $maxBreakpoint) {\n      @content;\n    }\n  }\n\n  \n  @mixin vcenter {\n    top: 50%;\n    left: 50%;\n    transform: translateX(-50%)translateY(-50%);\n  }\n\n  @mixin valign {\n    top: 50%;\n    transform: translateY(-50%);\n    position: relative;\n  }\n","$fa-font-path: \"/assets/tfb-acctmgmt/fonts\";\n\n@font-face {\n\tfont-family: 'Tele-GroteskUlt';\n\tsrc:\n\t\turl(\"#{$fa-font-path}/TeleGroteskUltra.eot\") format(\"eot\"),\n\t\turl(\"#{$fa-font-path}/TeleGroteskUltra.woff\") format(\"woff\"),\n\t\turl(\"#{$fa-font-path}/TeleGroteskUltra.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: 'Tele-Grotesk-Fett';\n  src: \n\t\turl(\"#{$fa-font-path}/tele-groteskfet.eot\") format(\"eot\"),\n\t\turl(\"#{$fa-font-path}/tele-groteskfet.svg\") format(\"svg\"),\n\t\turl(\"#{$fa-font-path}/tele-groteskfet.ttf\") format(\"truetype\"),\n\t\turl(\"#{$fa-font-path}/tele-groteskfet.woff\") format(\"woff\"),\n\t\turl(\"#{$fa-font-path}/tele-groteskfet.woff2\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: 'ArialMT';\n\tsrc: \n\t\turl(\"#{$fa-font-path}/arialmt.eot\") format(\"eot\"),\n\t\turl(\"#{$fa-font-path}/ArialMT.ttf\") format(\"truetype\"),\n\t\turl(\"#{$fa-font-path}/ArialMT.woff\") format(\"woff\"),\n\t\turl(\"#{$fa-font-path}/arialmt.woff2\") format(\"woff\");\n}\n\n@font-face {\n\tfont-family: 'Tele-Grotesk-Ultr';\n\tsrc:\n\t\turl(\"#{$fa-font-path}/TeleGroteskUltra.eot\") format(\"eot\"),\n\t\turl(\"#{$fa-font-path}/TeleGroteskUltra.woff\") format(\"woff\"),\n\t\turl(\"#{$fa-font-path}/TeleGroteskUltra.ttf\") format(\"truetype\");\n}\n\n@font-face {\n\tfont-family: 'Tele-GroteskHal';\n\tsrc:\n\t\turl(\"#{$fa-font-path}/telegrotesk-halbfett.eot\") format(\"eot\"),\n\t\turl(\"#{$fa-font-path}//telegrotesk-halbfett.woff\") format(\"woff\"),\n\t\turl(\"#{$fa-font-path}/telegrotesk-halbfett.ttf\") format(\"truetype\");\n}\n\n@font-face {\n\tfont-family: 'Tele-Grotesk-Halb';\n\tsrc: \n\t\turl(\"#{$fa-font-path}/tele-groteskhal.eot\") format(\"eot\"),\n\t\turl(\"#{$fa-font-path}/tele-groteskhal.svg\") format(\"svg\"),\n\t\turl(\"#{$fa-font-path}/tele-groteskhal.ttf\") format(\"truetype\"),\n\t\turl(\"#{$fa-font-path}/tele-groteskhal.woff\") format(\"woff\"),\n\t\turl(\"#{$fa-font-path}/tele-groteskhal.woff2\") format(\"woff\");\n  }\n  @font-face {\n\tfont-family: 'TeleNeo';\n\tsrc:\n\t\turl(\"#{$fa-font-path}/TeleNeo-Thin.otf\") format(\"opentype\"),\n\t\turl(\"#{$fa-font-path}/TeleNeo-Thin.ttf\") format(\"truetype\");\n\tfont-weight: 100;\n\tfont-style: normal;\n}\n@font-face {\n\tfont-family: 'TeleNeo';\n\tsrc:\n\t\turl(\"#{$fa-font-path}/TeleNeo-ThinItalic.otf\") format(\"opentype\"),\n\t\turl(\"#{$fa-font-path}/TeleNeo-ThinItalic.ttf\") format(\"truetype\");\n\tfont-weight: 100;\n\tfont-style: italic;\n}\n@font-face {\n\tfont-family: 'TeleNeo';\n\tsrc:\n\t\turl(\"#{$fa-font-path}/TeleNeo-Regular.otf\") format(\"opentype\"),\n\t\turl(\"#{$fa-font-path}/TeleNeo-Regular.ttf\") format(\"truetype\");\n\tfont-weight: 400;\n\tfont-style: normal;\n}\n@font-face {\n\tfont-family: 'TeleNeo';\n\tsrc:\n\t\turl(\"#{$fa-font-path}/TeleNeo-RegularItalic.otf\") format(\"opentype\"),\n\t\turl(\"#{$fa-font-path}/TeleNeo-RegularItalic.ttf\") format(\"truetype\");\n\tfont-weight: 400;\n\tfont-style: italic;\n}\n@font-face {\n\tfont-family: 'TeleNeo';\n\tsrc:\n\t\turl(\"#{$fa-font-path}/TeleNeo-Medium.otf\") format(\"opentype\"),\n\t\turl(\"#{$fa-font-path}/TeleNeo-Medium.ttf\") format(\"truetype\");\n\tfont-weight: 500;\n\tfont-style: normal;\n}\n@font-face {\n\tfont-family: 'TeleNeo';\n\tsrc:\n\t\turl(\"#{$fa-font-path}/TeleNeo-MediumItalic.otf\") format(\"opentype\"),\n\t\turl(\"#{$fa-font-path}/TeleNeo-MediumItalic.ttf\") format(\"truetype\");\n\tfont-weight: 500;\n\tfont-style: italic;\n}\n@font-face {\n\tfont-family: 'TeleNeo';\n\tsrc:\n\t\turl(\"#{$fa-font-path}/TeleNeo-Bold.otf\") format(\"opentype\"),\n\t\turl(\"#{$fa-font-path}/TeleNeo-Bold.ttf\") format(\"truetype\");\n\tfont-weight: 700;\n\tfont-style: normal;\n}\n@font-face {\n\tfont-family: 'TeleNeo';\n\tsrc:\n\t\turl(\"#{$fa-font-path}/TeleNeo-BoldItalic.otf\") format(\"opentype\"),\n\t\turl(\"#{$fa-font-path}/TeleNeo-BoldItalic.ttf\") format(\"truetype\");\n\tfont-weight: 700;\n\tfont-style: italic;\n}\n@font-face {\n\tfont-family: 'TeleNeo';\n\tsrc:\n\t\turl(\"#{$fa-font-path}/TeleNeo-ExtraBold.otf\") format(\"opentype\"),\n\t\turl(\"#{$fa-font-path}/TeleNeo-ExtraBold.ttf\") format(\"truetype\");\n\tfont-weight: 900;\n\tfont-style: normal;\n}\n@font-face {\n\tfont-family: 'TeleNeo';\n\tsrc:\n\t\turl(\"#{$fa-font-path}/TeleNeo-ExtraBoldItalic.otf\") format(\"opentype\"),\n\t\turl(\"#{$fa-font-path}/TeleNeo-ExtraBoldItalic.ttf\") format(\"truetype\");\n\tfont-weight: 900;\n\tfont-style: italic;\n}\n.font-tele-hal { font-family: Tele-GroteskHal, sans-serif; }\n","@import './assets/tfb-acctmgmt/sass/variables.scss';\n@import './assets/tfb-acctmgmt/sass/fonts.scss';\n@import \"@angular/material/prebuilt-themes/indigo-pink.css\";\n\n.mat-mdc-tab-group, .mat-mdc-tab-nav-bar{\n    --mdc-tab-indicator-active-indicator-color: #e20074;  \n    --mat-tab-header-active-label-text-color:#000;\n    --mat-tab-header-active-hover-label-text-color:#fff;\n    --mat-tab-header-active-hover-indicator-color:var(--mdc-tab-indicator-active-indicator-color);\n    --mat-tab-header-inactive-hover-label-text-color:var(--mat-tab-header-active-hover-label-text-color);\n    --mat-tab-header-active-focus-label-text-color:var(--mdc-tab-indicator-active-indicator-color);\n    --mat-tab-header-active-focus-indicator-color:var(--mat-tab-header-active-label-text-color)\n    --mat-tab-header-active-ripple-color:var(--mdc-tab-indicator-active-indicator-color);\n    --mat-select-focused-arrow-color:var(--mdc-tab-indicator-active-indicator-color);\n\n}\n\n\n.acctmgmt {\n  @import \"./assets/tfb-acctmgmt/sass/main.scss\";\n  @import \"./assets/tfb-acctmgmt/sass/parent.scss\";\n\n  html, body {\n    height: 100%;\n    --mdc-filled-text-field-focus-label-text-color:var(--mdc-tab-indicator-active-indicator-color);\n  }\n\n  body {\n    margin: 0;\n    font-family: 'Roboto', sans-serif;\n  }\n    #am-container-custom{\n     background-color:#fff;\n    }\n\n  .cdk-global-overlay-wrapper, .cdk-overlay-container {\n    z-index: 10000000 !important;\n  }\n    // fix for IE cross button\n    input::-ms-clear { display: none; width : 0; height: 0; }\n\n    .mat-accordion .mat-expansion-panel:not([class*='mat-elevation-z']) {\n        -webkit-box-shadow: none;\n        -moz-box-shadow: none;\n        box-shadow: none;\n    }\n\n    .datepicker{\n        &.dropdown-menu{\n            width: 100%;\n            min-width: 16em;\n        }\n        .ngb-dp-month{\n            width: 100%;\n        }\n        .ngb-dp-week{\n            .ngb-dp-day,.ngb-dp-weekday{\n                width: 3rem;\n                .btn-light{\n                    width: auto;\n                }\n            }\n            .ngb-dp-weekday{\n                color: #6a6a6a;\n                font-style: normal;\n            }\n        }\n        .btn-link{\n            color: #6a6a6a;\n            padding: 0 .25rem;\n        }\n    }\n\n    .modal-scroll img {\n        width: 99%;\n        height: auto;\n    }\n    .btn-light {\n        color: #f41a8a;\n        background-color: #f2f2f2;\n    }\n    .ngb-dp-arrow .btn-link {\n        color: black;\n        padding: 0 .25rem;\n    }\n    .ngb-dp-weekday {\n        color: black;\n    }\n    .bg-primary {\n        background-color: #e20074;\n        border-radius: 2px;\n    }\n    .bg-light {\n        background-color: transparent !important;\n    }\n    .ngb-dp-header {\n        font-family: '\"Helvetica Neue\",Helvetica,Arial,sans-serif';\n        font-weight: 700 !important;\n        font-size: 14px !important;\n    }\n    .ngb-dp-weekday {\n        font-family: Arial !important;\n        font-weight: 400 !important;\n        font-size: 14px !important;\n        font-style: normal !important;\n        color:#6a6a6a !important;\n    }\n    .ngb-dp-month-name{\n        font-size: 16px;\n    }\n    .ngb-dp-navigation-chevron{\n        border-width: 2px 2px 0 0;\n        width: 10px;\n        height: 10px;\n    }\n    .min-content-height{\n        min-height: 100%;\n    }\n    /// ngx-date picker =====\n    .bs-datepicker {\n        display: flex;\n        align-items: stretch;\n        flex-flow: row wrap;\n        background: #fff;\n        box-shadow: 0 0 10px 0 #aaa;\n        position: relative;\n        z-index: 1;\n        .is-other-month {\n            color: rgba(0,0,0,.25);\n        }\n    }\n    .bs-datepicker-container {\n        padding: 0 5px;\n    }\n    .bs-datepicker-head {\n        min-width: 300px;\n        height: 50px;\n        padding: 10px;\n        border-radius: 3px 3px 0 0;\n        text-align: justify;\n        .previous,.next{\n            span{\n                font-size: 28px;\n                line-height: 24px;\n            }\n        }\n        bs-datepicker-navigation-view{\n            display: flex;\n            .previous{\n                width: 40px;\n            }\n            .month-year-block{\n                flex: 1;\n                text-align: center;\n            }\n            .next{\n                width: 40px;\n            }\n        }\n    }\n    .bs-datepicker-body {\n        padding: 10px;\n        border-radius: 0 0 3px 3px;\n        min-height: 232px;\n        min-width: 278px;\n        .days{\n            &.weeks {\n                position: relative;\n                z-index: 1;\n            }\n        }\n        table {\n            width: 100%;\n            border-collapse: separate;\n            border-spacing: 0;\n            td {\n                color: #54708b;\n                text-align: center;\n                position: relative;\n                padding: 0;\n                span {\n                    display: block;\n                    margin: 0 auto;\n                    font-size: 13px;\n                    position: relative;\n                    -moz-user-select: none;\n                    -webkit-user-select: none;\n                    -ms-user-select: none;\n                }\n                &:not(.disabled) span {\n                    cursor: pointer;\n                }\n\n            }\n            th {\n                font-size: 13px;\n                color: #9aaec1;\n                font-weight: 400;\n                text-align: center;\n            }\n            &.days {\n                span {\n                width: 32px;\n                height: 32px;\n                line-height: 32px;\n                color: #000;\n                font-family: Arial;   // font-style: italic;\n                font-size: 12px;\n                &.disabled{\n                    cursor: default;\n                    color:#6a6a6a;\n                    font-style: italic;\n                }\n                }\n            }\n            &.years{\n                td{\n                    color: #e20074;\n                    span{\n                        width: 46px;\n                        height: 46px;\n                        line-height: 45px;\n                        margin: 0 auto;\n                        font-family: Arial;\n                    }\n                }\n            }\n            &.months{\n                td{\n                    text-align: left;\n                    color: #6a6a6a;\n                    font-family: Arial;\n                    font-style: normal;\n                    line-height: 1.5;\n                    span{\n                        padding: 6px;\n                        border-radius: 15px;\n                        color: #e20074;\n                        font-family: Arial;\n                    }\n                }\n\n            }\n        }\n    }\n    .bs-datepicker-head button {\n        display: inline-block;\n        vertical-align: top;\n        padding: 0;\n        height: 30px;\n        line-height: 30px;\n        border: 0;\n        background: 0 0;\n        text-align: center;\n        cursor: pointer;\n        color: #6a6a6a;\n        transition: .3s;\n    }\n    .bs-datepicker-head button.next, .bs-datepicker-head button.previous {\n        border-radius: 50%;\n        width: 30px;\n        height: 30px;\n    }\n    .bs-datepicker-head button.current {\n        border-radius: 15px;\n        max-width: 155px;\n        padding: 0 5px;\n        font-family: Tele-Grotesk-Ultr;\n        font-size: 24px;\n        color: #000000;\n    }\n    .bs-datepicker-head button.next, .bs-datepicker-head button.previous {\n        border-radius: 50%;\n        width: 30px;\n        height: 30px;\n    }\n    .theme-green .bs-datepicker-body table td span.selected,\n    .theme-green .bs-datepicker-body table td span[class*=select-]:after,\n    .theme-green .bs-datepicker-body table td.selected span,\n    .theme-green .bs-datepicker-body table td[class*=select-] span:after,\n    .theme-green .bs-datepicker-head {\n        background-color: #e20074;\n        color: #fff;\n    }\n    .theme-green {\n        .bs-datepicker-head{\n            background: #fff;\n            color: #000;\n        }\n        .bs-datepicker-body{\n            table{\n                td{\n                    &.week{\n                        span{\n                            color: #5cb85c;\n                        }\n                    }\n\n                }\n                &.days{\n                    span{\n                        font-size: 14px;\n                        color: #000;\n                        font-weight: 700;\n                        &.disabled,&.is-other-month{\n                            font-weight: 400;\n                            color: #6a6a6a;\n                        }\n                        &.due-date{\n                            border: 1px solid #E20074;\n                        }\n                        &.autopay-date{\n                            background: #F2F2F2;\n                        }\n                    }\n                }\n                &.years,&.months{\n                    td{\n                        &.disabled{\n                            span{\n                                color: #ccc;\n                            }\n                        }\n                    }\n                }\n            }\n\n        }\n    }\n\n    .pagination-block{\n        .ngx-pagination {\n            text-align: left;\n        }\n    }   \n    .tmobilelinelisting{\n        min-height: 100%;\n    }\n    .vertical-wrap{\n        @media screen and (min-width:768px){\n            padding: 0 48px !important;\n        }\n    }\n\n    //utility classes\n    .f-12{\n        font-size: 12px;\n    }\n    .f-16{\n        font-size: 16px;\n    }\n\n    .f-18{\n        font-size:18px;\n    }\n    .f-20{\n        font-size:20px\n    }\n\n    .f-24{\n        font-size:24px;\n    }\n    .pull-right{\n        float: right;\n    }\n    .carousel-indicators li {\n    height: 12px;\n    width: 12px;\n    margin: 0 10px;\n    border-radius: 50%;\n    background-color: #9b9b9b;\n\n    }\n    .carousel-indicators {\n    bottom: -100px;\n    }\n    .bg-white{\n        background-color: #fff;\n    }\n    .cdk-overlay-pane { display: block; }\n\n    .error-circle{\n        background-image: url(/assets/tfb-acctmgmt/images/icons/error.svg);\n        @extend %error-style;\n    }\n    .check-circle{\n        background-image: url(/assets/tfb-acctmgmt/images/green-check-circle.svg);\n        @extend %success-style;\n    }\n    .text-red{\n        color: #e8200d\n    }\n    .error-triangle{\n        background-image: url(/assets/tfb-acctmgmt/images/icons/errorfilled.svg);\n        @extend %error-style;\n    }\n    %error-style{\n        width: 20px;\n        display: inline-block;\n        height: 20px;\n        background-repeat: no-repeat;\n        vertical-align: middle;\n        margin-right: 6px;\n        background-size: 18px;\n    }\n    %success-style{\n        width: 20px;\n        display: inline-block;\n        height: 20px;\n        background-repeat: no-repeat;\n        vertical-align: middle;\n        margin-right: 6px;\n        background-size: 18px;\n    }\n\n    a:focus, button:focus, textarea:focus, select:focus, area:focus{\n        outline: 1px solid #78aeda !important;\n    }\n    [role=\"button\"]:focus {\n        outline: 1px solid #78aeda !important;\n    }\n    iot-confirmation-modal, app-package-products-modal{\n        height: 100%;\n    }\n\n    .tmobilelinelisting .mat-pseudo-checkbox.mat-pseudo-checkbox-checked, .mat-pseudo-checkbox.mat-pseudo-checkbox-indeterminate {\n        background:$base-color;\n     }\n     \n     .headingSize {\n        font-size: 64pt !important;\n        @media only screen and (max-width: 767px) {\n            font-size: 40px !important;\n        }\n        @media only screen and (max-width: 1024px) and (min-width: 768px) {\n            font-size: 56px !important;\n        }\n     }\n}\n//ng-select- customised -css -start //\n.dialPadDropdown {    \n    .ng-select {\n        \n        border-radius: 0px;\n        .ng-select-container {\n          outline: none;\n        }\n      }\n      .ng-select .ng-select-container {\n        min-width: 500px;\n        min-height: 48px;\n        border-radius: 0px;\n      }\n      .ng-dropdown-panel {\n       box-shadow: 0 2px 0 rgba(0,0,0,0.06);\n       min-width: 500px;\n\n      }\n      .ng-select.ng-select-focused>.ng-select-container {\n        background: url(/../assets/tfb-acctmgmt/images/icons/searchImage.png);\n        background-size: 18px auto;\n        background-repeat: no-repeat;\n        background-position: left 8px center;\n        padding-left: 1.5rem;\n      }\n      .ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected, .ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected.ng-option-marked {\n          background-color: #F8F8F8;\n      }\n      .ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-marked {\n          background-color: #F8F8F8;\n      }\n      .ng-select.ng-select-focused:not(.ng-select-opened)>.ng-select-container {\n          box-shadow: none;\n          border-color: #ccc;\n      }\n      .ng-select .ng-select-container .ng-value-container .ng-input>input {\n          padding-left: 1.5rem;\n          margin-top: 4px;\n      }\n      .ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-disabled {\n        display: none;\n    }\n}\n","/* IMPORTING COMMON SASS FILES */\n@import 'fonts.scss';\n@import 'variables.scss';\n@import 'mixins.scss';\n@import 'custom-mat.scss';\n@import \"@angular/material/prebuilt-themes/indigo-pink.css\";\n@import 'global.scss';\n@import 'master.scss';\n@import 'responsive.scss';\n@import 'customall.scss';\n@import 'spacing.scss';\n@import 'typography.scss';\n@import 'display-visibility.scss';\n","@mixin txt-mixin(){\n    .txt {\n        &-small { font-size: 1rem; }\n        &-cr { text-align: center !important; }\n        &-rt { text-align: right !important; }\n        &-lt { text-align: left !important; }\n    }\n}\n\n@mixin txt-mixin-a($pre){\n    .txt {\n        &-#{$pre}-small { font-size: 1rem; }\n        &-#{$pre}-cr { text-align: center !important; }\n        &-#{$pre}-rt { text-align: right !important; }\n        &-#{$pre}-lt { text-align: left !important; }\n    }\n}\n\n\n@mixin display-mixin($device){\n    .display {\n        &-#{$device}-hide { display: none !important; }\n        &-#{$device}-show { display: block !important; }\n\n        &-#{$device}-visible { visibility: visible !important; }\n        &-#{$device}-hidden { visibility: hidden !important; }\n    }\n}\n\n\n// Usage : @include border(2px,solid, $color-lightest-gray)\n@mixin border($size,$type, $color){\n    border: $size $type $color;\n}\n\n@mixin borderBottom(){\n    @include borderPos(bottom,2px,solid, $color-lightest-gray);\n}\n\n// Usage : @include borderPos(bottom,2px,solid, $color-lightest-gray)\n@mixin borderPos($pos,$size,$type, $color){\n    border-#{$pos}: $size $type $color;\n}\n\n// px to rem - demo\n@mixin font-size($sizeValue: 1.6) {\n  font-size: ($sizeValue * 10) + px;\n  font-size: $sizeValue + rem;\n}\n@mixin text($font,$size,$weight,$spacing,$color,$height){\n    font-family: $font;\n    font-size: $size;\n    font-weight: $weight;\n    letter-spacing: $spacing;\n    color: $color;\n    line-height: $height;\n}\n@mixin keyframes($animation-name) {\n  @-webkit-keyframes #{$animation-name} {\n    @content;\n  }\n  @-moz-keyframes #{$animation-name} {\n    @content;\n  }\n  @-ms-keyframes #{$animation-name} {\n    @content;\n  }\n  @-o-keyframes #{$animation-name} {\n    @content;\n  }\n  @keyframes #{$animation-name} {\n    @content;\n  }\n}\n\n@mixin animation($str) {\n  -webkit-animation: #{$str};\n  -moz-animation: #{$str};\n  -ms-animation: #{$str};\n  -o-animation: #{$str};\n  animation: #{$str};\n}\n\n@include keyframes(zoomIn) {\n    from{opacity:0;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}\n    50%{opacity:1}\n}\n@include keyframes(zoomOut) {\n    from{opacity:1}\n    50%{opacity:0;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}\n    to{opacity:0}\n}\n\n/*\n*\n* Skeleton Loading\n*\n*/\n\n@mixin skeleton-loading-container($width: 300px) {\n  .loading-item {\n    @include skeleton-loading-item;\n    &.half {\n      width: 50%;\n    }\n  }\n  @include skeleton-loading-animation($width);\n  .loading-item::before {\n    @include skeleton-loading-position($width);\n  }\n}\n\n@mixin skeleton-loading-item {\n  position: relative;\n  overflow: hidden;\n  background: #f8f0fd;\n  color: transparent;\n  width: 100%;\n  min-height: 20px;\n  margin: 5px 0px;\n}\n\n@mixin skeleton-loading-position($width: 300px) {\n  content: '';\n  display: block;\n  position: absolute;\n  left: -$width;\n  width: $width;\n  height: 100%;\n  top: 0;\n  background: linear-gradient(to right, transparent 0%, #eeeded 40%, transparent 100%);\n  animation: load 1.5s cubic-bezier(0.4, 0, 0.2, 1) infinite;\n}\n\n@mixin skeleton-loading-animation($width: 300px) {\n  @keyframes load {\n    from {\n      left: -$width;\n    }\n    to {\n      left: 100%;\n    }\n  }\n}\n",".mat-mdc-fab.mat-primary,\n.mat-mdc-unelevated-button.mat-primary,\n.mat-mdc-mini-fab.mat-primary,\n.mat-mdc-raised-button.mat-primary {\n    background-color: base-color;\n}\n\n.mat-icon {\n    color: #a5a0a0;\n}\n\n/* TODO(mdc-migration): The following rule targets internal classes of tabs that may no longer apply for the MDC version.*/\n/* TODO(mdc-migration): The following rule targets internal classes of tabs that may no longer apply for the MDC version.*/\n.mat-tab-label {\n    /* TODO(mdc-migration): The following rule targets internal classes of tabs that may no longer apply for the MDC version.*/\n    &.mat-tab-label-active {\n        color: $base-color;\n        font-weight: bold;\n    }\n}\n\n.mat-mdc-tab-group.mat-primary .mat-ink-bar, .mat-mdc-tab-nav-bar.mat-primary .mat-ink-bar {\n    background-color: $base-color;\n}\n\n/* TODO(mdc-migration): The following rule targets internal classes of tabs that may no longer apply for the MDC version.*/\n.mat-tab-body-content {\n    padding: 1rem; \n}\n\n/* TODO(mdc-migration): The following rule targets internal classes of button that may no longer apply for the MDC version.*/\n.mat-button-toggle-checked {\n    background-color: #e20074;\n    color: #fff;\n}\n\n.mat-mdc-select-panel .mat-mdc-option.mat-selected:not(.mat-mdc-option-multiple) {\n    background: #e20074 !important;\n    color: #fff !important;\n}\n\n.mat-mdc-fab.mat-primary, .mat-mdc-unelevated-button.mat-primary, .mat-mdc-mini-fab.mat-primary, .mat-mdc-raised-button.mat-primary {\n    background-color: #ff4081;\n}\n\n.mat-mdc-fab.mat-basic, .mat-mdc-unelevated-button.mat-basic, .mat-mdc-mini-fab.mat-basic, .mat-mdc-raised-button.mat-basic {\n    background-color: #bfbfbf;\n}\n\n.mat-mdc-progress-spinner {\n    display: block;\n    position: absolute;\n    top: 40%;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    margin: auto;\n}\n\n.mat-mdc-progress-spinner circle, .mat-mdc-progress-spinner circle {\n    stroke: #ff4081;\n}\n/* TODO(mdc-migration): The following rule targets internal classes of tabs that may no longer apply for the MDC version.*/\n/* TODO(mdc-migration): The following rule targets internal classes of tabs that may no longer apply for the MDC version.*/\nmat-tab-group.filter{\n    \n        box-shadow: none;\n        /* TODO(mdc-migration): The following rule targets internal classes of tabs that may no longer apply for the MDC version.*/\n        .mat-tab-body-content {\n            margin: 0 -15px;\n        }\n    /* TODO(mdc-migration): The following rule targets internal classes of tabs that may no longer apply for the MDC version.*/\n    .mat-tab-label.mat-tab-label-active {\n        \n        \n        background-color: #e20074;\n        color: #fff;\n        opacity: 1;\n    }\n    .mat-mdc-tab-header {\n        box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);\n        border-bottom: none;\n    }\n}\n/* TODO(mdc-migration): The following rule targets internal classes of tabs that may no longer apply for the MDC version.*/\n.mat-mdc-tab-group.mat-primary .mat-tab-label:not(.mat-tab-disabled):focus{\n    background-color: #e20074;\n    color: #fff;\n}\n/* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/\n/* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/\n/* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/\n.mat-form-field-infix{\n   width: auto!important;\n    .mat-mdc-select{\n    \n   \n        font-family: $font_0;\n    /* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version.*/\n    .mat-select-value-text{\n        font-family: $font_0;\n        font-size: 1rem;\n        color: $black!important;\n        letter-spacing: 0.5px;\n        line-height: 1rem;\n        padding-right: 15px;\n    }\n    /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/\n    .mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label{display: none!important}\n    /* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version.*/\n    /* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version.*/\n    .mat-select-arrow-wrapper{\n        padding-left: 5px;\n        /* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version.*/\n        .mat-mdc-select-arrow{\n        \n            background: $url_2;\n            background-repeat: no-repeat;\n            background-size: 16px auto;\n            margin: 0;\n            width: 100%;\n            background-position: center center;\n           border: none;\n            padding: 8px;\n           \n        }\n    }\n    /* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version.*/\n    .mat-select-value{\n     // width: auto;\n       max-width: 100%;\n    }\n   \n    \n}\n    /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/\n    .mat-form-field-label-wrapper .mat-form-field-label{    \n        @include text($font_0,1rem,normal,normal,$black,1);\n        width: auto;\n    }\n    &:hover{\n        /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/\n        ::ng-deep .mat-form-field-label-wrapper .mat-form-field-label{\n            @include text($font_0,1rem,normal,normal,$base-color,1);\n        }\n            /* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version.*/\n            ::ng-deep .mat-select-arrow-wrapper .mat-select-arrow{\n                color: #e20074;\n                background: $url_11;\n                background-repeat: no-repeat;                \n                background-size: 16px;\n                padding: 8px;\n            }\n            \n        \n    }\n}\n/* TODO(mdc-migration): The following rule targets internal classes of option that may no longer apply for the MDC version.*/\n.mat-primary .mat-mdc-option.mat-selected:not(.mat-option-disabled){\n    color:inherit;\n    ::ng-deep .mat-pseudo-checkbox-checked,.mat-pseudo-checkbox-indeterminate{\n        background:$base-color;\n    }\n}\n/* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version.*/\n/* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version.*/\n.mat-select-content{\n    .mat-mdc-option{\n        &:hover{\n            ::ng-deep .mat-pseudo-checkbox{\n                color: $base-color;\n            }\n        }\n    }\n}\n/* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version.*/\n::ng-deep .mat-form-field-hide-placeholder .mat-select-placeholder{\n    padding-right: 15px;\n    @media screen and (max-width: 767px) {\n        font-size: 14px !important;\n    }\n}\n\n.mat-expansion-panel:last-child {\n    box-shadow: none;\n}\n\n/* TODO(mdc-migration): The following rule targets internal classes of checkbox that may no longer apply for the MDC version.*/\n.mat-checkbox-frame {\n    border-color: #9b9b9b;\n}\n/* TODO(mdc-migration): The following rule targets internal classes of checkbox that may no longer apply for the MDC version.*/\n::ng-deep .mat-checkbox-inner-container{\n    margin-right: 25px;\n\n\n}\n// .cdk-overlay-container{\n//     z-index: 111111  !important;\n// }\n.mat-mdc-select-panel .mat-mdc-optgroup-label, .mat-select-panel .mat-mdc-option{\n    font-size:14px !important;\n}\n.mat-mdc-option.mat-active,.mat-option.mat-active:hover{\n    background: #e20074;\n    color: #fff;\n}\n\n/* TODO(mdc-migration): The following rule targets internal classes of option that may no longer apply for the MDC version.*/\n.mat-mdc-option.mat-option-disabled {\n    font-weight: bold;\n}\n\n\n.mat-mdc-form-field-infix{\n    width: 100%!important;\n    padding-top: 0;\n    padding-bottom: 0;\n    min-height: auto;\n}\n\n.mdc-text-field--filled .mdc-line-ripple::before{\n    border-bottom-width: 1px;\n    color: rgba(0, 0, 0, 0.15);\n}\n\n.mat-mdc-text-field-wrapper{\n    padding-left: 0;\n    padding-right:0;\n    padding-top: 12px;\n}\n.mat-mdc-form-field-infix{\n    display:flex;\n}\n.mdc-line-ripple--active{\n    color: #e20074;\n}\n\n.mat-mdc-tab-link-container, .mat-mdc-tab-label-container{\n    height: 56px;\n    border-bottom-color: rgb(0 0 0 / 23%);\n    border-bottom-width: 1px;\n}\n.mat-mdc-tab-links{\n    height: 55px;\n    align-items: center;\n}\n\n.mdc-tab-indicator--active .mdc-tab-indicator__content--underline{\n    color:#e20074;\n}\n\n.mdc-checkbox .mdc-checkbox__native-control:enabled:not(:checked):not(:indeterminate):not([data-indeterminate=true])~.mdc-checkbox__background{\n    border-color: #9b9b9b;\n}\n.mat-pseudo-checkbox-full.mat-pseudo-checkbox-checked, .mat-pseudo-checkbox-full.mat-pseudo-checkbox-indeterminate,\n.mdc-checkbox:not(:disabled):active .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background,.mdc-checkbox .mdc-checkbox__native-control:enabled:focus:checked~.mdc-checkbox__background,\n.mdc-checkbox:not(:disabled):active .mdc-checkbox__native-control:enabled:not(:checked):not(:indeterminate):not([data-indeterminate=true])~.mdc-checkbox__background,\n.mdc-checkbox .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background, .mdc-checkbox .mdc-checkbox__native-control:enabled:indeterminate~.mdc-checkbox__background, .mdc-checkbox .mdc-checkbox__native-control[data-indeterminate=true]:enabled~.mdc-checkbox__background{\n    border-color: #e20074;\n    background-color: #e20074;\n}\n.mdc-checkbox .mdc-checkbox__native-control:enabled~.mdc-checkbox__background .mdc-checkbox__checkmark{\n    color: #fff;\n}\n\n.mdc-list-item__primary-text{\n    font-family: Roboto, \"Helvetica Neue\", sans-serif;\n    font-size: 14px !important;\n}\n.mat-pseudo-checkbox{\n    width: 16px;\n    height: 16px;\n    border: 2px solid;\n    border-radius: 2px;\n    cursor: pointer;\n    display: inline-block;\n    vertical-align: middle;\n    box-sizing: border-box;\n    position: relative;\n    flex-shrink: 0;\n    transition: border-color 90ms cubic-bezier(0, 0, 0.2, 0.1), background-color 90ms cubic-bezier(0, 0, 0.2, 0.1);\n}\n.mat-mdc-option .mat-pseudo-checkbox-full{\n    margin-right: 10px;\n}\n.mdc-checkbox__background{\n    width: 16px;\n    height: 16px;\n}\n.mdc-checkbox .mdc-checkbox__native-control[disabled]:not(:checked):not(:indeterminate):not([data-indeterminate=true])~.mdc-checkbox__background{\n    border-color: rgb(128 128 128 / 34%);\n    background-color: rgb(128 128 128 / 34%);\n}\n\n.mat-pseudo-checkbox-full.mat-pseudo-checkbox-checked::after, .mat-pseudo-checkbox-full.mat-pseudo-checkbox-indeterminate::after{\n    color: #fff;\n}\n.mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-text-field__input{\n    color: rgb(0 0 0 / 70%);\n    font-size: 14px;\n}\n.mat-divider{\n    border-top-width: 1px;\n    border-top-color: rgba(0, 0, 0, .12);\n}\n.mat-mdc-option .mat-pseudo-checkbox-minimal{\n    display: none;\n}\n.mat-mdc-card-outlined{\n    border-color: rgba(0, 0, 0, .12);\n}\n\n.mat-mdc-card{\n    -webkit-box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);\n    box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);\n    border: none;\n}\n\n.mat-form-field-appearance-fill .mat-mdc-select-arrow-wrapper{\n    transform: none;\n}\n.mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-floating-label{\n    top:12px\n}\n.mdc-text-field--filled .mdc-floating-label--float-above{\n    transform: translateY(-120%) scale(0.75);\n}\n.mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-floating-label{\n    color: rgba(0, 0, 0, 0.7);\n}\n.mdc-text-field--filled .mdc-floating-label{\n    font-size: 14px;\n}\n.mat-mdc-tab-header.mat-mdc-tab-nav-bar-stretch-tabs .mat-mdc-tab-link{\n    height: 100%;\n    flex-grow: initial;\n}\n.mat-mdc-option:hover:not(.mdc-list-item--disabled){\n    background-color: rgba(0, 0, 0, .04);\n}\n.mdc-linear-progress__bar-inner{\n    display: none;\n}\n.mdc-linear-progress__bar,.mdc-linear-progress__buffer{\n    background: #e4e8eb;\n    border-radius: 5px;\n}\n.mdc-form-field>label{\n    margin-bottom: 0;\n}\n.mdc-text-field--filled:not(.mdc-text-field--disabled), .mat-mdc-form-field.mat-focused .mat-mdc-form-field-focus-overlay, .mat-mdc-text-field-wrapper:hover .mat-mdc-form-field-focus-overlay{\n    background-color: #fff;\n}\n.mdc-text-field--no-label .mat-mdc-form-field-infix{\n    padding-top: 0;\n    padding-bottom: 0;\n}\n// .mat-mdc-checkbox {\n//     --mdc-checkbox-state-layer-size: 0;\n//   }\n\n.mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::after{\nborder-bottom-color: #e20074;\n}\n\n.mdc-text-field--filled:not(.mdc-text-field--disabled).mdc-text-field--focused .mdc-floating-label, .mdc-text-field--filled:not(.mdc-text-field--disabled).mdc-text-field--focused .mdc-floating-label--float-above{\n    color: rgb(0 0 0 / 72%);\n}\n.mat-mdc-tab-link .mdc-tab-indicator__content--underline{\n    border-top-width: 4px;\n}\n.mdc-linear-progress__buffer{\n    height: 16px;\n}\n.mat-mdc-select-arrow svg {\n    display: none !important;\n}\n\n.mat-mdc-select-arrow{\n \n    background: $url_2;\n    background-repeat: no-repeat;\n    background-size: 16px auto;\n    margin: 0;\n    width: 100%;\n    background-position: center center;\n   border: none;\n    padding: 8px;\n\n}\n.mat-checkbox-frame{\n    top:-3px;\n}\n.mdc-linear-progress__buffer-bar{\n    background-color: #e4e8eb;\n}\n.mat-mdc-option.mat-mdc-option-active.mdc-list-item{\n    background-color: #e20074 !important;\n    color: #fff;\n    .mdc-list-item__primary-text{\n        color: #fff;\n    }\n}\n.mat-mdc-select{\n    padding-bottom: 4px;\n}\n.mdc-checkbox .mdc-checkbox__native-control:focus:checked~.mdc-checkbox__ripple{\n    background-color: #fff;\n}\n.mdc-checkbox .mdc-checkbox__native-control:focus~.mdc-checkbox__ripple{\n    background-color: #fff;   \n}","/* RESET */\n// h1,\n// .h1 {\n//   font-size: 4.5rem;\n//   color: $color-dark;\n//   margin-top: 2rem;\n//   font-weight: 700;\n//   letter-spacing: -1.7px;\n// }\n\n// h2,\n// .h2,\n// h3,\n// .h3 {\n//   letter-spacing: -1.7px;\n// }\n\n// h1,\n// h2,\n// h3,\n// h4,\n// h5,\n// h6 {\n//   font-family: Tele-Grotesk-Ultr;\n// }\n\na {\n  color: $base-color-light;\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.text {\n  &-warning {\n    color: $color-warning !important;\n  }\n}\n\n/* FOOTER */\n.footer {\n  background: $color-dark;\n  padding: 15px 0;\n  margin-top: 2rem;\n}\n\n.no-ul {\n  padding: 0;\n  li {\n    list-style-type: none;\n  }\n}\n\n/*------------------- RESET CLASSES/Tags ----------------*/\n\n/* LAYOUT */\n\n.data-table {\n  .data-head {\n    margin-bottom: 10px;\n    @include borderBottom;\n    padding-bottom: 10px;\n    .data-heading {\n      font-size: 1rem;\n      text-transform: uppercase;\n      color: $color-normal-gray;\n    }\n  }\n  .data-body {\n    .each-item {\n      @include borderBottom;\n      margin-bottom: 15px;\n    }\n    .acessory-row {\n      margin-bottom: 20px;\n    }\n  }\n  label {\n    margin: 0;\n  }\n  .item-img {\n    width: 65px;\n    text-align: center;\n  }\n}\n\n.parent-loader {\n  position: relative;\n}\n\n.overlay-loader {\n  background: rgba(185, 176, 176, 0.3803921568627451);\n  position: absolute;\n  width: 100%;\n  height: 100%;\n\n  .img-loader {\n    max-width: 150px;\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    margin: auto;\n  }\n}\n\n/*----- INPUTS BUTTONS ------*/\n\n.btn {\n  cursor: pointer;\n  padding: 0.7rem 3rem;\n  border-radius: unset;\n  font-weight: 600;\n\n  &-link-lg {\n    font-weight: 800;\n    font-size: 1rem;\n\n    &:hover {\n      text-decoration: none;\n      color: $base-color-dark;\n    }\n  }\n  &-link {\n    color: $base-color !important;\n    font-size: 0.9rem;\n    font-weight: 500;\n    cursor: pointer;\n    &-bold {\n      font-weight: bold !important;\n    }\n  }\n  &-underline {\n    text-decoration: underline;\n  }\n  &-small {\n    font-size: 12px;\n  }\n  &-outline {\n    &-primary {\n      color: $color-dark;\n      border-color: $color-dark;\n      &.active,\n      &:active,\n      .show > &.dropdown-toggle,\n      &:hover {\n        color: #fff;\n        background-color: $base-color;\n        border-color: $base-color;\n      }\n    }\n  }\n  &-primary {\n    background-color: $base-color;\n    color: #fff;\n    border-color: $base-color;\n    margin: 10px 0;\n    &:hover,\n    &:focus,\n    &:active,\n    &.active,\n    &:active:hover,\n    &.active:hover {\n      background-color: $base-color-dark;\n      border-color: $base-color-dark;\n      border-width: 1px;\n      border-style: solid;\n    }\n    &[disabled]:hover,\n    &[disabled]:focus,\n    &[disabled].focus,\n    &.disabled:hover,\n    &.disabled:focus,\n    &:disabled,\n    &.disabled {\n      background-color: $color-light-gray;\n      border-color: $color-light-gray;\n      color: $color-dark;\n    }\n  }\n  &-white {\n    *display: inline;\n    color: #c06;\n    text-align: center;\n    text-shadow: 0 1px 1px rgba(255, 255, 255, 0.75);\n    background-color: #f5f5f5;\n    *background-color: #e6e6e6;\n    background-image: -moz-linear-gradient(top, #fff, #e6e6e6);\n    background-image: -webkit-gradient(\n      linear,\n      0 0,\n      0 100%,\n      from(#fff),\n      to(#e6e6e6)\n    );\n    background-image: -webkit-linear-gradient(top, #fff, #e6e6e6);\n    background-image: -o-linear-gradient(top, #fff, #e6e6e6);\n    background-image: linear-gradient(to bottom, #fff, #e6e6e6);\n    background-repeat: repeat-x;\n    border: 1px solid #ccc;\n    *border: 0;\n    border-color: #e6e6e6 #e6e6e6 #bfbfbf;\n    border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);\n    border-bottom-color: #b3b3b3;\n    -webkit-border-radius: 4px;\n    -moz-border-radius: 4px;\n    border-radius: 4px;\n    filter: progid:DXImageTransform.Microsoft.gradient(\n        startColorstr=\"#ffffffff\",\n        endColorstr=\"#ffe6e6e6\",\n        GradientType=0\n      );\n    filter: progid:DXImageTransform.Microsoft.gradient(enabled=false);\n    *zoom: 1;\n    -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2),\n      0 1px 2px rgba(0, 0, 0, 0.05);\n    -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2),\n      0 1px 2px rgba(0, 0, 0, 0.05);\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2),\n      0 1px 2px rgba(0, 0, 0, 0.05);\n    &:hover,\n    &:focus,\n    &:active,\n    &.active,\n    &:active:hover,\n    &.active:hover,\n    &[disabled]:hover,\n    &[disabled]:focus,\n    &[disabled].focus,\n    &.disabled:hover,\n    &.disabled:focus {\n      color: #8c0041;\n      background-color: #e6e6e6;\n      *background-color: #d9d9d9;\n    }\n    &:active,\n    &.active {\n      background-color: #ccc \\9;\n    }\n    &:first-child {\n      *margin-left: 0;\n    }\n    &:hover,\n    &:focus {\n      color: #8c0041;\n      text-decoration: none;\n      background-position: 0 -15px;\n      -webkit-transition: background-position 0.1s linear;\n      -moz-transition: background-position 0.1s linear;\n      -o-transition: background-position 0.1s linear;\n      transition: background-position 0.1s linear;\n    }\n    &:focus {\n      outline: thin dotted #333;\n      outline: 5px auto -webkit-focus-ring-color;\n      outline-offset: -2px;\n    }\n    &.active,\n    &:active {\n      background-image: none;\n      outline: 0;\n      -webkit-box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.15),\n        0 1px 2px rgba(0, 0, 0, 0.05);\n      -moz-box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.15),\n        0 1px 2px rgba(0, 0, 0, 0.05);\n      box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.15),\n        0 1px 2px rgba(0, 0, 0, 0.05);\n    }\n    &.disabled,\n    &[disabled] {\n      cursor: default;\n      background-image: none;\n      opacity: 0.65;\n      filter: alpha(opacity=65);\n      -webkit-box-shadow: none;\n      -moz-box-shadow: none;\n      box-shadow: none;\n      color: #8c0041;\n      background-color: #e6e6e6;\n      *background-color: #d9d9d9;\n    }\n  }\n}\n\n\n.input {\n  &-custom {\n    border: 0;\n    outline: 0;\n    border-bottom: 1px solid gray;\n    display: block;\n  }\n  &-large {\n    font-weight: 600;\n    font-size: 2.5rem;\n  }\n  &-fluid {\n    width: 100%;\n  }\n}\n\n.small-ddl {\n  .dropdown-menu {\n    max-width: 200px;\n  }\n}\n\n.ddl-auto-height {\n  .dropdown-menu{\n    height: auto !important;\n  }\n}\n\n.optional_errortext{\n  background-image: url(~assets/tfb-acctmgmt/images/icons/globalicons.png);\n  background-repeat: no-repeat;\n  padding-right: 16px;\n  background-position: right 0 top -118px;\n  color: #e8200d !important;\n  background-size: 16px;\n  width: 100%;\n  height: 18px;\n}\n\n.optional_errortext_20 {\n  background-size: 20px !important;\n  height: 20px !important;\n  padding-right: 20px !important;\n  background-position: right 0 top -151px !important;\n}\n\n.optional_errortext ~ label{\n  color: #e8200d !important;\n}\n\ninput.disabled-floatinglabel ~label{\n  transform: translate(-4px, -35px) scale(0.9) !important;\n  margin-top: -41px !important;\n  font-size: 14px !important;\n}\n/*----- FLOATING LABEL ------*/\n.question label {\n  font-family: Arial;\n  line-height: 20px !important;\n    letter-spacing: 0.7px !important;\n    font-size: 14px !important;\n}\n/** z-index level**/\n.zindex1{\n  z-index: 1 !important;\n}\n.zindex2{\n  z-index: 2 !important;\n}\n.zindex3{\n  z-index: 3 !important;\n}\n.zindex4{\n  z-index: 4 !important;\n}\n.zindex5{\n  z-index: 5 !important;\n}\n.position-r{position: relative;}\n.mb-80{\n    @media (min-width:992px){\n      margin-bottom: 80px !important;\n\n    }\n    @media (max-width:767px){\n      margin-bottom: 120px !important;\n\n    }\n    @media (max-width:476px){\n      margin-bottom: 190px !important;\n\n    }\n\n}\n/** Custom Drop Down start **/\n\n.btn-outline-primary:not(:disabled):not(.disabled).active,\n.btn-outline-primary:not(:disabled):not(.disabled):active,\n.show>.btn-outline-primary.dropdown-toggle{\n  background: $base-color;\n}\n\n.custom-ddl-wrapper {\n  .dropdownBasic2 ~ .dropdown-menu{\n      width: 100% !important\n  }\n  .dropdown-menu {\n      height: auto;\n      overflow-y: auto;\n      overflow-x: hidden;\n      border-radius: 0;\n      margin: 0;\n      padding: 6px;\n      top: 0px !important;\n      border: 0;\n      background: #fff;\n      box-shadow: 0px 0px 10px #988d8d;\n      &.show {\n          .dropdown-item {\n              margin-bottom: 2px;\n              .default-item {\n                  padding: 8px;\n              }\n              .active-item {\n                  background: #e20074;\n                  color: #fff;\n              }\n              strong {\n                  display: block;\n              }\n              &:hover {\n                  background: #e20074;\n                  color: #fff;\n              }\n          }\n      }\n      .dropdown-item {\n          padding: 0;\n      }\n  }\n\n  .custom_floatlabel {\n      visibility: hidden;\n      min-height: 30px;\n      z-index: -1;\n  }\n  .active-ddl {\n      .custom_floatlabel {\n          color: #6a6a6a;\n          font-size: 16px;\n          padding: 0;\n          padding-bottom: 6px;\n          visibility: visible;\n      }\n  }\n}\n.custom-ddl-wrapper span{\n  font-weight: normal;\n}\n.custom-ddl-wrapper{\n  span{\n      width: 90%;\n      overflow: hidden;\n      justify-content:start;\n  }\n}\n/** Custom Drop Down end **/\n.pl-sm-15{\n  @media (max-width:767px){\n    padding-left: 0;\n  }\n}\n\n.floating-label-hasvalue-date {\n  top: -20px !important;\n  font-size: 11px !important;\n  transition: all .3s ease-in-out;\n}\n\n.date_label .datepic_box .datepicker {\n  padding-left: 0;\n}\n\n.datepic_box .datepicker {\n  width: 100%;\n  background-color: transparent;\n  border-bottom: 1px solid #ddd;\n  border-left: none;\n  border-right: 0;\n  border-top: 0;\n  padding: 7px;\n  border-radius: 0;\n}\n\n.datepicker {\n  top: 0;\n  left: 0;\n  padding: 4px;\n  margin-top: 1px;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  border-radius: 4px;\n\n}\n\n.label_box .date_label label {\n  color: #8e8e8e;\n  font-weight: 100;\n  font-size: 15px;\n  box-sizing: border-box;\n  padding: 12px 0;\n  display: block;\n  position: absolute;\n  pointer-events: none;\n  background-color: transparent;\n  top: 0;\n  z-index: 99;\n}\n.fa-calendar-alt{\n  font-size: 20px;\n  color: #e20074;\n  position: absolute;\n  right: 0;\n  top:20%;\n}\n.box_icon {\n  background-repeat: no-repeat;\n  background-size: 25px;\n  height: 25px;\n  width: 25px;\n}\n\n.datepicker:before {\n  content: '';\n  display: inline-block;\n  border-left: 7px solid transparent;\n  border-right: 7px solid transparent;\n  border-bottom: 7px solid #ccc;\n  border-bottom-color: rgba(0,0,0,0.2);\n  position: absolute;\n  top: -7px;\n  left: 6px;\n}\n\n.datepicker:after {\n  content: '';\n  display: inline-block;\n  border-left: 6px solid transparent;\n  border-right: 6px solid transparent;\n  border-bottom: 6px solid #fff;\n  position: absolute;\n  top: -6px;\n  left: 7px;\n}\n",".gray-link,a{\n    display: inline-block;\n    color:$color_dove_gray_approx;\n    font-family: $font_3;\n    font-size: 14px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    letter-spacing: normal;\n    vertical-align: middle;\n    &:hover {\n        color:$color_dove_gray_approx;\n        text-decoration: none;\n    }\n}\n.small-text {\n    font-family: $font_3;\n    font-size: 11px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: 1;\n    letter-spacing: 0.3px;\n    color:$color_dove_gray_approx;\n  }\n.white-text{\n    font-family: $font_0;\n  font-size: 16px;\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1;\n  letter-spacing: normal;\n  text-align: right;\n  color: $white;\n  &:hover {\n    color:  $white;\n    text-decoration: underline;\n}\n}\nh1{\n    font-family: $font_1;\n    font-size: 4.5rem;\n    color: $black ;\n    letter-spacing: -1.5px;\n    line-height: 64px;\n    padding: 30px 0 10px;\n\n    @media screen and (max-width:1191px){\n        font-size: 40px;\n        line-height: 50px;\n    }\n}\n\nbody,.regular-black{\n    font-family: $font_3;\n    font-size: 1rem;\n    color: $black;\n    \n    \n}\nbody{\n    cursor: default;\n}\n.black-fourteen{\n    letter-spacing: 0.5px;\n    @include text($font_3,14px,normal,normal,$black,1);\n}\n.grey-sixteen{\n    @include text($font_3,16px,normal,normal,#6a6a6a,24px);\n}\nh6,h4,h2{\n  letter-spacing: normal;\n  margin-top: 10px;\n  margin-bottom: 5px;\n  max-height: 66px;\n  @include text($font_1,22px,normal,normal,$black,22px);  \n\n  \n}\nh6{\n    @media screen and (max-width:767px){\n        font-size: 24px;\n        line-height: 24px;\n    } \n}\nh2{\n    font-size: 40px;\n    line-height: 40px;\n\n    @media screen and (max-width:767px){\n        font-size: 32px;\n        line-height: 32px;\n    }\n}\nh4{\n    font-size: 32px;\n    line-height: 32px;\n\n    @media screen and (max-width:767px){\n        font-size: 24px;\n        line-height: 24px;\n    }\n}\n.limited{        \n    @include text($font_0,14px,normal,normal,#e8200d,24px);  \n    letter-spacing: -0.2px;\n    min-height: 24px;\n    @media screen and (max-width:1191px){\n        font-size: 16px;\n    }\n}\n.offer{\n    color: $color-success;\n    @include text($font_0,14px,normal,normal,$color-success,1);    \n    letter-spacing: -0.2px;\n    \n    @media screen and (max-width:1191px){\n        font-size: 16px;\n    }\n  }\n  .small-bold-grey{\n    \n    text-transform: uppercase;\n    @include text($font_1,14px,normal,normal,$color_star_dust_approx,1.5);    \n  }\n  .small-normal-black{\n    @include text($font_0,1rem,normal,normal,$black,1.5);    \n  }\n  .small-bold-black{\n    @include text($font_1,1rem,bold,0.5px,$black,1.5);    \n  }\n  .small-pink{\n    @include text($font_2,1rem,bold,0,$base-color,1.5);   \n    &:hover{\n        color: $base-color;\n    }\n  }\n  .small-legal-grey{\n    font-family: $font_3;\n    font-size: 10px;\n    color: $color-gray;\n    letter-spacing: 0.5px; \n    line-height: 1.2 ;\n\n    @media screen and (max-width:1191px){\n        font-size: 14px;\n\n    }\n  }\n .device-box{\n    padding: 15px 12px;\n    a{\n        width:100%\n    }\n    .phone-box{\n        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);\n        background-color: $white;\n        border: solid 1px rgba(0, 0, 0, 0.1);\n        //margin: 15px 0;\n    \n        .phone-wrapper {\n            padding: 10px 15px;\n            border-bottom: 1px solid #f2f2f2;\n            a{\n                text-decoration: none;\n                width: 100%;\n            }\n        }\n        .phone-wrapper:nth-child(2) {\n           \n            border-bottom:none;\n        }\n        \n        .phone-desc{\n            .color-variation{\n                float: right;\n                a {\n             \n                    border:1px solid rgba(0, 0, 0, 0.1);\n                    border-radius: 50%;\n                    height: 14px;\n                    width: 14px;\n                    margin: 2px;\n                    font-size: 0;\n        \n                    &.red{background:#BF1B2C}\n                    &.black{background:$black}\n                    \n                    &.grey{background:$white}\n                   \n                    &.rose-gold{background:#ecd7e2}\n                    &.gold{background:#e0d1b2}\n        \n                }\n            } \n        }\n        .img-wrapper{\n            text-align: center;\n            padding:15px 30px;\n        \n            img{\n                height: 150px;\n                margin: 0 auto;\n            }\n        }\n        \n        }\n }\n \n.ngx-pagination {\n    margin: 1rem 0;\n    padding: 0;\n    text-align: center;\n    \n         li{\n          \n            &.current{\n            padding: 12px 16px!important;\n            font-weight: bold;\n             border: 2px solid $color_razzmatazz_approx;\n             background: transparent;\n             color: $color_razzmatazz_approx;\n                line-height: 1;\n            \n            }\n            &.disabled{\n                    vertical-align: middle;                   \n                    line-height: 1;\n                    opacity: 0.7;\n\n                  \n                    span{\n                        font-size: 0;\n                     }\n                    \n                a{\n                    @include text($font_3,16px,bold,0.5px,rgb(139, 55, 55),1);\n                }\n                \n            }\n            &.pagination-previous,&.pagination-next {\n                vertical-align: middle;\n                line-height: 1;\n                padding: 0.1875rem 0.625rem;\n               \n                &:before{\n                    display: none;\n                }\n                \n                \n            }\n            &.pagination-previous{\n                &.disabled{\n                    position: relative;\n                    &:before{\n                        \n                        width: 20px;\n                        height: 20px;\n                        display: inline-block;\n                       \n                        content: \"<\"!important;\n                        background: none;\n                        color: #9b9b9b;\n                        font-size: 21px;\n                    }\n                }\n                &:before{\n                   \n                    display: none;              \n                }\n                a{\n                    font-size: 0;\n                    position: relative;\n                    height: 40px;\n                    width: 40px;\n                    padding: 0;\n                    &:before{\n                        \n                        width: 20px;\n                        height: 20px;\n                        display: inline-block;\n                        position: absolute;  \n                        top:8px;\n                        left: 0;\n                        right: 0;\n                        margin: auto;  \n                        content: \"<\";\n                        background: none;\n                        color: #6a6a6a;\n                        font-size: 21px;\n                    }\n                    &:hover{\n                        background: #f41a8a;\n                        &:before{\n                             width: 20px;\n                        height: 20px;\n                        display: inline-block;\n                        position: absolute;  \n                        top:8px;\n                        left: 0;\n                        right: 0;\n                        margin: auto;  \n                        content: \"<\"!important;\n                        background: none;\n                        color: #fff;\n                        font-size: 21px;\n                            \n                        }\n                    }\n                    &:active{\n                        background: $url_8;\n                        \n                    }\n                }\n            }\n            &.pagination-next{\n                &.disabled{\n                    &:before{\n                        width: 20px;\n                        height: 20px;\n                        display: inline-block;                       \n                        content: \">\"!important;\n                        background: none;\n                        color: #9b9b9b;\n                        font-size: 21px;\n                    }\n                    \n                }\n                &:after{\n                   \n                    display: none!important;              \n                }\n                \n                a{\n                    font-size: 0;\n                    position: relative;\n                    height: 40px;\n                    width: 40px;\n                    padding: 0;\n\n                    &:before{\n                        width: 20px;\n                        height: 20px;\n                        display: inline-block;                       \n                        content: \">\"!important;\n                        position: absolute;  \n                        top:8px;\n                        left: 0;\n                        right: 0;\n                        margin: auto;  \n                        background: none;\n                        color: #9a9a9a;\n                        font-size: 21px;\n                    }\n                    &:hover{\n                        background: #f41a8a;\n\n                        &:before{\n                            width: 20px;\n                            height: 20px;\n                            display: inline-block;   \n                            position: absolute;  \n                            top:8px;\n                            left: 0;\n                            right: 0;\n                            margin: auto;                  \n                            content: \">\"!important;\n                            background: none;\n                            color: #fff;\n                            font-size: 21px;\n                        }\n                    }\n                    &:active{\n                        background: $url_8;\n                        \n                    }\n                }\n            }\n            a{\n                @include text($font_3,16px,bold,0.5px,$black,1);                        \n                &:hover{\n                    background: transparent;\n                    text-decoration: none;\n                    color:$color_razzmatazz_approx;\n                }\n            }\n         }\n       \n     \n}\n.filter-devices {\n    padding-right: 40px;\n    //padding-left: 15px;\n    display: inline-block;\n}\n\n.primary_btn {\n    float: none;\n    min-width: 150px;\n    min-height: 48px;\n    display: inline-block;\n    background-color: $color_razzmatazz_approx;\n\tbackground-position: center;\n\ttransition: background .8s;\n    width: auto;\n    color: $white;\n    border: none;\n    border-radius: 0;\n\tpadding: 12px 35px;\n\tline-height: 20px;\n\tfont-size: 18px;\n    font-family: Tele-Grotesk-Fett;\n\tfont-weight: normal;\n\tfont-style: normal;\n\tfont-stretch: normal;\n\tletter-spacing: normal;\n    text-decoration: none;\n    text-align: center;\n    span{\n        line-height: 20px;\n        font-size: 18px;\n        font-family: Tele-Grotesk-Fett;\n        font-weight: normal;\n        font-style: normal;\n        font-stretch: normal;\n        letter-spacing: normal;\n        text-decoration: none;\n        text-align: center;\n    }\n    \n    cursor: pointer;\n    &:hover {\n        box-shadow: 0 8px 8px 0 rgba(0, 0, 0, 0.24), 0 0 8px 0 rgba(0, 0, 0, 0.12);\n\t\tbackground: $color_persian_rose_approx radial-gradient(circle, transparent 1%, #a10053 1%) center/15000%;\n\n        &:disabled {\n            background-color: $concrete;\n            color: $color_dove_gray_approx;\n        }\n    }\n    &:focus {\n\t\tbackground-color: $color_persian_rose_approx;\n\t\tbox-shadow: 0 8px 8px 0 rgba(0, 0, 0, 0.24), 0 0 8px 0 rgba(0, 0, 0, 0.12);\n\t\ttext-decoration: underline;\n    }\n\t&:active {\n\t\ttext-decoration: none;\n\t\tbackground-color: #ba0060;\n\t\tbackground-size: 100%;\n\t\ttransition: background 0s;\n\t\tbox-shadow: none;\n\t}\n\t&:disabled {\n\t\tbackground-color: $concrete;\n\t\tcolor: $color_star_dust_approx;\n\t\tcursor: pointer;\n\t\tbox-shadow: none;\n\n\t\t&:hover {\n\t\t\tbackground-color: $concrete;\n\t\t\tcolor: $color_star_dust_approx;\n\t\t\tcursor: pointer;\n\t\t\tbox-shadow: none;\n\t\t}\n\t}\n    &:hover[disabled] {\n        background-color: $concrete;\n        color: $color_dove_gray_approx;\n    }\n}\n\n.secondary_btn {\n\tfloat: none;\n\tdisplay: inline-block;\n\tmin-width: 150px;\n\tmin-height: 48px;\n\tbackground-color: $white;\n\tbackground-position: center;\n\ttransition: background .8s;\n\tcolor: $black;\n\tpadding: 12px 35px;\n\tline-height: 20px;\n\tfont-size: 18px;\n\tfont-family: Tele-Grotesk-Fett;\n\tfont-weight: normal;\n\tfont-style: normal;\n\tfont-stretch: normal;\n\tletter-spacing: normal;\n\tborder: 1px solid $black;\n    text-decoration: none;\n    text-align: center;\n\t&:hover {\n\t\tborder: 2px solid #4c4c4c;\n\t\tcolor: #4c4c4c;\n\t\tbackground: #ffffff radial-gradient(circle, transparent 1%, #fff 1%) center/15000%;\n\t}\n\t&:focus {\n\t\tborder: 2px solid #4c4c4c;\n\t\tcolor: #4c4c4c;\n\t\ttext-decoration: underline;\n\t}\n\t&:active {\n\t\tborder: 2px solid #000;\n\t\ttext-decoration: none;\n\t\tbackground-color: #e8e8e8;\n\t\tbackground-size: 100%;\n\t\ttransition: background 0s;\n\t}\n\t&:disabled {\n\t\tborder: 1px solid #9b9b9b;\n\t\tcolor: #9b9b9b;\n\t\ttext-decoration: none;\n\t\tbackground: #fff;\n\t\tcursor: pointer;\n\t}\n}\n\n\n.arrow-left{\n    vertical-align: middle;\n    padding-right: 10px;\n    &:before{\n        background:  $url_9 no-repeat center center;\n        display: inline-block;\n        content: '';\n        width: 12px;\n        height: 12px;\n        background-size: 100% auto;\n    }\n}\n/*TODO(mdc-migration): The following rule targets internal classes of card that may no longer apply for the MDC version.*/\n.mat-card-header-text{\n    margin: 0 !important;\n}\n.caps{\n    text-transform: uppercase;\n    padding-bottom: 5px;\n}\n\n.paginations{\n    width: 100%;\n}\n\n.mega_spinner_box, .micro_spinner_box {\n\tposition: fixed;\n\tleft: 50%;\n    top: 50%;\n\talign-content: center;\n\talign-self: center;\n\tjustify-content: center;\n\tbackground-color: transparent;\n\toverflow: hidden;\n\tz-index: 500000;\n}\n.micro_spinner_box{\n\tmargin: -30px 0 0 0;\n}\n.megaspinner {\n\tdisplay: flex;\n\talign-content: center;\n\talign-self: center;\n\tjustify-content: center;\n\tanimation: rotate 2s linear infinite;\n\tcircle {\n\t\tfill: none;\n\t\tstroke: $color_lipstick_approx;\n\t\tstroke-dasharray: 125, 155;\n\t\tstroke-dashoffset: 0;\n\t\tanimation: dash 1.35s cubic-bezier(0.4,0,0.2,1) infinite;\n\t}\n}\n.microspinner {\n    display: flex;\n    align-content: center;\n    align-self: center;\n    justify-content: center;\n\tanimation: rotate 2s linear infinite;\n\tcircle {\n\t\tfill: none;\n\t\tstroke: #ba0060;\n\t\tstroke-dasharray: 125,155;\n\t\tstroke-dashoffset: 0;\n\t\tanimation: dash 1.35s cubic-bezier(0.4,0,0.2,1) infinite;\n\t}\n}\n.modal_spinner_box {\n\tposition: absolute;\n\theight: 100%;\n\twidth: 100%;\n\tdisplay: flex;\n\talign-content: center;\n\talign-self: center;\n\tjustify-content: center;\n\tz-index: 150000;\n\tbackground-size: 100%;\n\tbackground-color: transparent;\n\topacity: 0.8;\n\toverflow: hidden;\n\tdisplay: none;\n\tz-index: 500000;\n}\n.modalspinner {\n\tdisplay: flex;\n\talign-content: center;\n\talign-self: center;\n\tjustify-content: center;\n\tanimation: rotate 2s linear infinite;\n\tcircle {\n\t\tfill: none;\n\t\tstroke: $color_lipstick_approx;\n\t\tstroke-dasharray: 125, 155;\n\t\tstroke-dashoffset: 0;\n\t\tanimation: dash 1.35s cubic-bezier(0.4,0,0.2,1) infinite;\n\t}\n}\n@keyframes dash {\n\t0% {\n\t\tstroke-dasharray: 2, 155;\n\t\tstroke-dashoffset: 0;\n\t}\n\t50% {\n\t\tstroke-dasharray: 122, 20;\n\t\tstroke-dashoffset: -20;\n\t}\n\t100% {\n\t\tstroke-dasharray: 2, 155;\n\t\tstroke-dashoffset: -155;\n\t}\n}\n@keyframes rotate {\n\t100% {\n\t\t//Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)\n\t\ttransform: rotate(360deg);\n\t}\n}\n.cursorPointer {\n    cursor: pointer;\n}\n.padding15{\n    padding: 0 15px;\n}\n.BG-modal {\n    width: 100%;\n    // background-color: rgba(0, 0, 0, 0.4);\n}\n\n.floatRight {\n    float: right;\n}\n.text-right{\n    text-align: right!important;\n}\n\n.font32 {\n    font-size: 32px;\n}\n.upgradeSubheader .modal-header {\n    border-bottom: 0px;\n}\n.upgradeSubheader .modal-footer {\n    border-top: 0px;\n}\n.upgradeSubheader table thead tr:first-child td {\n    border-top:none;\n}\n.BG-modal {\n    width: 100%;\n  //  background-color: rgba(0, 0, 0, 0.4);\n}\n.borderBtmGrey {\n    border-bottom: solid 1px #e8e8e8;\n}\n.upgradeSubheader .modal-header {\n    display: inline-block;\n}\n\n.upgradeSubheader .modal-content {\n    border : 0px;\n    border-radius : 0px;\n    padding:10px;\n}\n.upgradeLinesContainer {\n    background-color: #f8f8f8;\n    //box-shadow: inset 0 -1px 0 0 rgba(0, 0, 0, 0.1);\n}\n.lineNumber {\n    font-family: Arial;\n    font-size: 1rem;\n    color: #000;\n    font-weight: bold;\n}\n.lineName {\n    font-family: Arial;\n    font-size: 1rem;\n    color: #4c4c4c;\n}\n.lineHeading {\n    font-family: Tele-GroteskHal;\n    font-size: 0.8rem;\n    color: #9b9b9b;\n    text-transform: uppercase;\n    padding: 15px 0;\n    border-top: solid 1px #e8e8e8;\n}\n.small-text {\n    line-height: 1.5;\n}\n\n.cancelBtnPad {\n    padding: 8px 35px;\n    width: auto;\n    margin-right: 16px;\n    border: solid 1px #000000;\n    background: white;\n    &:hover{\n        border: solid 2px #000000;\n        background: white;\n        background: inherit;\n        border-color: inherit;\n        padding: 7px 34px;\n    }\n    span{\n        font-family: Tele-Grotesk-Fett;\n        font-size: 18px;\n        line-height: 1.11;\n        text-align: center;\n        color: #000000;\n        font-weight: normal;\n    }\n}\n.Oval {\n    width: 34px;\n    height: 34px;\n    border: solid 2px #000000;\n    border-radius: 50%;\n    padding: 0px 7px;\n    margin-left: 30px;\n    vertical-align: text-bottom;\n    text-align: center;\n}\n.greenTick{\n    background: $url_12;\n    background-repeat: no-repeat;\n    padding-right: 16px;\n    background-position: 15px -221px;\n    color: #e8200d!important;\n    background-size: 16px;\n    width: 100%;\n    height: 18px;\n}\n.blackInfo{\n    background: $url_13;\n    background-repeat: no-repeat;\n    padding-right: 16px;\n    background-size: 14px;\n    width: 100%;\n    height: 14px;\n    background-position: 15px;\n}\n.trade-text{\n    margin-top: 10px;\n}\n.BG-modal{\n    overflow: auto;\n}\n.redirect-text,.Oval{\n    display: inline-block;\n}\n.optional_errortext{\n    background: $url_12;\n    background-repeat: no-repeat;\n    padding-right: 15px;\n    background-position: 15px -118px;\n    color: #e8200d!important;\n    background-size: 16px;\n    width: 100%;\n    height: 18px;\n    color: #e8200d !important;\n    background-size: 16px;\n    width: 100%;\n    height: 18px;\n  }\n\n  \n    .zoomIn{ @include animation('zoomIn 1s');}\n   \n    .zoomOut{@include animation('zoomOut 1s');}\n\n.alert-dialog{\n.mat-mdc-dialog-container{\noverflow: visible;\n}\n}\n    \n.plp_useralert {\n    float: left;\n    width: 100%;\n    background-color: #fff;\n    height: 48px;\n    padding: 18px 0;\n    text-align: center;\n\n    @media screen and (max-width:991px){\n      height: auto;\n    }\n    .small-legal-grey{\n      color: #000;\n      span{\n        text-transform: lowercase;\n  \n      }\n    }\n    &.staicplp_useralert {\n      position: fixed;\n      left: 0;\n      bottom: 0;\n      transform:translate3d(0px,0px,0px);\n          z-index: 1;\n         \n      /* border-top: 2px solid #E20074; */\n  }\n  }\n  .alignItem{\n      align-items: center;\n  }\n  .inline-blk{\n      display: inline-block;\n  }\n  *{outline: none}\n\n  .search-line{\n    padding: 15px 15px 15px 55px;\n    width: 100%;\n    //background: #f8f8f8;\n    border-radius: 4px;\n    border-color: transparent;\n    margin-bottom: 15px;\n    background: #f8f8f8 url('/../assets/tfb-acctmgmt/images/icons/search.png') ;\n    background-size: 19px auto;\n    background-repeat: no-repeat;\n    background-position: 25px center;\n    font-family: $font_1;\n    font-size: 24px;\n    line-height: 1;\n    color: #000;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n\n    @media screen and (max-width:960px){\n        margin-top: 30px;\n    }\n\n    @media screen and (max-width:767px){\n       font-size: 16px;\n       background-position: 15px center;\n    }   \n}\n.search-line:-ms-input-placeholder {\n    padding: 15px 15px 15px 55px;\n}\n\n.close-search{\n\n    position: absolute;\n    right: 30px;\n    padding: 15px;\n    cursor: pointer;\n    color: transparent;\n    background: url('/../assets/tfb-acctmgmt/images/icons/close-icon.png') no-repeat center center;\n   \n    font-family: Tele-Grotesk-Ultr;\n    font-size: 24px;\n    line-height: 1;\n    border: 4px solid transparent;\n    @media screen and (max-width:991px){\n        font-size: 16px;\n       \n     }\n}\n\n.label_box {\n    float: left;\n    width: 100%;\n    position: relative;\n    // z-index: 1;\n    .question {\n        position: relative;\n        padding: 12px 0;\n        &:first-of-type {\n            padding-top: 0;\n        }\n        &:last-of-type {\n            padding-bottom: 0;\n        }\n        .fa-eye, .fa-eye-slash{\n            color: #6a6a6a;\n            position: absolute;\n            right: 0px;\n            top:25px;\n            z-index: 1;\n        }\n        label {\n            //trans.label_box-origin: left center;\n            color: $color_stack_approx;\n            font-weight: 100;\n            font-size: 16px;\n            //Instead of the line below you could use @include box-sizing($bs)\n            box-sizing: border-box;\n            padding: 12px 0;\n            display: block;\n            position: absolute;\n            margin-top: -40px;\n            pointer-events: none;\n            background-color: transparent;\n        }\n        input[type=\"password\"] {\n            appearance: none;\n            -webkit-appearance: none;\n            background-color: none;\n            line-height: 0;\n            font-size: 16px;\n            width: 100%;\n            display: block;\n            //Instead of the line below you could use @include box-sizing($bs)\n            box-sizing: border-box;\n            padding: 12px 0;\n            color: $black;\n            position: relative;\n            z-index: 1;\n            border-bottom: 1px solid $alto;\n            border-top: none;\n            border-right: none;\n            border-left: none;\n            background-color: transparent;\n            &:focus {\n                outline: none;\n                color: $black;\n                margin-top: 0;\n                border-bottom: 1px solid $color_razzmatazz_approx;\n                ~ label {\n                    transform: translate(0, -35px);\n                    margin-top: -41px;\n                    font-size: 10px;\n                }\n            }\n            &:valid {\n                margin-top: 0;\n                border-bottom: 1px solid $color_dove_gray_approx;\n                ~ label {\n                    transform: translate(-4px, -35px) scale(0.9);\n                    margin-top: -41px;\n                    font-size: 16px;\n                }\n            }\n        }\n        input[type=\"text\"] {\n            appearance: none;\n            -webkit-appearance: none;\n            background-color: none;\n            line-height: 0;\n            font-size: 16px;\n            width: 100%;\n            display: block;\n            //Instead of the line below you could use @include box-sizing($bs)\n            box-sizing: border-box;\n            padding: 12px 0;\n            color: $black;\n            position: relative;\n            z-index: 1;\n            border-bottom: 1px solid $alto;\n            border-top: none;\n            border-right: none;\n            border-left: none;\n            background-color: transparent;\n            &:focus {\n                outline: none;\n                color: $black;\n                margin-top: 0;\n                border-bottom: 1px solid $color_razzmatazz_approx;\n                ~ label {\n                    transform: translate(0, -35px);\n                    margin-top: -41px;\n                    font-size: 10px;\n                }\n            }\n            &:valid {\n                margin-top: 0;\n                border-bottom: 1px solid $color_dove_gray_approx;\n                ~ label {\n                    transform: translate(-4px, -35px) scale(0.9);\n                    margin-top: -41px;\n                    font-size: 16px;\n                }\n            }\n        }\n        textarea {\n            appearance: none;\n            -webkit-appearance: none;\n            background-color: none;\n            line-height: 0;\n            font-size: 16px;\n            width: 100%;\n            display: block;\n            //Instead of the line below you could use @include box-sizing($bs)\n            box-sizing: border-box;\n            padding: 12px 0;\n            color: $black;\n            position: relative;\n            z-index: 1;\n            border-bottom: 1px solid $alto;\n            border-top: none;\n            border-right: none;\n            border-left: none;\n            background-color: transparent;\n            &:focus {\n                outline: none;\n                color: $black;\n                margin-top: 0;\n                border-bottom: 1px solid $color_razzmatazz_approx;\n                ~ .txt_arealabel {\n                    transform: translate(0, -35px);\n                    margin-top: -30px;\n                    font-size: 10px;\n                }\n            }\n            &:valid {\n                margin-top: 0;\n                border-bottom: 1px solid $color_razzmatazz_approx;\n                ~ .txt_arealabel {\n                    text-transform: uppercase;\n                    transform: translate(5px, -35px) scale(0.9);\n                    margin-top: -30px;\n                    font-size: 16px;\n                }\n            }\n        }\n        .txt_arealabel {\n            margin-top: 0;\n        }\n        .invalid_input[type=\"password\"]:focus {\n            outline: none;\n            color: $black;\n            margin-top: 0;\n            border-bottom: 1px solid $red !important;\n        }\n        .invalid_input[type=\"text\"]:focus {\n            outline: none;\n            color: $black;\n            margin-top: 0;\n            border-bottom: 1px solid $red !important;\n        }\n    }\n    .date_label {\n        label {\n            color: $color_stack_approx;\n            font-weight: 100;\n            font-size: 15px;\n            //Instead of the line below you could use @include box-sizing($bs)\n            box-sizing: border-box;\n            padding: 12px 0;\n            display: block;\n            position: absolute;\n            pointer-events: none;\n            background-color: transparent;\n            top: 0;\n        }\n        input[type=\"text\"] {\n            &:valid {\n                margin-top: 0;\n                ~ label {\n                    font-size: 10px;\n                    top: -20px;\n                }\n            }\n            &:focus {\n                outline: none;\n                color: $black;\n                margin-top: 0;\n                border-bottom: 1px solid $color_alto_approx;\n                ~ label {\n                    font-size: 10px;\n                    top: -20px;\n                }\n            }\n        }\n    }\n}\n\n.datepic_box {\n    float: left;\n    width: 100%;\n}\n\n.date_box {\n\twidth: 100%;\n\tpadding: 12px;\n}\n.date_iocn {\n\tbackground-position: -1px -769px;\n\tposition: absolute;\n\tright: 0;\n\ttop: 5px;\n\tcursor: pointer;\n\tz-index: -1;\n}\n.datepicker {\n\ttop: 0;\n\tleft: 0;\n\tpadding: 4px;\n\tmargin-top: 1px;\n\t//Instead of the line below you could use @include border-radius($radius, $vertical-radius)\n\tborder-radius: 4px;\n\tth {\n\t\ttext-align: center;\n\t\twidth: 20px;\n\t\theight: 20px;\n\t\t//Instead of the line below you could use @include border-radius($radius, $vertical-radius)\n\t\tborder-radius: 4px;\n\t\tfont-size: 14px;\n\t\t&.next {\n\t\t\tcursor: pointer;\n\t\t\tfont-size: 21px;\n\t\t}\n\t\t&.prev {\n\t\t\tcursor: pointer;\n\t\t\tfont-size: 21px;\n\t\t}\n\t\t&.switch {\n\t\t\twidth: 145px;\n\t\t}\n\t}\n\ttd {\n\t\ttext-align: center;\n\t\twidth: 20px;\n\t\theight: 20px;\n\t\t//Instead of the line below you could use @include border-radius($radius, $vertical-radius)\n\t\tborder-radius: 4px;\n\t\tfont-size: 14px;\n\t\t&.day {\n\t\t\tcolor: $color_persian_rose_approx;\n\t\t\tpadding: 5px 6px;\n\t\t\t&:hover {\n\t\t\t\tbackground: $color_gallery_approx;\n\t\t\t\tcursor: pointer;\n\t\t\t\t//Instead of the line below you could use @include border-radius($radius, $vertical-radius)\n\t\t\t\tborder-radius: 100%;\n\t\t\t}\n\t\t\t&.disabled {\n\t\t\t\tcolor: $color_gallery_approx;\n\t\t\t}\n\t\t}\n\t\t&.old {\n\t\t\tcolor: $color_mountain_mist_approx;\n\t\t}\n\t\t&.new {\n\t\t\tcolor: $color_mountain_mist_approx;\n\t\t}\n\t\t&.active {\n\t\t\tcolor: $white;\n\t\t\tbackground-color: $color_razzmatazz_approx;\n\t\t\t//Instead of the line below you could use @include text-shadow($shadow-1, $shadow-2, $shadow-3, $shadow-4, $shadow-5, $shadow-6, $shadow-7, $shadow-8, $shadow-9, $shadow-10)\n\t\t\ttext-shadow: 0 -1px 0 $black_25;\n\t\t\t//Instead of the line below you could use @include border-radius($radius, $vertical-radius)\n\t\t\tborder-radius: 100%;\n\t\t\t&:hover {\n\t\t\t\tcolor: $white;\n\t\t\t\tbackground-color: $color_razzmatazz_approx;\n\t\t\t\t//Instead of the line below you could use @include text-shadow($shadow-1, $shadow-2, $shadow-3, $shadow-4, $shadow-5, $shadow-6, $shadow-7, $shadow-8, $shadow-9, $shadow-10)\n\t\t\t\ttext-shadow: 0 -1px 0 $black_25;\n\t\t\t\t//Instead of the line below you could use @include border-radius($radius, $vertical-radius)\n\t\t\t\tborder-radius: 100%;\n\t\t\t\tcolor: $white;\n\t\t\t\tbackground-color: $color_razzmatazz_approx;\n\t\t\t\t&:hover {\n\t\t\t\t\tcolor: $white;\n\t\t\t\t\tbackground-color: $color_razzmatazz_approx;\n\t\t\t\t}\n\t\t\t\t&:focus {\n\t\t\t\t\tcolor: $white;\n\t\t\t\t\tbackground-color: $color_razzmatazz_approx;\n\t\t\t\t}\n\t\t\t\t&:active {\n\t\t\t\t\tcolor: $white;\n\t\t\t\t\tbackground-color: $color_razzmatazz_approx;\n\t\t\t\t\tbackground-color: $smalt \\9;\n\t\t\t\t}\n\t\t\t\t&.active {\n\t\t\t\t\tcolor: $white;\n\t\t\t\t\tbackground-color: $color_razzmatazz_approx;\n\t\t\t\t\tbackground-color: $smalt \\9;\n\t\t\t\t}\n\t\t\t\t&.disabled {\n\t\t\t\t\tcolor: $white;\n\t\t\t\t\tbackground-color: $color_razzmatazz_approx;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&:focus {\n\t\t\t\tcolor: $white;\n\t\t\t\tbackground-color: $color_razzmatazz_approx;\n\t\t\t}\n\t\t\t&:active {\n\t\t\t\tcolor: $white;\n\t\t\t\tbackground-color: $color_razzmatazz_approx;\n\t\t\t\tbackground-color: $smalt \\9;\n\t\t\t}\n\t\t\t&.active {\n\t\t\t\tcolor: $white;\n\t\t\t\tbackground-color: $color_razzmatazz_approx;\n\t\t\t\tbackground-color: $smalt \\9;\n\t\t\t}\n\t\t\t&.disabled {\n\t\t\t\tcolor: $white;\n\t\t\t\tbackground-color: $color_razzmatazz_approx;\n\t\t\t}\n\t\t\t&:hover[disabled] {\n\t\t\t\tcolor: $white;\n\t\t\t\tbackground-color: $color_razzmatazz_approx;\n\t\t\t}\n\t\t}\n\t\t&.active[disabled] {\n\t\t\tcolor: $white;\n\t\t\tbackground-color: $color_razzmatazz_approx;\n\t\t}\n\t\tspan {\n\t\t\tdisplay: block;\n\t\t\twidth: 47px;\n\t\t\theight: 54px;\n\t\t\tline-height: 54px;\n\t\t\tfloat: left;\n\t\t\tmargin: 2px;\n\t\t\tcursor: pointer;\n\t\t\t//Instead of the line below you could use @include border-radius($radius, $vertical-radius)\n\t\t\tborder-radius: 100%;\n\t\t\t&:hover {\n\t\t\t\tbackground: $color_gallery_approx;\n\t\t\t\t//Instead of the line below you could use @include border-radius($radius, $vertical-radius)\n\t\t\t\tborder-radius: 100%;\n\t\t\t}\n\t\t\t&.active {\n\t\t\t\tcolor: $white;\n\t\t\t\t//Instead of the line below you could use @include text-shadow($shadow-1, $shadow-2, $shadow-3, $shadow-4, $shadow-5, $shadow-6, $shadow-7, $shadow-8, $shadow-9, $shadow-10)\n\t\t\t\ttext-shadow: 0 -1px 0 $black_25;\n\t\t\t\t&:hover {\n\t\t\t\t\tcolor: $white;\n\t\t\t\t\tbackground-color: $color_cobalt_approx;\n\t\t\t\t\t*background-color: $color_cobalt_approx;\n\t\t\t\t}\n\t\t\t\t&:focus {\n\t\t\t\t\tcolor: $white;\n\t\t\t\t\tbackground-color: $color_cobalt_approx;\n\t\t\t\t\t*background-color: $color_cobalt_approx;\n\t\t\t\t}\n\t\t\t\t&:active {\n\t\t\t\t\tcolor: $white;\n\t\t\t\t\tbackground-color: $color_cobalt_approx;\n\t\t\t\t\t*background-color: $color_cobalt_approx;\n\t\t\t\t\tbackground-color: $smalt \\9;\n\t\t\t\t}\n\t\t\t\t&.active {\n\t\t\t\t\tcolor: $white;\n\t\t\t\t\tbackground-color: $color_cobalt_approx;\n\t\t\t\t\t*background-color: $color_cobalt_approx;\n\t\t\t\t\tbackground-color: $smalt \\9;\n\t\t\t\t}\n\t\t\t\t&.disabled {\n\t\t\t\t\tcolor: $white;\n\t\t\t\t\tbackground-color: $color_cobalt_approx;\n\t\t\t\t\t*background-color: $color_cobalt_approx;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.active[disabled] {\n\t\t\t\tcolor: $white;\n\t\t\t\tbackground-color: $color_cobalt_approx;\n\t\t\t\t*background-color: $color_cobalt_approx;\n\t\t\t}\n\t\t\t&.old {\n\t\t\t\tcolor: $color_mountain_mist_approx;\n\t\t\t}\n\t\t}\n\t}\n\t&:before {\n\t\tcontent: '';\n\t\tdisplay: inline-block;\n\t\tborder-left: 7px solid transparent;\n\t\tborder-right: 7px solid transparent;\n\t\tborder-bottom: 7px solid $color_celeste_approx;\n\t\tborder-bottom-color: $black_20;\n\t\tposition: absolute;\n\t\ttop: -7px;\n\t\tleft: 6px;\n\t}\n\t&:after {\n\t\tcontent: '';\n\t\tdisplay: inline-block;\n\t\tborder-left: 6px solid transparent;\n\t\tborder-right: 6px solid transparent;\n\t\tborder-bottom: 6px solid $white;\n\t\tposition: absolute;\n\t\ttop: -6px;\n\t\tleft: 7px;\n\t}\n\t> div {\n\t\tdisplay: none;\n\t}\n\ttable {\n\t\twidth: 100%;\n\t\tmargin: 0;\n\t}\n\tthead tr:first-child th {\n\t\tcursor: pointer;\n\t\t&:hover {\n\t\t\tbackground: $color_gallery_approx;\n\t\t}\n\t}\n}\n\n.datepic_box .datepicker {\n\twidth: 100%;\n\tbackground-color: transparent;\n\tborder-bottom: 1px solid $color_alto_approx;\n\tborder-left: none;\n\tborder-right: none;\n\tborder-top: none;\n\tpadding: 7px;\n\t//Instead of the line below you could use @include border-radius($radius, $vertical-radius)\n\tborder-radius: 0;\n}\n.datepic_box .datepicker {\n\tpadding-left: 0;\n}\n\n.input-append.date .add-on i {\n\tdisplay: block;\n\tcursor: pointer;\n\twidth: 16px;\n\theight: 16px;\n}\n.input-prepend.date .add-on i {\n\tdisplay: block;\n\tcursor: pointer;\n\twidth: 16px;\n\theight: 16px;\n}\n\n.wrapper-dropdownbox {\n\tposition: relative;\n\twidth: 100%;\n\tmargin: 0 auto;\n\tpadding: 10px;\n\tbackground: $white;\n\tborder-bottom: 1px solid $color_alto_approx;\n\t//Instead of the line below you could use @include box-shadow($shadow-1, $shadow-2, $shadow-3, $shadow-4, $shadow-5, $shadow-6, $shadow-7, $shadow-8, $shadow-9, $shadow-10)\n\tbox-shadow: 0 1px 1px $mine_shaft_10;\n\tcursor: pointer;\n\toutline: none;\n\t&:after {\n\t\tcontent: \"\";\n\t\twidth: 0;\n\t\theight: 0;\n\t\tposition: absolute;\n\t\tright: 15px;\n\t\ttop: 50%;\n\t\tmargin-top: 0;\n\t\tborder-width: 10px 10px 0 10px;\n\t\tborder-style: solid;\n\t\tborder-color: $color_alto_approx transparent;\n\t}\n\t.dropdown {\n\t\tposition: absolute;\n\t\ttop: 100%;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tpadding: 0;\n\t\tmargin: 0;\n\t\tbackground: $white;\n\t\tborder: 1px solid $black_17;\n\t\tfont-weight: normal;\n\t\t//Instead of the line below you could use @include transition($transition-1, $transition-2, $transition-3, $transition-4, $transition-5, $transition-6, $transition-7, $transition-8, $transition-9, $transition-10)\n\t\ttransition: all 0.5s ease-in;\n\t\tlist-style: none;\n\t\topacity: 0;\n\t\tpointer-events: none;\n\t\tli {\n\t\t\ta {\n\t\t\t\tdisplay: block;\n\t\t\t\tpadding: 10px;\n\t\t\t\ttext-decoration: none;\n\t\t\t\tcolor: $black;\n\t\t\t\tborder-bottom: 1px solid $color_gray_nurse_approx;\n\t\t\t\t//Instead of the line below you could use @include box-shadow($shadow-1, $shadow-2, $shadow-3, $shadow-4, $shadow-5, $shadow-6, $shadow-7, $shadow-8, $shadow-9, $shadow-10)\n\t\t\t\tbox-shadow: inset 0 1px 0 $white_100;\n\t\t\t\t//Instead of the line below you could use @include transition($transition-1, $transition-2, $transition-3, $transition-4, $transition-5, $transition-6, $transition-7, $transition-8, $transition-9, $transition-10)\n\t\t\t\ttransition: all 0.3s ease-out;\n\t\t\t}\n\t\t\ti {\n\t\t\t\tfloat: right;\n\t\t\t\tcolor: inherit;\n\t\t\t}\n\t\t\t&:first-of-type a {\n\t\t\t\t//Instead of the line below you could use @include border-radius($radius, $vertical-radius)\n\t\t\t\tborder-radius: 7px 7px 0 0;\n\t\t\t}\n\t\t\t&:last-of-type a {\n\t\t\t\tborder: none;\n\t\t\t\t//Instead of the line below you could use @include border-radius($radius, $vertical-radius)\n\t\t\t\tborder-radius: 0 0 7px 7px;\n\t\t\t}\n\t\t\t&:hover a {\n\t\t\t\tbackground: $color_black_squeeze_approx;\n\t\t\t}\n\t\t}\n\t}\n\t&.active .dropdown {\n\t\topacity: 1;\n\t\tpointer-events: auto;\n\t}\n}\n\n.modal-content{\n    border : 0px;\n    border-radius : 0px;\n    padding: 15px;   \n}\n","\n    @media screen and (min-width: 1024px){\n        .container {\n            max-width: 1024px;\n            padding: 0 20px;\n            // margin-left: 0;\n        }\n        .textalign-right{text-align: right;}\n    }\n    @media only screen and (max-width: 1024px){\n        .textalign-right{text-align: right;}\n    .container {\n        max-width: 100%;\n    }\n    \n    .logo-wrapper{\n        margin: 20px 0 0 0!important;\n        .payment-logo {\n            max-width: 175px;\n        }\n    }\n    \n    }\n    @media screen and (min-width:769px) and (max-width:991px){\n        .device-box.col-md-3{\n            flex: 0 0 50%;\n            max-width: 50%;\n    \n            a{\n                width:100%;\n            }\n        }\n    }\n    \n@media screen and (max-width: 768px) {\n    \n    #footer{\n        padding: 15px;\n        .application-footer{\n            .gray-link{\n                display: block;\n            }\n        }\n    }\n    .upgradeSubheader .modal-dialog {\n        max-width: 80%;\n        margin: 1.75rem auto;\n\n        .modal-content {\n           \n            max-height: 500px;\n            overflow-y: scroll;\n        }\n    }\n    \n}\n\n\n@media screen and (min-width: 768px) and (max-width:991px) {\n   \n    app-choose-device{\n        .col-md-3 {\n            flex: 0 0 50%;\n            max-width: 50%;\n            padding: 15px;\n        }\n    }    \n    .upgradeSubheader .modal-dialog {\n        max-width: 80%;\n        margin: 1.75rem auto;\n    }\n    \n}\n@media screen and (min-width:576px) and (max-width:1199px){\n    .sort{\n        text-align: left!important;\n    }\n    // .product-details[_ngcontent-c4] .partition[_ngcontent-c4]:nth-child(1) {\n    //     margin-top: 25px;\n    //     padding-top: 15px;\n    // }\n    .product-details .details .small-legal-grey{\n        padding-left: 30px!important;\n    }\n    // .mat-form-field-infix{\n    //     width: auto;\n    //     .mat-select-value{\n    //         width: 100%!important;\n    //         max-width: 0!important;\n    //     }\n    // }\n}\n@media screen and (max-width: 575px) {\n    .phone-box {\n        max-width: 414px;\n        width: 100%;\n       \n    margin: 7.5px auto!important;\n\n        .phone-box .img-wrapper img {\n            max-width: 150px !important;\n            width: 100%;\n        }\n    }\n    .textalign-right{text-align: left;}\n    // .product-details .details .mat-radio-button {\n    //     padding: 0 15px;\n    // }\n    .upgradeLinesContainer{\n        .text-right{\n            text-align: left!important;\n        }\n    }\n    .storage{\n        \n        .memory-size{\n            h6{padding: 10px 30px!important}\n        }\n}\n/* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/\n.mat-form-field-infix{\n    width: 180px!important;\n\n    // \n    \n}\n\n}\n\n/*------------Manage Modal Pop Up-------------*/\n\n.modal-dialog {\n    max-width: 672px !important;\n     @media screen and (max-width: 767px) {\n        height: 100%;\n        width: 100%;\n        transform: none !important;\n        margin: 0;\n        max-width: max-content !important;\n        min-width: 100%;\n    }\n}\n\n.modal-content{\n    @media screen and (max-width: 767px) {\n        width: 100%;\n        min-height: 100%;\n        max-height: fit-content;\n    }\n}\n\n#managePopUp {\n    .secondary_btn {\n        min-width: 150px;\n        min-height: 48px;\n        background-color: #fff;\n        color: #000;\n        border: 1px solid #000;\n        cursor: pointer;\n    }\n\n    .modal-header, .modal-footer {\n        border : 0px solid #e9ecef\n    }\n    .single-change-content {\n        .head {\n            font-size: 10px;\n            font-weight: bold;\n            margin-bottom: 2px;\n        }\n        .content {\n            font-size: 10px;\n        }\n    }\n    .modal-title {\n        padding-right: 32px;\n        font-family: Tele-Grotesk-Ultr;\n        font-size: 32px;\n        font-weight: normal;\n        font-style: normal;\n        font-stretch: normal;\n        letter-spacing: -0.3px;\n        text-align: left;\n        color: #000;\n    }\n    .modal-header {\n        border: 0;\n        padding: 20px 30px;\n    }\n    .modal-subtitle {\n        font-family: Tele-GroteskHal;\n        font-size: 24px;\n        font-weight: normal;\n        font-style: normal;\n        font-stretch: normal;\n        letter-spacing: -0.3px;\n        text-align: left;\n        color: #000;\n        padding: 0;\n        margin: 0 0 30px 0;\n    }\n    .modal-subtitle {\n        font-family: Tele-GroteskHal;\n        font-size: 24px;\n        font-weight: normal;\n        font-style: normal;\n        font-stretch: normal;\n        letter-spacing: -0.3px;\n        text-align: left;\n        color: #000;\n        padding: 0;\n        margin: 0 0 30px 0;\n    }\n    .acceptanceText {\n        font-family: Arial;\n        font-size: 11px;\n        font-weight: normal;\n        font-style: normal;\n        font-stretch: normal;\n        line-height: 1.45;\n        letter-spacing: .3px;\n        text-align: left;\n        color: #6a6a6a;\n    }\n    .primary_btn:disabled, .primary_btn:disabled:hover{\n        background-color: #e8e8e8;\n        color: #9b9b9b;\n    }\n    button[disabled]{\n        cursor: default;\n    }\n    \n    .checkBoxDisabled label {\n        background-color: #eee;\n        cursor: not-allowed;\n    }\n    .modal-body p {\n        font-family: Arial;\n        font-size: 14px;\n        font-weight: normal;\n        font-style: normal;\n        font-stretch: normal;\n        line-height: 1.33;\n        letter-spacing: .6px;\n        text-align: left;\n        color: #4c4c4c;\n        margin-bottom: 30px;\n        padding: 0;\n        width: 100%;\n    }\n    .input-wrapper {\n        margin-top: 10px;\n        height: 27px;\n        border-bottom: 1px solid #ddd;\n    }\n    .input-select {\n        border: 0;\n        outline: 0;\n        font-size: 15px;\n        line-height: 18px;\n        color: #000;\n        font-family: Arial;\n        width: 100%;\n        -webkit-appearance: none;\n        background-position: right center;\n    }\n  \n    .floating-label-novalue {\n        color: #6a6a6a;\n        font-family: Arial;\n        font-size: 14px;\n        line-height: 20px;\n        float: left;\n        letter-spacing: -0.14px;\n        top: -20px;\n        position: relative;\n        transition: .2s ease all;\n    }\n    \n    .api-error {\n        font-size: 11px;\n        line-height: 16px;\n        color: red;\n        padding-bottom: 20px;\n        float: left;\n        width: 100%;\n    }\n    \n    .floating-label-hasvalue {\n        position: relative;\n        pointer-events: none;\n        left: 0;\n        transition: .2s ease all;\n        color: #999;\n        font-family: Arial;\n        font-size: 11px;\n        line-height: 16px;\n        top: -50px;\n        bottom: 10px;\n        left: 0;\n        opacity: 1;\n        word-wrap: break-word;\n    }\n    \n}\n\n@media screen and (max-width: 767px) {\n    #managePopUp {\n        .modal-title {       \n        font-size: 24px;\n        } \n        .modal-header {\n            border: 0;\n            padding: 16px 16px;\n            justify-content: normal !important;\n        }\n        .modal-body {\n            padding: 0 16px 0 16px;\n          }\n        .modal-subtitle {\n            margin-bottom: 15px;\n            font-size: 18px;\n        }\n        .primary_btn {\n            width: 100% !important;\n        }\n    }\n    .primary_btn {\n        width: 100% !important;\n    }\n    .secondary_btn {\n        width: 100% !important;\n    }\n}\n\n@media (min-width:768px) {\n    #managePopUp {        \n        \n        .close {\n            font-size: 40px;\n            font-weight: normal;\n            position: absolute;\n            z-index: 150000;\n            right: 24px;\n            top: 24px;\n            opacity: 1;\n        }        \n        .modal-body {\n            padding: 0 32px 0 32px;\n          }\n    }  \n    .primary_btn {\n        float: none;\n        min-width: 150px;\n        min-height: 48px;\n        background-color: #e20074;\n        color: #fff;\n        border: 0;\n    }    \n}\n\n.accordion-txt {\n    text-decoration: none!important;\n    font-size: 24px;\n    font-weight: bold;\n    font-family: Tele-Grotesk-Ultr;\n    color: black;\n    float: left;\n}\n\n.mat-expansion-panel:not(.mat-expanded) .mat-expansion-panel-header:not([aria-disabled=true])\n{\n    background: none !important; \n\t\n}\n\n","@import 'variables.scss';\n\n@media (max-width:768px){\n    .ngx-pagination li.pagination-previous, .ngx-pagination li.pagination-next {padding: 10px 2px;}\n}\n@media (max-width:576px){\n    .ngx-pagination li a{letter-spacing: 0; padding: 6px;}  \n    .pagination-block {\n        .ngx-pagination{\n        text-align: center !important;\n    } \n}\n}\n\n.mat-ink-bar{\n    height:4px !important;\n}\n/* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version.*/\n.mat-select-trigger, .mat-select-trigger:hover{\n    width: 100%;\n}\n// .mat-form-field-infix, .mat-form-field-infix .mat-select .mat-select-arrow-wrapper .mat-select-arrow {\n//    @media (max-width:576px) {\n//     padding: 8px 2px;\n//    }\n// }\n.modal-backdrop{z-index: 99991 !important;}\n.modal{z-index: 99991 !important;}\n\n.clr{clear: both !important;}\n\n/** modal start**/\n.modal-title{\n    line-height: 32px;\n    font-size: 32px;\n    font-family: Tele-Grotesk-Ultr;\n    letter-spacing: -1px;\n    @media (max-width:576px){\n        font-size: 26px;\n    }\n}\n\n#cusmodal .modal-header{\npadding:15px;\n}\n#cusmodal .modal-body{\n    padding: 15px;\n}\n#cusmodal .modal-footer{\n    display: initial !important;\n    justify-content: flex-start;\n    padding: 15px;\n    float: left;\n    width: 100%;\n    border: 0;\n}\n.ml-15{\n    margin-left: -15px;\n}\n#cusmodal .primary_btn{\n    float: none;\n    width: 100%;\n}\n.acceptanceText{\n    @media (max-width:576px){\n        font-size: 11px;\n    }\n}\n/** modal end**/\n/** modal show top start **/\n// .modal{\n//     z-index: 9999 !important;\n// }\n.modal.show {\n    .modal-dialog{\n    -webkit-transform: translate(0,110px);\n    transform: translate(0,110px);\n}\n}\n\n.modal-header {\n    .close{\n    outline: none;\n    font-size: 24px;\n    span{\n        font-size: 26px;\n    }\n}\n}\n.modal-subtitle{\n    .selected-number{\n        font-family: Arial, Helvetica, sans-serif;\n    font-size: 22px;\n    font-weight: normal;\n    font-style: normal;\n    letter-spacing: -1px;\n    text-align: left;\n    color: #000;\n    padding: 0;\n    margin-bottom: 30px;\n    display: inline-block;\n    }\n}\n/** modal show top end **/\n\n.dropdown-item.active, .dropdown-item:active{\n    background-color: #fff;\n    color: $base-color;\n}\n\n.cdk-overlay-container{\n    z-index: 99999;\n}\n// #bulk-upload-care{\n//     cursor: pointer;\n//     font-size: 18px;\n//     font-weight: bold;\n//     letter-spacing: -0.5;\n// }\n.txtColor {\n    button{\n        cursor: pointer;\n    }\n}\n.w100{\n    width: 100% !important;\n    @media screen and (min-width: 768px) and (max-width:1024px) and (orientation: portrait) {\n        width: 150% !important;\n    }\n}\n// material dropdown width according to its parent \n// .cdk-overlay-pane{\n//     transform: translateX(0) translateY(-15px) !important; \n   \n// }\n\n\n.mat-mdc-select-panel{\n    width: 100% !important;\n    min-width: calc(100% + 1px) !important;\n    max-width: 0 !important;\n  //  left: 16px !important;\n    transform-origin: 0 0 !important;\n    top: 10px !important;\n    position: relative !important;\n    background-color: #fff;\n    &.manage-line-panel{\n      min-width: calc(100% + 100px) !important;\n    }\n    &.multpl-chkbx-mat-select {\n     // left: 44px!important;\n      background-color: #fff;\n    }\n     @media screen and (max-width: 1024px) {\n        min-width: calc(100% + 0px) !important;\n        left: 7px !important;\n    } \n}\n// .mat-select-panel:focus {\n//     width: 100% !important;\n// }\n/* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version.*/\n.mat-select-trigger { min-width: 50px !important; }\n/* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version.*/\n.acctmgmt .mat-mdc-select .mat-select-trigger {\n    min-width: 60px !important;\n    justify-content: space-between !important;\n}\n  /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/\n  .mat-mdc-form-field.mat-focused .mat-form-field-ripple{\n      background-color: $base-color;\n  }\n.mat-mdc-dialog-container {\n    width: 0px!important;\n    height: 0px!important;\n    padding: 0px!important;\n  }\n// .mat-form-field-infix .mat-select .mat-select-value{\n//       max-width: 0 !important;\n//   }\n//\n/* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/\n.mat-form-field-infix .mat-form-field-label-wrapper .mat-form-field-label{\n    color: #8e8e8e;\n    @media screen and (max-width: 767px) {\n        font-size: 14px !important;\n        color: #6A6A6A !important;\n        }\n}\n/* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/\n.enable-empty .mat-form-field-appearance-legacy .mat-form-field-wrapper{\n    min-width: 110px !important;\n}\n/* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/\n.mat-form-field-appearance-legacy .mat-form-field-underline{\n    background: rgba(0,0,0,.15)\n}\n/* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version.*/\n.mat-select-content{\n    width: 100% !important;\n    \n}\n.mat-mdc-option{\n    padding: 0 12px !important;\n}\n.cdk-overlay-pane:focus{\n    overflow: hidden !important;\n}\n.successClass{\n    /*change color of underline*/\n    background-color: green !important;\n  } \n.errorClass{\n    /*change color of underline*/\n   background-color: red !important;\n  } \n\n\n\n\n\n// modal custom //\n#managePopUp {\n    .modal-header{\n        padding: 1rem;\n    }\n    .modal-body {\n        position: relative;\n        flex: 1 1 auto;\n        padding: 1rem;\n    }\n    .modal-footer{\n        justify-content: flex-start;\n    }\n    /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/\n    /* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/\n    .mat-form-field-infix {\n        .mat-mdc-select {\n            /* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version.*/\n            .mat-select-value-text{\n                padding-right:5px !important;\n            }\n        }\n        \n    }  \n\n}\n.pagination-num-bx{\n    width: 100px!important;\n    @media (max-width:576px) {\n        width: auto;\n    }\n}\n\n\n/* TODO(mdc-migration): The following rule targets internal classes of form-field that may no longer apply for the MDC version.*/\napp-change-number-form .mat-form-field-infix .mat-form-field-label-wrapper .mat-form-field-label{\n    width: 100% !important;\n    padding-right: 15px !important;\n}\n.gray-bg\n{\n    background-color:#DDDDDD !important\n}\n.only-bdr-btn\n{\n    background-color: #ffffff !important;\n    border: 1px solid #000 !important;\n}\n\n\n\n.bottom_aligner {\n    @media screen and (max-width: 767px) {\n        position: absolute;\n        bottom: 0;\n    }\n  \n}\n.popup_btnbox {\n    @media screen and (max-width: 767px) {\n        float: left;\n        width: 100%;\n        padding: 0 32px 32px 0px;\n        display: flex;\n      flex-direction: column-reverse;\n    }\n}","@import 'variables.scss';\n\n\n/* no padding */\n.p-t-0{padding-top: 0 !important;}\n.p-b-0{padding-bottom: 0 !important;}\n.p-l-0{padding-left: 0 !important;}\n.p-r-0{padding-right: 0 !important;}\n.p-a-0{padding: 0 !important;}\n\n/* Padding all */\n.p-a-5{padding: 5px !important;}\n.p-a-10{padding: 10px !important;}\n.p-a-15{padding: 15px !important;}\n.p-a-20{padding: 20px !important;}\n.p-a-35{padding: 35px !important;}\n.p-a-50{padding: 50px !important;}\n\n/* Padding left */\n.p-l-5{padding-left: 5px !important;}\n.p-l-10{padding-left: 10px !important;}\n.p-l-15{padding-left: 15px !important;}\n.p-l-20{padding-left: 20px !important;}\n.p-l-30{padding-left: 30px !important;}\n.p-l-35{padding-left: 35px !important;}\n.p-l-50{padding-left: 50px !important;}\n\n/* Padding right */\n.p-r-5{padding-right: 5px !important;}\n.p-r-10{padding-right: 10px !important;}\n.p-r-15{padding-right: 15px !important;}\n.p-r-20{padding-right: 20px !important;}\n.p-r-35{padding-right: 35px !important;}\n.p-r-50{padding-right: 50px !important;}\n\n/* Padding top */\n.p-t-5{padding-top: 5px !important;}\n.p-t-10{padding-top: 10px !important;}\n.p-t-15{padding-top: 15px !important;}\n.p-t-20{padding-top: 20px !important;}\n.p-t-35{padding-top: 35px !important;}\n.p-t-50{padding-top: 50px !important;}\n\n/* padding bottom */\n.p-b-5{padding-bottom: 5px !important;}\n.p-b-10{padding-bottom: 10px !important;}\n.p-b-15{padding-bottom: 15px !important;}\n.p-b-20{padding-bottom: 20px !important;}\n.p-b-35{padding-bottom: 35px !important;}\n.p-b-50{padding-bottom: 50px !important;}\n\n@media screen and (min-width: $mobileMin) {\n  .p-xs-t-50 { padding-top: $globalSpacingXXL !important; }\n  .p-xs-b-50 { padding-bottom: $globalSpacingXXL !important; }\n  .p-xs-l-50 { padding-left: $globalSpacingXXL !important; }\n  .p-xs-r-50 { padding-right: $globalSpacingXXL !important; }\n\n  .p-xs-l-35 { padding-left: $globalSpacingXL !important; }\n  .p-xs-r-35 { padding-right: $globalSpacingXL !important; }\n  .p-xs-t-35 { padding-top: $globalSpacingXL !important; }\n  .p-xs-b-35 { padding-bottom: $globalSpacingXL !important; }\n\n  .p-xs-l-20 { padding-left: $globalSpacingLarge !important; }\n  .p-xs-r-20 { padding-right: $globalSpacingLarge !important; }\n  .p-xs-t-20 { padding-top: $globalSpacingLarge !important; }\n  .p-xs-b-20 { padding-bottom: $globalSpacingLarge !important; }\n\n  .p-xs-l-15 { padding-left: $globalSpacingMedium !important; }\n  .p-xs-r-15 { padding-right: $globalSpacingMedium !important; }\n  .p-xs-t-15 { padding-top: $globalSpacingMedium !important; }\n  .p-xs-b-15 { padding-bottom: $globalSpacingMedium !important; }\n\n  .p-xs-l-10 { padding-left: $globalSpacingSmall !important; }\n  .p-xs-r-10 { padding-right: $globalSpacingSmall !important; }\n  .p-xs-t-10 { padding-top: $globalSpacingSmall !important; }\n  .p-xs-b-10 { padding-bottom: $globalSpacingSmall !important; }\n\n  .p-xs-l-5 { padding-left: $globalSpacingXSmall !important; }\n  .p-xs-r-5 { padding-right: $globalSpacingXSmall !important; }\n  .p-xs-t-5 { padding-top: $globalSpacingXSmall !important; }\n  .p-xs-b-5 { padding-bottom: $globalSpacingXSmall !important; }\n\n  .p-xs-l-0 { padding-left: 0 !important;}\n  .p-xs-r-0 { padding-right: 0 !important; }\n  .p-xs-t-0 { padding-top: 0 !important; }\n  .p-xs-b-0 { padding-bottom: 0 !important; }\n  .p-xs-a-0 { padding: 0 !important;}\n}\n\n@media screen and (min-width: $device-min-sm) {\n  .p-sm-t-50 { padding-top: $globalSpacingXXL !important; }\n  .p-sm-b-50 { padding-bottom: $globalSpacingXXL !important; }\n  .p-sm-l-50 { padding-left: $globalSpacingXXL !important; }\n  .p-sm-r-50 { padding-right: $globalSpacingXXL !important; }\n\n  .p-sm-l-35 { padding-left: $globalSpacingXL !important; }\n  .p-sm-r-35 { padding-right: $globalSpacingXL !important; }\n  .p-sm-t-35 { padding-top: $globalSpacingXL !important; }\n  .p-sm-b-35 { padding-bottom: $globalSpacingXL !important; }\n\n  .p-sm-l-20 { padding-left: $globalSpacingLarge !important; }\n  .p-sm-r-20 { padding-right: $globalSpacingLarge !important; }\n  .p-sm-t-20 { padding-top: $globalSpacingLarge !important; }\n  .p-sm-b-20 { padding-bottom: $globalSpacingLarge !important; }\n\n  .p-sm-l-15 { padding-left: $globalSpacingMedium !important; }\n  .p-sm-r-15 { padding-right: $globalSpacingMedium !important; }\n  .p-sm-t-15 { padding-top: $globalSpacingMedium !important; }\n  .p-sm-b-15 { padding-bottom: $globalSpacingMedium !important; }\n\n  .p-sm-l-10 { padding-left: $globalSpacingSmall !important; }\n  .p-sm-r-10 { padding-right: $globalSpacingSmall !important; }\n  .p-sm-t-10 { padding-top: $globalSpacingSmall !important; }\n  .p-sm-b-10 { padding-bottom: $globalSpacingSmall !important; }\n\n  .p-sm-l-5 { padding-left: $globalSpacingXSmall !important;}\n  .p-sm-r-5 { padding-right: $globalSpacingXSmall !important; }\n  .p-sm-t-5 { padding-top: $globalSpacingXSmall !important; }\n  .p-sm-b-5 { padding-bottom: $globalSpacingXSmall !important; }\n\n  .p-sm-a-0 { padding: 0 !important;}\n  .p-sm-l-0 { padding-left: 0 !important;}\n  .p-sm-r-0 { padding-right: 0 !important; }\n  .p-sm-t-0 { padding-top: 0 !important; }\n  .p-sm-b-0 { padding-bottom: 0 !important; }\n}\n\n@media screen and (min-width: $screen-md-min) {\n  .p-md-t-50 { padding-top: $globalSpacingXXL !important; }\n  .p-md-b-50 { padding-bottom: $globalSpacingXXL !important; }\n  .p-md-l-50 { padding-left: $globalSpacingXXL !important; }\n  .p-md-r-50 { padding-right: $globalSpacingXXL !important; }\n\n  .p-md-l-35 { padding-left: $globalSpacingXL !important; }\n  .p-md-r-35 { padding-right: $globalSpacingXL !important; }\n  .p-md-t-35 { padding-top: $globalSpacingXL !important; }\n  .p-md-b-35 { padding-bottom: $globalSpacingXL !important; }\n\n  .p-md-l-20 { padding-left: $globalSpacingLarge !important; }\n  .p-md-r-20 { padding-right: $globalSpacingLarge !important; }\n  .p-md-t-20 { padding-top: $globalSpacingLarge !important; }\n  .p-md-b-20 { padding-bottom: $globalSpacingLarge !important; }\n\n  .p-md-l-15 { padding-left: $globalSpacingMedium !important; }\n  .p-md-r-15 { padding-right: $globalSpacingMedium !important; }\n  .p-md-t-15 { padding-top: $globalSpacingMedium !important; }\n  .p-md-b-15 { padding-bottom: $globalSpacingMedium !important; }\n\n  .p-md-l-10 { padding-left: $globalSpacingSmall !important; }\n  .p-md-r-10 { padding-right: $globalSpacingSmall !important; }\n  .p-md-t-10 { padding-top: $globalSpacingSmall !important; }\n  .p-md-b-10 { padding-bottom: $globalSpacingSmall !important; }\n\n  .p-md-l-5 { padding-top: $globalSpacingXSmall !important;}\n  .p-md-r-5 { padding-right: $globalSpacingXSmall !important; }\n  .p-md-t-5 { padding-top: $globalSpacingXSmall !important; }\n  .p-md-b-5 { padding-bottom: $globalSpacingXSmall !important; }\n\n  .p-md-l-0 { padding-left: 0 !important;}\n  .p-md-r-0 { padding-right: 0 !important; }\n  .p-md-t-0 { padding-top: 0 !important; }\n  .p-md-b-0 { padding-bottom: 0 !important; }\n  .p-md-a-0 { padding: 0 !important;}\n}\n\n@media screen and (min-width: $screen-lg-min){\n  .p-lg-t-50 { padding-top: $globalSpacingXXL !important; }\n  .p-lg-b-50 { padding-bottom: $globalSpacingXXL !important; }\n  .p-lg-l-50 { padding-left: $globalSpacingXXL !important; }\n  .p-lg-r-50 { padding-right: $globalSpacingXXL !important; }\n  .p-lg-a-50 { padding: $globalSpacingXXL !important;}\n\n  .p-lg-l-35 { padding-left: $globalSpacingXL !important; }\n  .p-lg-r-35 { padding-right: $globalSpacingXL !important; }\n  .p-lg-t-35 { padding-top: $globalSpacingXL !important; }\n  .p-lg-b-35 { padding-bottom: $globalSpacingXL !important; }\n  .p-lg-a-35 { padding: $globalSpacingXL !important;}\n\n  .p-lg-l-20 { padding-left: $globalSpacingLarge !important; }\n  .p-lg-r-20 { padding-right: $globalSpacingLarge !important; }\n  .p-lg-t-20 { padding-top: $globalSpacingLarge !important; }\n  .p-lg-b-20 { padding-bottom: $globalSpacingLarge !important; }\n  .p-lg-a-20 { padding: $globalSpacingLarge !important;}\n\n  .p-lg-l-15 { padding-left: $globalSpacingMedium !important; }\n  .p-lg-r-15 { padding-right: $globalSpacingMedium !important; }\n  .p-lg-t-15 { padding-top: $globalSpacingMedium !important; }\n  .p-lg-b-15 { padding-bottom: $globalSpacingMedium !important; }\n  .p-lg-a-15 { padding: $globalSpacingMedium !important;}\n\n  .p-lg-l-10 { padding-left: $globalSpacingSmall !important; }\n  .p-lg-r-10 { padding-right: $globalSpacingSmall !important; }\n  .p-lg-t-10 { padding-top: $globalSpacingSmall !important; }\n  .p-lg-b-10 { padding-bottom: $globalSpacingSmall !important; }\n  .p-lg-a-10 { padding: $globalSpacingSmall !important;}\n\n  .p-lg-l-5 { padding-left: $globalSpacingXSmall !important; }\n  .p-lg-r-5 { padding-right: $globalSpacingXSmall !important; }\n  .p-lg-t-5 { padding-top: $globalSpacingXSmall !important; }\n  .p-lg-b-5 { padding-bottom: $globalSpacingXSmall !important; }\n  .p-lg-a-5 { padding: $globalSpacingXSmall !important;}\n\n  .p-lg-l-0 { padding-left: 0 !important;}\n  .p-lg-r-0 { padding-right: 0 !important; }\n  .p-lg-t-0 { padding-top: 0 !important; }\n  .p-lg-b-0 { padding-bottom: 0 !important; }\n  .p-lg-a-0 { padding: 0 !important;}\n}\n\n\n// Global Spacing - margin\n.no-margin { margin: 0 !important; }\n.no-margin-top { margin-top: 0 !important; }\n.no-margin-bottom { margin-bottom: 0 !important; }\n\n/* Margin all */\n.m-a-5{margin: 5px !important;}\n.m-a-10{margin: 10px !important;}\n.m-a-15{margin: 15px !important;}\n.m-a-20{margin: 20px !important;}\n.m-a-35{margin: 35px !important;}\n.m-a-50{margin: 50px !important;}\n\n.m-t-0 { margin-top: 0 !important; }\n.m-b-0 { margin-bottom: 0 !important; }\n.m-l-0 { margin-left: 0 !important; }\n.m-r-0 { margin-right: 0 !important; }\n.m-a-0 { margin: 0 !important;}\n\n.m-t-50 { margin-top: $globalSpacingXXL ; }\n.m-b-50 { margin-bottom: $globalSpacingXXL ; }\n.m-l-50 { margin-left: $globalSpacingXXL ; }\n.m-r-50 { margin-right: $globalSpacingXXL ; }\n\n.m-l-35 { margin-left: $globalSpacingXL ; }\n.m-r-35 { margin-right: $globalSpacingXL ; }\n.m-t-35 { margin-top: $globalSpacingXL ; }\n.m-b-35 { margin-bottom: $globalSpacingXL ; }\n\n.m-l-20 { margin-left: $globalSpacingLarge ; }\n.m-r-20 { margin-right: $globalSpacingLarge ; }\n.m-t-20 { margin-top: $globalSpacingLarge ; }\n.m-b-20 { margin-bottom: $globalSpacingLarge ; }\n\n.m-l-15 { margin-left: $globalSpacingMedium ; }\n.m-r-15 { margin-right: $globalSpacingMedium ; }\n.m-t-15 { margin-top: $globalSpacingMedium ; }\n.m-b-15 { margin-bottom: $globalSpacingMedium ; }\n\n.m-l-10 { margin-left: $globalSpacingSmall ; }\n.m-r-10 { margin-right: $globalSpacingSmall ; }\n.m-t-10 { margin-top: $globalSpacingSmall ; }\n.m-b-10 { margin-bottom: $globalSpacingSmall ; }\n\n.m-l-5 { margin-left: $globalSpacingXSmall ;}\n.m-r-5 { margin-right: $globalSpacingXSmall ; }\n.m-t-5 { margin-top: $globalSpacingXSmall ; }\n.m-b-5 { margin-bottom: $globalSpacingXSmall ; }\n\n@media screen and (min-width: $mobileMin) {\n  .m-xs-t-50 { margin-top: $globalSpacingXXL ; }\n  .m-xs-b-50 { margin-bottom: $globalSpacingXXL ; }\n  .m-xs-l-50 { margin-left: $globalSpacingXXL ; }\n  .m-xs-r-50 { margin-right: $globalSpacingXXL ; }\n  .m-xs-a-50 { margin: $globalSpacingXXL ;}\n\n  .m-xs-l-35 { margin-left: $globalSpacingXL ; }\n  .m-xs-r-35 { margin-right: $globalSpacingXL ; }\n  .m-xs-t-35 { margin-top: $globalSpacingXL ; }\n  .m-xs-b-35 { margin-bottom: $globalSpacingXL ; }\n  .m-xs-a-35 { margin: $globalSpacingXL ;}\n\n  .m-xs-l-20 { margin-left: $globalSpacingLarge ; }\n  .m-xs-r-20 { margin-right: $globalSpacingLarge ; }\n  .m-xs-t-20 { margin-top: $globalSpacingLarge ; }\n  .m-xs-b-20 { margin-bottom: $globalSpacingLarge ; }\n  .m-xs-a-20 { margin: $globalSpacingLarge ;}\n\n  .m-xs-l-15 { margin-left: $globalSpacingMedium ; }\n  .m-xs-r-15 { margin-right: $globalSpacingMedium ; }\n  .m-xs-t-15 { margin-top: $globalSpacingMedium ; }\n  .m-xs-b-15 { margin-bottom: $globalSpacingMedium ; }\n  .m-xs-a-15 { margin: $globalSpacingMedium ;}\n\n  .m-xs-l-10 { margin-left: $globalSpacingSmall ; }\n  .m-xs-r-10 { margin-right: $globalSpacingSmall ; }\n  .m-xs-t-10 { margin-top: $globalSpacingSmall ; }\n  .m-xs-b-10 { margin-bottom: $globalSpacingSmall ; }\n  .m-xs-a-10 { margin: $globalSpacingSmall ;}\n\n  .m-xs-l-5 { margin-left: $globalSpacingXSmall ; }\n  .m-xs-r-5 { margin-right: $globalSpacingXSmall ; }\n  .m-xs-t-5 { margin-top: $globalSpacingXSmall ; }\n  .m-xs-b-5 { margin-bottom: $globalSpacingXSmall ; }\n  .m-xs-a-5 { margin: $globalSpacingXSmall ;}\n\n  .m-xs-l-0 { margin-left: 0 ;}\n  .m-xs-r-0 { margin-right: 0 ; }\n  .m-xs-t-0 { margin-top: 0 ; }\n  .m-xs-b-0 { margin-bottom: 0 ; }\n  .m-xs-a-0 { margin: 0 ;}\n}\n\n@media screen and (min-width: $device-min-sm) {\n  .m-sm-t-50 { margin-top: $globalSpacingXXL ; }\n  .m-sm-b-50 { margin-bottom: $globalSpacingXXL ; }\n  .m-sm-l-50 { margin-left: $globalSpacingXXL ; }\n  .m-sm-r-50 { margin-right: $globalSpacingXXL ; }\n  .m-sm-a-50 { margin: $globalSpacingXXL ;}\n\n  .m-sm-l-35 { margin-left: $globalSpacingXL ; }\n  .m-sm-r-35 { margin-right: $globalSpacingXL ; }\n  .m-sm-t-35 { margin-top: $globalSpacingXL ; }\n  .m-sm-b-35 { margin-bottom: $globalSpacingXL ; }\n  .m-sm-a-35 { margin: $globalSpacingXL ;}\n\n  .m-sm-l-20 { margin-left: $globalSpacingLarge ; }\n  .m-sm-r-20 { margin-right: $globalSpacingLarge ; }\n  .m-sm-t-20 { margin-top: $globalSpacingLarge ; }\n  .m-sm-b-20 { margin-bottom: $globalSpacingLarge ; }\n  .m-sm-a-20 { margin: $globalSpacingLarge ;}\n\n  .m-sm-l-15 { margin-left: $globalSpacingMedium ; }\n  .m-sm-r-15 { margin-right: $globalSpacingMedium ; }\n  .m-sm-t-15 { margin-top: $globalSpacingMedium ; }\n  .m-sm-b-15 { margin-bottom: $globalSpacingMedium ; }\n  .m-sm-a-15 { margin: $globalSpacingMedium ;}\n\n  .m-sm-l-10 { margin-left: $globalSpacingSmall ; }\n  .m-sm-r-10 { margin-right: $globalSpacingSmall ; }\n  .m-sm-t-10 { margin-top: $globalSpacingSmall ; }\n  .m-sm-b-10 { margin-bottom: $globalSpacingSmall ; }\n  .m-sm-a-10 { margin: $globalSpacingSmall ;}\n\n  .m-sm-l-5 { margin-left: $globalSpacingXSmall ;}\n  .m-sm-r-5 { margin-right: $globalSpacingXSmall ; }\n  .m-sm-t-5 { margin-top: $globalSpacingXSmall ; }\n  .m-sm-b-5 { margin-bottom: $globalSpacingXSmall ; }\n  .m-sm-a-5 { margin: $globalSpacingXSmall ;}\n\n  .m-sm-l-0 { margin-left: 0 ;}\n  .m-sm-r-0 { margin-right: 0 ; }\n  .m-sm-t-0 { margin-top: 0 ; }\n  .m-sm-b-0 { margin-bottom: 0 ; }\n  .m-sm-a-0 { margin: 0 ;}\n}\n\n@media screen and (min-width: $screen-md-min) {\n  .m-md-t-50 { margin-top: $globalSpacingXXL ; }\n  .m-md-b-50 { margin-bottom: $globalSpacingXXL ; }\n  .m-md-l-50 { margin-left: $globalSpacingXXL ; }\n  .m-md-r-50 { margin-right: $globalSpacingXXL ; }\n  .m-md-a-50 { margin: $globalSpacingXXL ;}\n\n  .m-md-l-35 { margin-left: $globalSpacingXL ; }\n  .m-md-r-35 { margin-right: $globalSpacingXL ; }\n  .m-md-t-35 { margin-top: $globalSpacingXL ; }\n  .m-md-b-35 { margin-bottom: $globalSpacingXL ; }\n  .m-md-a-35 { margin: $globalSpacingXL ;}\n\n  .m-md-l-20 { margin-left: $globalSpacingLarge ; }\n  .m-md-r-20 { margin-right: $globalSpacingLarge ; }\n  .m-md-t-20 { margin-top: $globalSpacingLarge ; }\n  .m-md-b-20 { margin-bottom: $globalSpacingLarge ; }\n  .m-md-a-20 { margin: $globalSpacingLarge ;}\n\n  .m-md-l-15 { margin-left: $globalSpacingMedium ; }\n  .m-md-r-15 { margin-right: $globalSpacingMedium ; }\n  .m-md-t-15 { margin-top: $globalSpacingMedium ; }\n  .m-md-b-15 { margin-bottom: $globalSpacingMedium ; }\n  .m-md-a-15 { margin: $globalSpacingMedium ;}\n\n  .m-md-l-10 { margin-left: $globalSpacingSmall ; }\n  .m-md-r-10 { margin-right: $globalSpacingSmall ; }\n  .m-md-t-10 { margin-top: $globalSpacingSmall ; }\n  .m-md-b-10 { margin-bottom: $globalSpacingSmall ; }\n  .m-md-a-10 { margin: $globalSpacingSmall ;}\n\n  .m-md-l-5 { margin-top: $globalSpacingXSmall ;}\n  .m-md-r-5 { margin-right: $globalSpacingXSmall ; }\n  .m-md-t-5 { margin-top: $globalSpacingXSmall ; }\n  .m-md-b-5 { margin-bottom: $globalSpacingXSmall ; }\n  .m-md-a-5 { margin: $globalSpacingXSmall ;}\n\n  .m-md-l-0 { margin-left: 0;}\n  .m-md-r-0 { margin-right: 0; }\n  .m-md-t-0 { margin-top: 0; }\n  .m-md-b-0 { margin-bottom: 0; }\n  .m-md-a-0 { margin: 0;}\n\n}\n\n@media screen and (min-width: $screen-lg-min){\n  .m-lg-t-50 { margin-top: $globalSpacingXXL ; }\n  .m-lg-b-50 { margin-bottom: $globalSpacingXXL ; }\n  .m-lg-l-50 { margin-left: $globalSpacingXXL ; }\n  .m-lg-r-50 { margin-right: $globalSpacingXXL ; }\n  .m-lg-a-50 { margin: $globalSpacingXXL ;}\n\n  .m-lg-l-35 { margin-left: $globalSpacingXL ; }\n  .m-lg-r-35 { margin-right: $globalSpacingXL ; }\n  .m-lg-t-35 { margin-top: $globalSpacingXL ; }\n  .m-lg-b-35 { margin-bottom: $globalSpacingXL ; }\n  .m-lg-a-35 { margin: $globalSpacingXL ;}\n\n  .m-lg-l-20 { margin-left: $globalSpacingLarge ; }\n  .m-lg-r-20 { margin-right: $globalSpacingLarge ; }\n  .m-lg-t-20 { margin-top: $globalSpacingLarge ; }\n  .m-lg-b-20 { margin-bottom: $globalSpacingLarge ; }\n  .m-lg-a-20 { margin: $globalSpacingLarge ;}\n\n  .m-lg-l-15 { margin-left: $globalSpacingMedium ; }\n  .m-lg-r-15 { margin-right: $globalSpacingMedium ; }\n  .m-lg-t-15 { margin-top: $globalSpacingMedium ; }\n  .m-lg-b-15 { margin-bottom: $globalSpacingMedium ; }\n  .m-lg-a-15 { margin: $globalSpacingMedium ;}\n\n  .m-lg-l-10 { margin-left: $globalSpacingSmall ; }\n  .m-lg-r-10 { margin-right: $globalSpacingSmall ; }\n  .m-lg-t-10 { margin-top: $globalSpacingSmall ; }\n  .m-lg-b-10 { margin-bottom: $globalSpacingSmall ; }\n  .m-lg-a-10 { margin: $globalSpacingSmall ;}\n\n  .m-lg-l-5 { margin-left: $globalSpacingXSmall ; }\n  .m-lg-r-5 { margin-right: $globalSpacingXSmall ; }\n  .m-lg-t-5 { margin-top: $globalSpacingXSmall ; }\n  .m-lg-b-5 { margin-bottom: $globalSpacingXSmall ; }\n  .m-lg-a-5 { margin: $globalSpacingXSmall ;}\n\n  .m-lg-l-0 { margin-left: 0 ;}\n  .m-lg-r-0 { margin-right: 0 ; }\n  .m-lg-t-0 { margin-top: 0 ; }\n  .m-lg-b-0 { margin-bottom: 0 ; }\n  .m-lg-a-0 { margin: 0 ;}\n}\n","\n/* LOADER */\n.main-loader-wrapper {\n    position: fixed;\n    top: 0;\n    left: 0;\n    background: rgba(255, 255, 255, 0.5);\n    z-index: 99999;\n    display: block;\n    right: 0;\n    bottom: 0;\n    margin: auto;\n\n    \n}\n\n.main-loader-wrapper .loader-image {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n}\n\n\n.hr-loader {\n    text-align: center;\n    width:80px;\n    height:50px;\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    margin: auto;\n}\n\n.hr-loader .hr-loading-title {\n    font-size: 19px;\n}\n\n.hr-loader span {\n        display: inline-block;\n        vertical-align: middle;\n        width: 15px;\n        height: 15px;\n        margin: 25px auto;\n        background: #E8488B;\n        -moz-border-radius: 50px;\n        -moz-animation: hr-loader 0.8s infinite alternate;\n        -webkit-border-radius: 50px;\n        -webkit-animation: hr-loader 0.8s infinite alternate;\n        -ms-border-radius: 50px;\n        -ms-animation: hr-loader 0.8s infinite alternate;\n        -o-border-radius: 50px;\n        -o-animation: hr-loader 0.8s infinite alternate;\n        border-radius: 50px;\n        animation: hr-loader 0.8s infinite alternate;\n}\n\n#hr_bubbling_1 {\n    -moz-animation-delay: 0s;\n    -webkit-animation-delay: 0s;\n    -ms-animation-delay: 0s;\n    -o-animation-delay: 0s;\n    animation-delay: 0s;\n    }\n\n#hr_bubbling_2 {\n    -moz-animation-delay: 0.24s;\n    -webkit-animation-delay: 0.24s;\n    -ms-animation-delay: 0.24s;\n    -o-animation-delay: 0.24s;\n    animation-delay: 0.24s;\n    }\n\n#hr_bubbling_3 {\n    -moz-animation-delay: 0.48s;\n    -webkit-animation-delay: 0.48s;\n    -ms-animation-delay: 0.48s;\n    -o-animation-delay: 0.48s;\n    animation-delay: 0.48s;\n    }\n\n@-moz-keyframes hr-loader {\n    0% {\n    width: 10px;\n    height: 10px;\n    background-color:#E8488B;\n    -moz-transform: translateY(0);\n    }\n\n    100% {\n    width: 24px;\n    height: 24px;\n    background-color:#D10F63;\n    -moz-transform: translateY(-21px);\n    }\n\n}\n\n@-webkit-keyframes hr-loader {\n    0% {\n    width: 10px;\n    height: 10px;\n    background-color:#E8488B;\n    -webkit-transform: translateY(0);\n    }\n\n    100% {\n    width: 24px;\n    height: 24px;\n    background-color:#D10F63;\n    -webkit-transform: translateY(-21px);\n    }\n\n}\n\n@-ms-keyframes hr-loader {\n    0% {\n    width: 10px;\n    height: 10px;\n    background-color:#E8488B;\n    -ms-transform: translateY(0);\n    }\n\n    100% {\n    width: 24px;\n    height: 24px;\n    background-color:#D10F63;\n    -ms-transform: translateY(-21px);\n    }\n\n}\n\n@-o-keyframes hr-loader {\n    0% {\n    width: 10px;\n    height: 10px;\n    background-color:#E8488B;\n    -o-transform: translateY(0);\n    }\n\n    100% {\n    width: 24px;\n    height: 24px;\n    background-color:#D10F63;\n    -o-transform: translateY(-21px);\n    }\n\n}\n\n@keyframes hr-loader {\n    0% {\n    width: 10px;\n    height: 10px;\n    background-color:#E8488B;\n    transform: translateY(0);\n    }\n\n    100% {\n    width: 24px;\n    height: 24px;\n    background-color:#D10F63;\n    transform: translateY(-21px);\n    }\n\n}","@import 'variables.scss';\n  \n  // Text Colors\n  .text-black {color: $black;}\n  .text-white {color: $white;}\n  .text-white-smoke {color: $whiteSmoke;}\n  .text-magenta, .text-brand-magenta, .text-primary {color: $brandMagenta;}\n  .text-dark-magenta {color: $darkMagenta;}\n  .text-very-dark-magenta {color: $veryDarkMagenta;}\n  .text-gray {color: $gray;}\n  .text-gray-dark {color: $grayDark;}\n  .text-gray-darker {color: $grayDarker;}\n  .text-gray-light {color: $grayLight;}\n  .text-gray-lighter {color: $grayLighter;}\n  .text-gray-light-1 {color: $grayLight-1;}\n  .text-gray-light-2 {color: $grayLight-2;}\n  .text-green-true {color: $greenTrue;}\n  .text-green-light {color: $greenlight;}\n  .text-green-medium {color: $greenMedium;}\n  .text-green {color: $green;}\n  .text-red, .text-error {color: $red;}\n  .text-pinkish-red {color: $pinkishRed;}\n  .text-squash {color: $squash;}\n  .text-bright-yellow {color: $brightYellow;}\n  \n  \n  // Background Colors\n  .bg-black {background-color: $black;}\n  .bg-white {background-color: $white;}\n  .bg-white-smoke {background-color: $whiteSmoke;}\n  .bg-magenta, .bg-brand-magenta {background-color: $brandMagenta;}\n  .bg-dark-magenta {background-color: $darkMagenta;}\n  .bg-very-dark-magenta {background-color: $veryDarkMagenta;}\n  .bg-gray {background-color: $gray;}\n  .bg-gray-dark {background-color: $grayDark;}\n  .bg-gray-darker {background-color: $grayDarker;}\n  .bg-gray-light {background-color: $grayLight;}\n  .bg-gray-lighter {background-color: $grayLighter;}\n  .bg-gray-light-1 {background-color: $grayLight-1;}\n  .bg-gray-light-2 {background-color: $grayLight-2;}\n  .bg-green-true {background-color: $greenTrue;}\n  .bg-green-light {background-color: $greenlight;}\n  .bg-green-medium {background-color: $greenMedium;}\n  .bg-green {background-color: $green;}\n  .bg-red {background-color: $red;}\n  .bg-pinkish-red {background-color: $pinkishRed;}\n  .bg-squash {background-color: $squash;}\n  .bg-bright-yellow {background-color: $brightYellow;}\n  .bg-cart {background-color: $cartBackground;}\n  .bg-cart-boxes {background-color: $cartBoxes;}\n  \n  // Font Weight\n  .text-bold {font-family: Tele-Ult, sans-serif;}\n  .paragraph-bold {font-family: Arial-Bold, sans-serif;}\n  .text-strike-through {text-decoration: line-through;}\n  .font-bold { font-weight : bold }\n  \n  // Font Sizing\n  .lead {\n    font-size: 18px;\n    line-height: 22px;\n  \n    @include break-max($mobileMax){\n      font-size: 1.6rem;\n    }\n  }\n  \n  .regular {\n    font-size: 16px;\n    line-height: 19px;\n  \n    @include break-max($mobileMax){\n      font-size: 14px;\n      line-height: 17px;\n    }\n  }\n  \n  .small {\n    font-size: 14px;\n    line-height: 17px;\n    font-family: ArialMT;\n  \n    @include break-max($mobileMax){\n      font-size: 12px;\n      line-height: 15px;\n    }\n  }\n  \n  .xsmall {\n    font-size: 12px;\n    line-height: 15px;\n  \n    @include break-max($mobileMax){\n      font-size: 11px;\n      line-height: 13px;\n    }\n  }\n  \n  .legal {\n    font-size: 10px;\n    line-height: 12px;\n    font-family: ArialMT;\n  }\n  \n\n  ","//display and visibility\n\n.display-none {\n    display: none !important;\n  }\n  \n  .display-block, .block {\n    display: block !important;\n  }\n  \n  .display-inline {\n    display: inline !important;\n  }\n  \n  .display-flex {\n    display: flex !important;\n  }\n  \n  .display-inline-block, .inline, .inline-block {\n    display: inline-block !important;\n  }\n  \n  .display-inline-flex, .inline-flex {\n    display: inline-flex !important;\n  }\n  \n  .hidden {\n    visibility: hidden !important;\n  }\n  \n  .overflow-hidden {\n    overflow: hidden !important;\n  }\n  \n  .overflow-auto {\n    overflow: auto !important;\n  }\n  \n  .overflow-visible {\n    overflow: visible !important;\n  }\n  \n  @media (max-width:$mobileMax) {\n    .display-none-xs {\n      display: none !important;\n    }\n  }\n  \n  @media (min-width:$device-min-sm) {\n    .display-none-sm {\n      display: none !important;\n    }\n  }\n  \n  @media (min-width:$device-min-md) {\n    .display-none-md {\n      display: none !important;\n    }\n  }\n  @media (max-width:$device-max-md) {\n    .display-none-max-md {\n      display: none !important;\n    }\n  }\n  \n  @media (min-width:$device-min-lg) {\n    .display-none-lg {\n      display: none !important;\n    }\n  }\n  \n  @media (max-width:$device-max-sm) {\n    .display-none-max-sm {\n      display: none !important;\n    }\n  }\n  \n  @media (max-width:$device-max-md) {\n    .display-none-max-md {\n      display: none !important;\n    }\n  }\n  \n  .display-none-pseudo:before,\n  .display-none-pseudo:after {\n    display: none !important\n  }\n  \n  .display-none-pseudo-before:before {\n    display: none !important\n  }\n  \n  .display-none-pseudo-after:after {\n    display: none !important\n  }\n  \n  @media (max-width:$mobileMax) {\n    .display-inline-xs {\n      display: inline !important;\n    }\n  }\n  \n  @media (max-width:$mobileMax) {\n    .display-block-xs {\n      display: block !important;\n    }\n  }\n  \n  .word-wrap {\n    word-wrap: break-word;\n  }\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
